(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.farmOS = {}));
})(this, (function (exports) { 'use strict';

  function _isPlaceholder$4(a) {
    return a != null && typeof a === 'object' && a['@@functional/placeholder'] === true;
  }

  var _isPlaceholder_1 = _isPlaceholder$4;

  var _isPlaceholder$3 =

  _isPlaceholder_1;
  /**
   * Optimized internal one-arity curry function.
   *
   * @private
   * @category Function
   * @param {Function} fn The function to curry.
   * @return {Function} The curried function.
   */


  function _curry1$l(fn) {
    return function f1(a) {
      if (arguments.length === 0 || _isPlaceholder$3(a)) {
        return f1;
      } else {
        return fn.apply(this, arguments);
      }
    };
  }

  var _curry1_1 = _curry1$l;

  var _curry1$k =

  _curry1_1;

  var _isPlaceholder$2 =

  _isPlaceholder_1;
  /**
   * Optimized internal two-arity curry function.
   *
   * @private
   * @category Function
   * @param {Function} fn The function to curry.
   * @return {Function} The curried function.
   */


  function _curry2$H(fn) {
    return function f2(a, b) {
      switch (arguments.length) {
        case 0:
          return f2;

        case 1:
          return _isPlaceholder$2(a) ? f2 : _curry1$k(function (_b) {
            return fn(a, _b);
          });

        default:
          return _isPlaceholder$2(a) && _isPlaceholder$2(b) ? f2 : _isPlaceholder$2(a) ? _curry1$k(function (_a) {
            return fn(_a, b);
          }) : _isPlaceholder$2(b) ? _curry1$k(function (_b) {
            return fn(a, _b);
          }) : fn(a, b);
      }
    };
  }

  var _curry2_1 = _curry2$H;

  var _curry2$G =

  _curry2_1;
  /**
   * Returns a partial copy of an object omitting the keys specified.
   *
   * @func
   * @memberOf R
   * @since v0.1.0
   * @category Object
   * @sig [String] -> {String: *} -> {String: *}
   * @param {Array} names an array of String property names to omit from the new object
   * @param {Object} obj The object to copy from
   * @return {Object} A new object with properties from `names` not on it.
   * @see R.pick
   * @example
   *
   *      R.omit(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, c: 3}
   */


  var omit =
  /*#__PURE__*/
  _curry2$G(function omit(names, obj) {
    var result = {};
    var index = {};
    var idx = 0;
    var len = names.length;

    while (idx < len) {
      index[names[idx]] = 1;
      idx += 1;
    }

    for (var prop in obj) {
      if (!index.hasOwnProperty(prop)) {
        result[prop] = obj[prop];
      }
    }

    return result;
  });

  var omit_1 = omit;

  var omit$1 = omit_1;

  function _arity$5(n, fn) {
    /* eslint-disable no-unused-vars */
    switch (n) {
      case 0:
        return function () {
          return fn.apply(this, arguments);
        };

      case 1:
        return function (a0) {
          return fn.apply(this, arguments);
        };

      case 2:
        return function (a0, a1) {
          return fn.apply(this, arguments);
        };

      case 3:
        return function (a0, a1, a2) {
          return fn.apply(this, arguments);
        };

      case 4:
        return function (a0, a1, a2, a3) {
          return fn.apply(this, arguments);
        };

      case 5:
        return function (a0, a1, a2, a3, a4) {
          return fn.apply(this, arguments);
        };

      case 6:
        return function (a0, a1, a2, a3, a4, a5) {
          return fn.apply(this, arguments);
        };

      case 7:
        return function (a0, a1, a2, a3, a4, a5, a6) {
          return fn.apply(this, arguments);
        };

      case 8:
        return function (a0, a1, a2, a3, a4, a5, a6, a7) {
          return fn.apply(this, arguments);
        };

      case 9:
        return function (a0, a1, a2, a3, a4, a5, a6, a7, a8) {
          return fn.apply(this, arguments);
        };

      case 10:
        return function (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
          return fn.apply(this, arguments);
        };

      default:
        throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
    }
  }

  var _arity_1 = _arity$5;

  function _pipe$1(f, g) {
    return function () {
      return g.call(this, f.apply(this, arguments));
    };
  }

  var _pipe_1 = _pipe$1;

  var _curry1$j =

  _curry1_1;

  var _curry2$F =

  _curry2_1;

  var _isPlaceholder$1 =

  _isPlaceholder_1;
  /**
   * Optimized internal three-arity curry function.
   *
   * @private
   * @category Function
   * @param {Function} fn The function to curry.
   * @return {Function} The curried function.
   */


  function _curry3$9(fn) {
    return function f3(a, b, c) {
      switch (arguments.length) {
        case 0:
          return f3;

        case 1:
          return _isPlaceholder$1(a) ? f3 : _curry2$F(function (_b, _c) {
            return fn(a, _b, _c);
          });

        case 2:
          return _isPlaceholder$1(a) && _isPlaceholder$1(b) ? f3 : _isPlaceholder$1(a) ? _curry2$F(function (_a, _c) {
            return fn(_a, b, _c);
          }) : _isPlaceholder$1(b) ? _curry2$F(function (_b, _c) {
            return fn(a, _b, _c);
          }) : _curry1$j(function (_c) {
            return fn(a, b, _c);
          });

        default:
          return _isPlaceholder$1(a) && _isPlaceholder$1(b) && _isPlaceholder$1(c) ? f3 : _isPlaceholder$1(a) && _isPlaceholder$1(b) ? _curry2$F(function (_a, _b) {
            return fn(_a, _b, c);
          }) : _isPlaceholder$1(a) && _isPlaceholder$1(c) ? _curry2$F(function (_a, _c) {
            return fn(_a, b, _c);
          }) : _isPlaceholder$1(b) && _isPlaceholder$1(c) ? _curry2$F(function (_b, _c) {
            return fn(a, _b, _c);
          }) : _isPlaceholder$1(a) ? _curry1$j(function (_a) {
            return fn(_a, b, c);
          }) : _isPlaceholder$1(b) ? _curry1$j(function (_b) {
            return fn(a, _b, c);
          }) : _isPlaceholder$1(c) ? _curry1$j(function (_c) {
            return fn(a, b, _c);
          }) : fn(a, b, c);
      }
    };
  }

  var _curry3_1 = _curry3$9;

  /**
   * Tests whether or not an object is an array.
   *
   * @private
   * @param {*} val The object to test.
   * @return {Boolean} `true` if `val` is an array, `false` otherwise.
   * @example
   *
   *      _isArray([]); //=> true
   *      _isArray(null); //=> false
   *      _isArray({}); //=> false
   */

  var _isArray$5 = Array.isArray || function _isArray(val) {
    return val != null && val.length >= 0 && Object.prototype.toString.call(val) === '[object Array]';
  };

  function _isString$5(x) {
    return Object.prototype.toString.call(x) === '[object String]';
  }

  var _isString_1 = _isString$5;

  var _curry1$i =

  _curry1_1;

  var _isArray$4 =

  _isArray$5;

  var _isString$4 =

  _isString_1;
  /**
   * Tests whether or not an object is similar to an array.
   *
   * @private
   * @category Type
   * @category List
   * @sig * -> Boolean
   * @param {*} x The object to test.
   * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
   * @example
   *
   *      _isArrayLike([]); //=> true
   *      _isArrayLike(true); //=> false
   *      _isArrayLike({}); //=> false
   *      _isArrayLike({length: 10}); //=> false
   *      _isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
   */


  var _isArrayLike$3 =
  /*#__PURE__*/
  _curry1$i(function isArrayLike(x) {
    if (_isArray$4(x)) {
      return true;
    }

    if (!x) {
      return false;
    }

    if (typeof x !== 'object') {
      return false;
    }

    if (_isString$4(x)) {
      return false;
    }

    if (x.nodeType === 1) {
      return !!x.length;
    }

    if (x.length === 0) {
      return true;
    }

    if (x.length > 0) {
      return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
    }

    return false;
  });

  var _isArrayLike_1 = _isArrayLike$3;

  var XWrap =
  /*#__PURE__*/
  function () {
    function XWrap(fn) {
      this.f = fn;
    }

    XWrap.prototype['@@transducer/init'] = function () {
      throw new Error('init not implemented on XWrap');
    };

    XWrap.prototype['@@transducer/result'] = function (acc) {
      return acc;
    };

    XWrap.prototype['@@transducer/step'] = function (acc, x) {
      return this.f(acc, x);
    };

    return XWrap;
  }();

  function _xwrap$1(fn) {
    return new XWrap(fn);
  }

  var _xwrap_1 = _xwrap$1;

  var _arity$4 =

  _arity_1;

  var _curry2$E =

  _curry2_1;
  /**
   * Creates a function that is bound to a context.
   * Note: `R.bind` does not provide the additional argument-binding capabilities of
   * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
   *
   * @func
   * @memberOf R
   * @since v0.6.0
   * @category Function
   * @category Object
   * @sig (* -> *) -> {*} -> (* -> *)
   * @param {Function} fn The function to bind to context
   * @param {Object} thisObj The context to bind `fn` to
   * @return {Function} A function that will execute in the context of `thisObj`.
   * @see R.partial
   * @example
   *
   *      const log = R.bind(console.log, console);
   *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
   *      // logs {a: 2}
   * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
   */


  var bind$4 =
  /*#__PURE__*/
  _curry2$E(function bind(fn, thisObj) {
    return _arity$4(fn.length, function () {
      return fn.apply(thisObj, arguments);
    });
  });

  var bind_1 = bind$4;

  var _isArrayLike$2 =

  _isArrayLike_1;

  var _xwrap =

  _xwrap_1;

  var bind$3 =

  bind_1;

  function _arrayReduce(xf, acc, list) {
    var idx = 0;
    var len = list.length;

    while (idx < len) {
      acc = xf['@@transducer/step'](acc, list[idx]);

      if (acc && acc['@@transducer/reduced']) {
        acc = acc['@@transducer/value'];
        break;
      }

      idx += 1;
    }

    return xf['@@transducer/result'](acc);
  }

  function _iterableReduce(xf, acc, iter) {
    var step = iter.next();

    while (!step.done) {
      acc = xf['@@transducer/step'](acc, step.value);

      if (acc && acc['@@transducer/reduced']) {
        acc = acc['@@transducer/value'];
        break;
      }

      step = iter.next();
    }

    return xf['@@transducer/result'](acc);
  }

  function _methodReduce(xf, acc, obj, methodName) {
    return xf['@@transducer/result'](obj[methodName](bind$3(xf['@@transducer/step'], xf), acc));
  }

  var symIterator = typeof Symbol !== 'undefined' ? Symbol.iterator : '@@iterator';

  function _reduce$5(fn, acc, list) {
    if (typeof fn === 'function') {
      fn = _xwrap(fn);
    }

    if (_isArrayLike$2(list)) {
      return _arrayReduce(fn, acc, list);
    }

    if (typeof list['fantasy-land/reduce'] === 'function') {
      return _methodReduce(fn, acc, list, 'fantasy-land/reduce');
    }

    if (list[symIterator] != null) {
      return _iterableReduce(fn, acc, list[symIterator]());
    }

    if (typeof list.next === 'function') {
      return _iterableReduce(fn, acc, list);
    }

    if (typeof list.reduce === 'function') {
      return _methodReduce(fn, acc, list, 'reduce');
    }

    throw new TypeError('reduce: list must be array or iterable');
  }

  var _reduce_1 = _reduce$5;

  var _curry3$8 =

  _curry3_1;

  var _reduce$4 =

  _reduce_1;
  /**
   * Returns a single item by iterating through the list, successively calling
   * the iterator function and passing it an accumulator value and the current
   * value from the array, and then passing the result to the next call.
   *
   * The iterator function receives two values: *(acc, value)*. It may use
   * [`R.reduced`](#reduced) to shortcut the iteration.
   *
   * The arguments' order of [`reduceRight`](#reduceRight)'s iterator function
   * is *(value, acc)*.
   *
   * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
   * arrays), unlike the native `Array.prototype.reduce` method. For more details
   * on this behavior, see:
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
   *
   * Dispatches to the `reduce` method of the third argument, if present. When
   * doing so, it is up to the user to handle the [`R.reduced`](#reduced)
   * shortcuting, as this is not implemented by `reduce`.
   *
   * @func
   * @memberOf R
   * @since v0.1.0
   * @category List
   * @sig ((a, b) -> a) -> a -> [b] -> a
   * @param {Function} fn The iterator function. Receives two values, the accumulator and the
   *        current element from the array.
   * @param {*} acc The accumulator value.
   * @param {Array} list The list to iterate over.
   * @return {*} The final, accumulated value.
   * @see R.reduced, R.addIndex, R.reduceRight
   * @example
   *
   *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
   *      //          -               -10
   *      //         / \              / \
   *      //        -   4           -6   4
   *      //       / \              / \
   *      //      -   3   ==>     -3   3
   *      //     / \              / \
   *      //    -   2           -1   2
   *      //   / \              / \
   *      //  0   1            0   1
   *
   * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
   */


  var reduce$5 =
  /*#__PURE__*/
  _curry3$8(_reduce$4);

  var reduce_1 = reduce$5;

  var reduce$6 = reduce_1;

  var _isArray$3 =

  _isArray$5;
  /**
   * This checks whether a function has a [methodname] function. If it isn't an
   * array it will execute that function otherwise it will default to the ramda
   * implementation.
   *
   * @private
   * @param {Function} fn ramda implemtation
   * @param {String} methodname property to check for a custom implementation
   * @return {Object} Whatever the return value of the method is.
   */


  function _checkForMethod$2(methodname, fn) {
    return function () {
      var length = arguments.length;

      if (length === 0) {
        return fn();
      }

      var obj = arguments[length - 1];
      return _isArray$3(obj) || typeof obj[methodname] !== 'function' ? fn.apply(this, arguments) : obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
    };
  }

  var _checkForMethod_1 = _checkForMethod$2;

  var _checkForMethod$1 =

  _checkForMethod_1;

  var _curry3$7 =

  _curry3_1;
  /**
   * Returns the elements of the given list or string (or object with a `slice`
   * method) from `fromIndex` (inclusive) to `toIndex` (exclusive).
   *
   * Dispatches to the `slice` method of the third argument, if present.
   *
   * @func
   * @memberOf R
   * @since v0.1.4
   * @category List
   * @sig Number -> Number -> [a] -> [a]
   * @sig Number -> Number -> String -> String
   * @param {Number} fromIndex The start index (inclusive).
   * @param {Number} toIndex The end index (exclusive).
   * @param {*} list
   * @return {*}
   * @example
   *
   *      R.slice(1, 3, ['a', 'b', 'c', 'd']);        //=> ['b', 'c']
   *      R.slice(1, Infinity, ['a', 'b', 'c', 'd']); //=> ['b', 'c', 'd']
   *      R.slice(0, -1, ['a', 'b', 'c', 'd']);       //=> ['a', 'b', 'c']
   *      R.slice(-3, -1, ['a', 'b', 'c', 'd']);      //=> ['b', 'c']
   *      R.slice(0, 3, 'ramda');                     //=> 'ram'
   */


  var slice$2 =
  /*#__PURE__*/
  _curry3$7(
  /*#__PURE__*/
  _checkForMethod$1('slice', function slice(fromIndex, toIndex, list) {
    return Array.prototype.slice.call(list, fromIndex, toIndex);
  }));

  var slice_1 = slice$2;

  var _checkForMethod =

  _checkForMethod_1;

  var _curry1$h =

  _curry1_1;

  var slice$1 =

  slice_1;
  /**
   * Returns all but the first element of the given list or string (or object
   * with a `tail` method).
   *
   * Dispatches to the `slice` method of the first argument, if present.
   *
   * @func
   * @memberOf R
   * @since v0.1.0
   * @category List
   * @sig [a] -> [a]
   * @sig String -> String
   * @param {*} list
   * @return {*}
   * @see R.head, R.init, R.last
   * @example
   *
   *      R.tail([1, 2, 3]);  //=> [2, 3]
   *      R.tail([1, 2]);     //=> [2]
   *      R.tail([1]);        //=> []
   *      R.tail([]);         //=> []
   *
   *      R.tail('abc');  //=> 'bc'
   *      R.tail('ab');   //=> 'b'
   *      R.tail('a');    //=> ''
   *      R.tail('');     //=> ''
   */


  var tail$1 =
  /*#__PURE__*/
  _curry1$h(
  /*#__PURE__*/
  _checkForMethod('tail',
  /*#__PURE__*/
  slice$1(1, Infinity)));

  var tail_1 = tail$1;

  var _arity$3 =

  _arity_1;

  var _pipe =

  _pipe_1;

  var reduce$4 =

  reduce_1;

  var tail =

  tail_1;
  /**
   * Performs left-to-right function composition. The first argument may have
   * any arity; the remaining arguments must be unary.
   *
   * In some libraries this function is named `sequence`.
   *
   * **Note:** The result of pipe is not automatically curried.
   *
   * @func
   * @memberOf R
   * @since v0.1.0
   * @category Function
   * @sig (((a, b, ..., n) -> o), (o -> p), ..., (x -> y), (y -> z)) -> ((a, b, ..., n) -> z)
   * @param {...Function} functions
   * @return {Function}
   * @see R.compose
   * @example
   *
   *      const f = R.pipe(Math.pow, R.negate, R.inc);
   *
   *      f(3, 4); // -(3^4) + 1
   * @symb R.pipe(f, g, h)(a, b) = h(g(f(a, b)))
   */


  function pipe$1() {
    if (arguments.length === 0) {
      throw new Error('pipe requires at least one argument');
    }

    return _arity$3(arguments[0].length, reduce$4(_pipe, arguments[0], tail(arguments)));
  }

  var pipe_1 = pipe$1;

  var _curry1$g =

  _curry1_1;

  var _isString$3 =

  _isString_1;
  /**
   * Returns a new list or string with the elements or characters in reverse
   * order.
   *
   * @func
   * @memberOf R
   * @since v0.1.0
   * @category List
   * @sig [a] -> [a]
   * @sig String -> String
   * @param {Array|String} list
   * @return {Array|String}
   * @example
   *
   *      R.reverse([1, 2, 3]);  //=> [3, 2, 1]
   *      R.reverse([1, 2]);     //=> [2, 1]
   *      R.reverse([1]);        //=> [1]
   *      R.reverse([]);         //=> []
   *
   *      R.reverse('abc');      //=> 'cba'
   *      R.reverse('ab');       //=> 'ba'
   *      R.reverse('a');        //=> 'a'
   *      R.reverse('');         //=> ''
   */


  var reverse$1 =
  /*#__PURE__*/
  _curry1$g(function reverse(list) {
    return _isString$3(list) ? list.split('').reverse().join('') : Array.prototype.slice.call(list, 0).reverse();
  });

  var reverse_1 = reverse$1;

  var pipe =

  pipe_1;

  var reverse =

  reverse_1;
  /**
   * Performs right-to-left function composition. The last argument may have
   * any arity; the remaining arguments must be unary.
   *
   * **Note:** The result of compose is not automatically curried.
   *
   * @func
   * @memberOf R
   * @since v0.1.0
   * @category Function
   * @sig ((y -> z), (x -> y), ..., (o -> p), ((a, b, ..., n) -> o)) -> ((a, b, ..., n) -> z)
   * @param {...Function} ...functions The functions to compose
   * @return {Function}
   * @see R.pipe
   * @example
   *
   *      const classyGreeting = (firstName, lastName) => "The name's " + lastName + ", " + firstName + " " + lastName
   *      const yellGreeting = R.compose(R.toUpper, classyGreeting);
   *      yellGreeting('James', 'Bond'); //=> "THE NAME'S BOND, JAMES BOND"
   *
   *      R.compose(Math.abs, R.add(1), R.multiply(2))(-4) //=> 7
   *
   * @symb R.compose(f, g, h)(a, b) = f(g(h(a, b)))
   */


  function compose() {
    if (arguments.length === 0) {
      throw new Error('compose requires at least one argument');
    }

    return pipe.apply(this, reverse(arguments));
  }

  var compose_1 = compose;

  var compose$1 = compose_1;

  function _isTransformer$1(obj) {
    return obj != null && typeof obj['@@transducer/step'] === 'function';
  }

  var _isTransformer_1 = _isTransformer$1;

  var _isArray$2 =

  _isArray$5;

  var _isTransformer =

  _isTransformer_1;
  /**
   * Returns a function that dispatches with different strategies based on the
   * object in list position (last argument). If it is an array, executes [fn].
   * Otherwise, if it has a function with one of the given method names, it will
   * execute that function (functor case). Otherwise, if it is a transformer,
   * uses transducer [xf] to return a new transformer (transducer case).
   * Otherwise, it will default to executing [fn].
   *
   * @private
   * @param {Array} methodNames properties to check for a custom implementation
   * @param {Function} xf transducer to initialize if object is transformer
   * @param {Function} fn default ramda implementation
   * @return {Function} A function that dispatches on object in list position
   */


  function _dispatchable$6(methodNames, xf, fn) {
    return function () {
      if (arguments.length === 0) {
        return fn();
      }

      var args = Array.prototype.slice.call(arguments, 0);
      var obj = args.pop();

      if (!_isArray$2(obj)) {
        var idx = 0;

        while (idx < methodNames.length) {
          if (typeof obj[methodNames[idx]] === 'function') {
            return obj[methodNames[idx]].apply(obj, args);
          }

          idx += 1;
        }

        if (_isTransformer(obj)) {
          var transducer = xf.apply(null, args);
          return transducer(obj);
        }
      }

      return fn.apply(this, arguments);
    };
  }

  var _dispatchable_1 = _dispatchable$6;

  function _filter$1(fn, list) {
    var idx = 0;
    var len = list.length;
    var result = [];

    while (idx < len) {
      if (fn(list[idx])) {
        result[result.length] = list[idx];
      }

      idx += 1;
    }

    return result;
  }

  var _filter_1 = _filter$1;

  function _isObject$3(x) {
    return Object.prototype.toString.call(x) === '[object Object]';
  }

  var _isObject_1 = _isObject$3;

  var _xfBase$6 = {
    init: function () {
      return this.xf['@@transducer/init']();
    },
    result: function (result) {
      return this.xf['@@transducer/result'](result);
    }
  };

  var _curry2$D =

  _curry2_1;

  var _xfBase$5 =

  _xfBase$6;

  var XFilter =
  /*#__PURE__*/
  function () {
    function XFilter(f, xf) {
      this.xf = xf;
      this.f = f;
    }

    XFilter.prototype['@@transducer/init'] = _xfBase$5.init;
    XFilter.prototype['@@transducer/result'] = _xfBase$5.result;

    XFilter.prototype['@@transducer/step'] = function (result, input) {
      return this.f(input) ? this.xf['@@transducer/step'](result, input) : result;
    };

    return XFilter;
  }();

  var _xfilter$1 =
  /*#__PURE__*/
  _curry2$D(function _xfilter(f, xf) {
    return new XFilter(f, xf);
  });

  var _xfilter_1 = _xfilter$1;

  function _has$6(prop, obj) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
  }

  var _has_1 = _has$6;

  var _has$5 =

  _has_1;

  var toString$4 = Object.prototype.toString;

  var _isArguments$2 =
  /*#__PURE__*/
  function () {
    return toString$4.call(arguments) === '[object Arguments]' ? function _isArguments(x) {
      return toString$4.call(x) === '[object Arguments]';
    } : function _isArguments(x) {
      return _has$5('callee', x);
    };
  }();

  var _isArguments_1 = _isArguments$2;

  var _curry1$f =

  _curry1_1;

  var _has$4 =

  _has_1;

  var _isArguments$1 =

  _isArguments_1; // cover IE < 9 keys issues


  var hasEnumBug = !
  /*#__PURE__*/
  {
    toString: null
  }.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['constructor', 'valueOf', 'isPrototypeOf', 'toString', 'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString']; // Safari bug

  var hasArgsEnumBug =
  /*#__PURE__*/
  function () {

    return arguments.propertyIsEnumerable('length');
  }();

  var contains = function contains(list, item) {
    var idx = 0;

    while (idx < list.length) {
      if (list[idx] === item) {
        return true;
      }

      idx += 1;
    }

    return false;
  };
  /**
   * Returns a list containing the names of all the enumerable own properties of
   * the supplied object.
   * Note that the order of the output array is not guaranteed to be consistent
   * across different JS platforms.
   *
   * @func
   * @memberOf R
   * @since v0.1.0
   * @category Object
   * @sig {k: v} -> [k]
   * @param {Object} obj The object to extract properties from
   * @return {Array} An array of the object's own properties.
   * @see R.keysIn, R.values
   * @example
   *
   *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
   */


  var keys$5 = typeof Object.keys === 'function' && !hasArgsEnumBug ?
  /*#__PURE__*/
  _curry1$f(function keys(obj) {
    return Object(obj) !== obj ? [] : Object.keys(obj);
  }) :
  /*#__PURE__*/
  _curry1$f(function keys(obj) {
    if (Object(obj) !== obj) {
      return [];
    }

    var prop, nIdx;
    var ks = [];

    var checkArgsLength = hasArgsEnumBug && _isArguments$1(obj);

    for (prop in obj) {
      if (_has$4(prop, obj) && (!checkArgsLength || prop !== 'length')) {
        ks[ks.length] = prop;
      }
    }

    if (hasEnumBug) {
      nIdx = nonEnumerableProps.length - 1;

      while (nIdx >= 0) {
        prop = nonEnumerableProps[nIdx];

        if (_has$4(prop, obj) && !contains(ks, prop)) {
          ks[ks.length] = prop;
        }

        nIdx -= 1;
      }
    }

    return ks;
  });
  var keys_1 = keys$5;

  var _curry2$C =

  _curry2_1;

  var _dispatchable$5 =

  _dispatchable_1;

  var _filter =

  _filter_1;

  var _isObject$2 =

  _isObject_1;

  var _reduce$3 =

  _reduce_1;

  var _xfilter =

  _xfilter_1;

  var keys$4 =

  keys_1;
  /**
   * Takes a predicate and a `Filterable`, and returns a new filterable of the
   * same type containing the members of the given filterable which satisfy the
   * given predicate. Filterable objects include plain objects or any object
   * that has a filter method such as `Array`.
   *
   * Dispatches to the `filter` method of the second argument, if present.
   *
   * Acts as a transducer if a transformer is given in list position.
   *
   * @func
   * @memberOf R
   * @since v0.1.0
   * @category List
   * @sig Filterable f => (a -> Boolean) -> f a -> f a
   * @param {Function} pred
   * @param {Array} filterable
   * @return {Array} Filterable
   * @see R.reject, R.transduce, R.addIndex
   * @example
   *
   *      const isEven = n => n % 2 === 0;
   *
   *      R.filter(isEven, [1, 2, 3, 4]); //=> [2, 4]
   *
   *      R.filter(isEven, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
   */


  var filter$2 =
  /*#__PURE__*/
  _curry2$C(
  /*#__PURE__*/
  _dispatchable$5(['filter'], _xfilter, function (pred, filterable) {
    return _isObject$2(filterable) ? _reduce$3(function (acc, key) {
      if (pred(filterable[key])) {
        acc[key] = filterable[key];
      }

      return acc;
    }, {}, keys$4(filterable)) : // else
    _filter(pred, filterable);
  }));

  var filter_1 = filter$2;

  var rFilter = filter_1;

  var _curry2$B =

  _curry2_1;
  /**
   * See if an object (`val`) is an instance of the supplied constructor. This
   * function will check up the inheritance chain, if any.
   *
   * @func
   * @memberOf R
   * @since v0.3.0
   * @category Type
   * @sig (* -> {*}) -> a -> Boolean
   * @param {Object} ctor A constructor
   * @param {*} val The value to test
   * @return {Boolean}
   * @example
   *
   *      R.is(Object, {}); //=> true
   *      R.is(Number, 1); //=> true
   *      R.is(Object, 1); //=> false
   *      R.is(String, 's'); //=> true
   *      R.is(String, new String('')); //=> true
   *      R.is(Object, new String('')); //=> true
   *      R.is(Object, 's'); //=> false
   *      R.is(Number, {}); //=> false
   */


  var is =
  /*#__PURE__*/
  _curry2$B(function is(Ctor, val) {
    return val != null && val.constructor === Ctor || val instanceof Ctor;
  });

  var is_1 = is;

  var is$1 = is_1;

  function _map$3(fn, functor) {
    var idx = 0;
    var len = functor.length;
    var result = Array(len);

    while (idx < len) {
      result[idx] = fn(functor[idx]);
      idx += 1;
    }

    return result;
  }

  var _map_1 = _map$3;

  var _curry2$A =

  _curry2_1;

  var _xfBase$4 =

  _xfBase$6;

  var XMap =
  /*#__PURE__*/
  function () {
    function XMap(f, xf) {
      this.xf = xf;
      this.f = f;
    }

    XMap.prototype['@@transducer/init'] = _xfBase$4.init;
    XMap.prototype['@@transducer/result'] = _xfBase$4.result;

    XMap.prototype['@@transducer/step'] = function (result, input) {
      return this.xf['@@transducer/step'](result, this.f(input));
    };

    return XMap;
  }();

  var _xmap$1 =
  /*#__PURE__*/
  _curry2$A(function _xmap(f, xf) {
    return new XMap(f, xf);
  });

  var _xmap_1 = _xmap$1;

  var _arity$2 =

  _arity_1;

  var _isPlaceholder =

  _isPlaceholder_1;
  /**
   * Internal curryN function.
   *
   * @private
   * @category Function
   * @param {Number} length The arity of the curried function.
   * @param {Array} received An array of arguments received thus far.
   * @param {Function} fn The function to curry.
   * @return {Function} The curried function.
   */


  function _curryN$1(length, received, fn) {
    return function () {
      var combined = [];
      var argsIdx = 0;
      var left = length;
      var combinedIdx = 0;

      while (combinedIdx < received.length || argsIdx < arguments.length) {
        var result;

        if (combinedIdx < received.length && (!_isPlaceholder(received[combinedIdx]) || argsIdx >= arguments.length)) {
          result = received[combinedIdx];
        } else {
          result = arguments[argsIdx];
          argsIdx += 1;
        }

        combined[combinedIdx] = result;

        if (!_isPlaceholder(result)) {
          left -= 1;
        }

        combinedIdx += 1;
      }

      return left <= 0 ? fn.apply(this, combined) : _arity$2(left, _curryN$1(length, combined, fn));
    };
  }

  var _curryN_1 = _curryN$1;

  var _arity$1 =

  _arity_1;

  var _curry1$e =

  _curry1_1;

  var _curry2$z =

  _curry2_1;

  var _curryN =

  _curryN_1;
  /**
   * Returns a curried equivalent of the provided function, with the specified
   * arity. The curried function has two unusual capabilities. First, its
   * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
   * following are equivalent:
   *
   *   - `g(1)(2)(3)`
   *   - `g(1)(2, 3)`
   *   - `g(1, 2)(3)`
   *   - `g(1, 2, 3)`
   *
   * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
   * "gaps", allowing partial application of any combination of arguments,
   * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
   * the following are equivalent:
   *
   *   - `g(1, 2, 3)`
   *   - `g(_, 2, 3)(1)`
   *   - `g(_, _, 3)(1)(2)`
   *   - `g(_, _, 3)(1, 2)`
   *   - `g(_, 2)(1)(3)`
   *   - `g(_, 2)(1, 3)`
   *   - `g(_, 2)(_, 3)(1)`
   *
   * @func
   * @memberOf R
   * @since v0.5.0
   * @category Function
   * @sig Number -> (* -> a) -> (* -> a)
   * @param {Number} length The arity for the returned function.
   * @param {Function} fn The function to curry.
   * @return {Function} A new, curried function.
   * @see R.curry
   * @example
   *
   *      const sumArgs = (...args) => R.sum(args);
   *
   *      const curriedAddFourNumbers = R.curryN(4, sumArgs);
   *      const f = curriedAddFourNumbers(1, 2);
   *      const g = f(3);
   *      g(4); //=> 10
   */


  var curryN$6 =
  /*#__PURE__*/
  _curry2$z(function curryN(length, fn) {
    if (length === 1) {
      return _curry1$e(fn);
    }

    return _arity$1(length, _curryN(length, [], fn));
  });

  var curryN_1 = curryN$6;

  var curryN$7 = curryN_1;

  var _curry2$y =

  _curry2_1;

  var _dispatchable$4 =

  _dispatchable_1;

  var _map$2 =

  _map_1;

  var _reduce$2 =

  _reduce_1;

  var _xmap =

  _xmap_1;

  var curryN$5 =

  curryN_1;

  var keys$3 =

  keys_1;
  /**
   * Takes a function and
   * a [functor](https://github.com/fantasyland/fantasy-land#functor),
   * applies the function to each of the functor's values, and returns
   * a functor of the same shape.
   *
   * Ramda provides suitable `map` implementations for `Array` and `Object`,
   * so this function may be applied to `[1, 2, 3]` or `{x: 1, y: 2, z: 3}`.
   *
   * Dispatches to the `map` method of the second argument, if present.
   *
   * Acts as a transducer if a transformer is given in list position.
   *
   * Also treats functions as functors and will compose them together.
   *
   * @func
   * @memberOf R
   * @since v0.1.0
   * @category List
   * @sig Functor f => (a -> b) -> f a -> f b
   * @param {Function} fn The function to be called on every element of the input `list`.
   * @param {Array} list The list to be iterated over.
   * @return {Array} The new list.
   * @see R.transduce, R.addIndex
   * @example
   *
   *      const double = x => x * 2;
   *
   *      R.map(double, [1, 2, 3]); //=> [2, 4, 6]
   *
   *      R.map(double, {x: 1, y: 2, z: 3}); //=> {x: 2, y: 4, z: 6}
   * @symb R.map(f, [a, b]) = [f(a), f(b)]
   * @symb R.map(f, { x: a, y: b }) = { x: f(a), y: f(b) }
   * @symb R.map(f, functor_o) = functor_o.map(f)
   */


  var map$4 =
  /*#__PURE__*/
  _curry2$y(
  /*#__PURE__*/
  _dispatchable$4(['fantasy-land/map', 'map'], _xmap, function map(fn, functor) {
    switch (Object.prototype.toString.call(functor)) {
      case '[object Function]':
        return curryN$5(functor.length, function () {
          return fn.call(this, functor.apply(this, arguments));
        });

      case '[object Object]':
        return _reduce$2(function (acc, key) {
          acc[key] = fn(functor[key]);
          return acc;
        }, {}, keys$3(functor));

      default:
        return _map$2(fn, functor);
    }
  }));

  var map_1 = map$4;

  var map$5 = map_1;

  /**
   * Determine if the passed argument is an integer.
   *
   * @private
   * @param {*} n
   * @category Type
   * @return {Boolean}
   */

  var _isInteger$1 = Number.isInteger || function _isInteger(n) {
    return n << 0 === n;
  };

  var _curry2$x =

  _curry2_1;

  var _isString$2 =

  _isString_1;
  /**
   * Returns the nth element of the given list or string. If n is negative the
   * element at index length + n is returned.
   *
   * @func
   * @memberOf R
   * @since v0.1.0
   * @category List
   * @sig Number -> [a] -> a | Undefined
   * @sig Number -> String -> String
   * @param {Number} offset
   * @param {*} list
   * @return {*}
   * @example
   *
   *      const list = ['foo', 'bar', 'baz', 'quux'];
   *      R.nth(1, list); //=> 'bar'
   *      R.nth(-1, list); //=> 'quux'
   *      R.nth(-99, list); //=> undefined
   *
   *      R.nth(2, 'abc'); //=> 'c'
   *      R.nth(3, 'abc'); //=> ''
   * @symb R.nth(-1, [a, b, c]) = c
   * @symb R.nth(0, [a, b, c]) = a
   * @symb R.nth(1, [a, b, c]) = b
   */


  var nth$1 =
  /*#__PURE__*/
  _curry2$x(function nth(offset, list) {
    var idx = offset < 0 ? list.length + offset : offset;
    return _isString$2(list) ? list.charAt(idx) : list[idx];
  });

  var nth_1 = nth$1;

  var _curry2$w =

  _curry2_1;

  var _isInteger =

  _isInteger$1;

  var nth =

  nth_1;
  /**
   * Retrieves the values at given paths of an object.
   *
   * @func
   * @memberOf R
   * @since v0.27.1
   * @category Object
   * @typedefn Idx = [String | Int]
   * @sig [Idx] -> {a} -> [a | Undefined]
   * @param {Array} pathsArray The array of paths to be fetched.
   * @param {Object} obj The object to retrieve the nested properties from.
   * @return {Array} A list consisting of values at paths specified by "pathsArray".
   * @see R.path
   * @example
   *
   *      R.paths([['a', 'b'], ['p', 0, 'q']], {a: {b: 2}, p: [{q: 3}]}); //=> [2, 3]
   *      R.paths([['a', 'b'], ['p', 'r']], {a: {b: 2}, p: [{q: 3}]}); //=> [2, undefined]
   */


  var paths$1 =
  /*#__PURE__*/
  _curry2$w(function paths(pathsArray, obj) {
    return pathsArray.map(function (paths) {
      var val = obj;
      var idx = 0;
      var p;

      while (idx < paths.length) {
        if (val == null) {
          return;
        }

        p = paths[idx];
        val = _isInteger(p) ? nth(p, val) : val[p];
        idx += 1;
      }

      return val;
    });
  });

  var paths_1 = paths$1;

  var _curry2$v =

  _curry2_1;

  var paths =

  paths_1;
  /**
   * Retrieve the value at a given path.
   *
   * @func
   * @memberOf R
   * @since v0.2.0
   * @category Object
   * @typedefn Idx = String | Int
   * @sig [Idx] -> {a} -> a | Undefined
   * @param {Array} path The path to use.
   * @param {Object} obj The object to retrieve the nested property from.
   * @return {*} The data at `path`.
   * @see R.prop, R.nth
   * @example
   *
   *      R.path(['a', 'b'], {a: {b: 2}}); //=> 2
   *      R.path(['a', 'b'], {c: {b: 2}}); //=> undefined
   *      R.path(['a', 'b', 0], {a: {b: [1, 2, 3]}}); //=> 1
   *      R.path(['a', 'b', -2], {a: {b: [1, 2, 3]}}); //=> 2
   */


  var path$1 =
  /*#__PURE__*/
  _curry2$v(function path(pathAr, obj) {
    return paths([pathAr], obj)[0];
  });

  var path_1 = path$1;

  var path$2 = path_1;

  var axios$2 = {exports: {}};

  var bind$2 = function bind(fn, thisArg) {
    return function wrap() {
      var args = new Array(arguments.length);
      for (var i = 0; i < args.length; i++) {
        args[i] = arguments[i];
      }
      return fn.apply(thisArg, args);
    };
  };

  var bind$1 = bind$2;

  // utils is a library of generic helper functions non-specific to axios

  var toString$3 = Object.prototype.toString;

  /**
   * Determine if a value is an Array
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if value is an Array, otherwise false
   */
  function isArray(val) {
    return Array.isArray(val);
  }

  /**
   * Determine if a value is undefined
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if the value is undefined, otherwise false
   */
  function isUndefined(val) {
    return typeof val === 'undefined';
  }

  /**
   * Determine if a value is a Buffer
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if value is a Buffer, otherwise false
   */
  function isBuffer(val) {
    return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
      && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
  }

  /**
   * Determine if a value is an ArrayBuffer
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if value is an ArrayBuffer, otherwise false
   */
  function isArrayBuffer(val) {
    return toString$3.call(val) === '[object ArrayBuffer]';
  }

  /**
   * Determine if a value is a FormData
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if value is an FormData, otherwise false
   */
  function isFormData(val) {
    return toString$3.call(val) === '[object FormData]';
  }

  /**
   * Determine if a value is a view on an ArrayBuffer
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
   */
  function isArrayBufferView(val) {
    var result;
    if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
      result = ArrayBuffer.isView(val);
    } else {
      result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
    }
    return result;
  }

  /**
   * Determine if a value is a String
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if value is a String, otherwise false
   */
  function isString(val) {
    return typeof val === 'string';
  }

  /**
   * Determine if a value is a Number
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if value is a Number, otherwise false
   */
  function isNumber(val) {
    return typeof val === 'number';
  }

  /**
   * Determine if a value is an Object
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if value is an Object, otherwise false
   */
  function isObject$1(val) {
    return val !== null && typeof val === 'object';
  }

  /**
   * Determine if a value is a plain Object
   *
   * @param {Object} val The value to test
   * @return {boolean} True if value is a plain Object, otherwise false
   */
  function isPlainObject(val) {
    if (toString$3.call(val) !== '[object Object]') {
      return false;
    }

    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
  }

  /**
   * Determine if a value is a Date
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if value is a Date, otherwise false
   */
  function isDate(val) {
    return toString$3.call(val) === '[object Date]';
  }

  /**
   * Determine if a value is a File
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if value is a File, otherwise false
   */
  function isFile(val) {
    return toString$3.call(val) === '[object File]';
  }

  /**
   * Determine if a value is a Blob
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if value is a Blob, otherwise false
   */
  function isBlob(val) {
    return toString$3.call(val) === '[object Blob]';
  }

  /**
   * Determine if a value is a Function
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if value is a Function, otherwise false
   */
  function isFunction(val) {
    return toString$3.call(val) === '[object Function]';
  }

  /**
   * Determine if a value is a Stream
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if value is a Stream, otherwise false
   */
  function isStream(val) {
    return isObject$1(val) && isFunction(val.pipe);
  }

  /**
   * Determine if a value is a URLSearchParams object
   *
   * @param {Object} val The value to test
   * @returns {boolean} True if value is a URLSearchParams object, otherwise false
   */
  function isURLSearchParams(val) {
    return toString$3.call(val) === '[object URLSearchParams]';
  }

  /**
   * Trim excess whitespace off the beginning and end of a string
   *
   * @param {String} str The String to trim
   * @returns {String} The String freed of excess whitespace
   */
  function trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
  }

  /**
   * Determine if we're running in a standard browser environment
   *
   * This allows axios to run in a web worker, and react-native.
   * Both environments support XMLHttpRequest, but not fully standard globals.
   *
   * web workers:
   *  typeof window -> undefined
   *  typeof document -> undefined
   *
   * react-native:
   *  navigator.product -> 'ReactNative'
   * nativescript
   *  navigator.product -> 'NativeScript' or 'NS'
   */
  function isStandardBrowserEnv() {
    if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                             navigator.product === 'NativeScript' ||
                                             navigator.product === 'NS')) {
      return false;
    }
    return (
      typeof window !== 'undefined' &&
      typeof document !== 'undefined'
    );
  }

  /**
   * Iterate over an Array or an Object invoking a function for each item.
   *
   * If `obj` is an Array callback will be called passing
   * the value, index, and complete array for each item.
   *
   * If 'obj' is an Object callback will be called passing
   * the value, key, and complete object for each property.
   *
   * @param {Object|Array} obj The object to iterate
   * @param {Function} fn The callback to invoke for each item
   */
  function forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') {
      return;
    }

    // Force an array if not already something iterable
    if (typeof obj !== 'object') {
      /*eslint no-param-reassign:0*/
      obj = [obj];
    }

    if (isArray(obj)) {
      // Iterate over array values
      for (var i = 0, l = obj.length; i < l; i++) {
        fn.call(null, obj[i], i, obj);
      }
    } else {
      // Iterate over object keys
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          fn.call(null, obj[key], key, obj);
        }
      }
    }
  }

  /**
   * Accepts varargs expecting each argument to be an object, then
   * immutably merges the properties of each object and returns result.
   *
   * When multiple objects contain the same key the later object in
   * the arguments list will take precedence.
   *
   * Example:
   *
   * ```js
   * var result = merge({foo: 123}, {foo: 456});
   * console.log(result.foo); // outputs 456
   * ```
   *
   * @param {Object} obj1 Object to merge
   * @returns {Object} Result of all merge properties
   */
  function merge(/* obj1, obj2, obj3, ... */) {
    var result = {};
    function assignValue(val, key) {
      if (isPlainObject(result[key]) && isPlainObject(val)) {
        result[key] = merge(result[key], val);
      } else if (isPlainObject(val)) {
        result[key] = merge({}, val);
      } else if (isArray(val)) {
        result[key] = val.slice();
      } else {
        result[key] = val;
      }
    }

    for (var i = 0, l = arguments.length; i < l; i++) {
      forEach(arguments[i], assignValue);
    }
    return result;
  }

  /**
   * Extends object a by mutably adding to it the properties of object b.
   *
   * @param {Object} a The object to be extended
   * @param {Object} b The object to copy properties from
   * @param {Object} thisArg The object to bind function to
   * @return {Object} The resulting value of object a
   */
  function extend(a, b, thisArg) {
    forEach(b, function assignValue(val, key) {
      if (thisArg && typeof val === 'function') {
        a[key] = bind$1(val, thisArg);
      } else {
        a[key] = val;
      }
    });
    return a;
  }

  /**
   * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
   *
   * @param {string} content with BOM
   * @return {string} content value without BOM
   */
  function stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) {
      content = content.slice(1);
    }
    return content;
  }

  var utils$e = {
    isArray: isArray,
    isArrayBuffer: isArrayBuffer,
    isBuffer: isBuffer,
    isFormData: isFormData,
    isArrayBufferView: isArrayBufferView,
    isString: isString,
    isNumber: isNumber,
    isObject: isObject$1,
    isPlainObject: isPlainObject,
    isUndefined: isUndefined,
    isDate: isDate,
    isFile: isFile,
    isBlob: isBlob,
    isFunction: isFunction,
    isStream: isStream,
    isURLSearchParams: isURLSearchParams,
    isStandardBrowserEnv: isStandardBrowserEnv,
    forEach: forEach,
    merge: merge,
    extend: extend,
    trim: trim,
    stripBOM: stripBOM
  };

  var utils$d = utils$e;

  function encode(val) {
    return encodeURIComponent(val).
      replace(/%3A/gi, ':').
      replace(/%24/g, '$').
      replace(/%2C/gi, ',').
      replace(/%20/g, '+').
      replace(/%5B/gi, '[').
      replace(/%5D/gi, ']');
  }

  /**
   * Build a URL by appending params to the end
   *
   * @param {string} url The base of the url (e.g., http://www.google.com)
   * @param {object} [params] The params to be appended
   * @returns {string} The formatted url
   */
  var buildURL$2 = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/
    if (!params) {
      return url;
    }

    var serializedParams;
    if (paramsSerializer) {
      serializedParams = paramsSerializer(params);
    } else if (utils$d.isURLSearchParams(params)) {
      serializedParams = params.toString();
    } else {
      var parts = [];

      utils$d.forEach(params, function serialize(val, key) {
        if (val === null || typeof val === 'undefined') {
          return;
        }

        if (utils$d.isArray(val)) {
          key = key + '[]';
        } else {
          val = [val];
        }

        utils$d.forEach(val, function parseValue(v) {
          if (utils$d.isDate(v)) {
            v = v.toISOString();
          } else if (utils$d.isObject(v)) {
            v = JSON.stringify(v);
          }
          parts.push(encode(key) + '=' + encode(v));
        });
      });

      serializedParams = parts.join('&');
    }

    if (serializedParams) {
      var hashmarkIndex = url.indexOf('#');
      if (hashmarkIndex !== -1) {
        url = url.slice(0, hashmarkIndex);
      }

      url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }

    return url;
  };

  var utils$c = utils$e;

  function InterceptorManager$1() {
    this.handlers = [];
  }

  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  InterceptorManager$1.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
      fulfilled: fulfilled,
      rejected: rejected,
      synchronous: options ? options.synchronous : false,
      runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
  };

  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   */
  InterceptorManager$1.prototype.eject = function eject(id) {
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  };

  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   */
  InterceptorManager$1.prototype.forEach = function forEach(fn) {
    utils$c.forEach(this.handlers, function forEachHandler(h) {
      if (h !== null) {
        fn(h);
      }
    });
  };

  var InterceptorManager_1 = InterceptorManager$1;

  var utils$b = utils$e;

  var normalizeHeaderName$1 = function normalizeHeaderName(headers, normalizedName) {
    utils$b.forEach(headers, function processHeader(value, name) {
      if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
        headers[normalizedName] = value;
        delete headers[name];
      }
    });
  };

  /**
   * Update an Error with the specified config, error code, and response.
   *
   * @param {Error} error The error to update.
   * @param {Object} config The config.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   * @returns {Error} The error.
   */
  var enhanceError$2 = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) {
      error.code = code;
    }

    error.request = request;
    error.response = response;
    error.isAxiosError = true;

    error.toJSON = function toJSON() {
      return {
        // Standard
        message: this.message,
        name: this.name,
        // Microsoft
        description: this.description,
        number: this.number,
        // Mozilla
        fileName: this.fileName,
        lineNumber: this.lineNumber,
        columnNumber: this.columnNumber,
        stack: this.stack,
        // Axios
        config: this.config,
        code: this.code,
        status: this.response && this.response.status ? this.response.status : null
      };
    };
    return error;
  };

  var enhanceError$1 = enhanceError$2;

  /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {Object} config The config.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   * @returns {Error} The created error.
   */
  var createError$2 = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return enhanceError$1(error, config, code, request, response);
  };

  var createError$1 = createError$2;

  /**
   * Resolve or reject a Promise based on response status.
   *
   * @param {Function} resolve A function that resolves the promise.
   * @param {Function} reject A function that rejects the promise.
   * @param {object} response The response.
   */
  var settle$1 = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) {
      resolve(response);
    } else {
      reject(createError$1(
        'Request failed with status code ' + response.status,
        response.config,
        null,
        response.request,
        response
      ));
    }
  };

  var utils$a = utils$e;

  var cookies$1 = (
    utils$a.isStandardBrowserEnv() ?

    // Standard browser envs support document.cookie
      (function standardBrowserEnv() {
        return {
          write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + '=' + encodeURIComponent(value));

            if (utils$a.isNumber(expires)) {
              cookie.push('expires=' + new Date(expires).toGMTString());
            }

            if (utils$a.isString(path)) {
              cookie.push('path=' + path);
            }

            if (utils$a.isString(domain)) {
              cookie.push('domain=' + domain);
            }

            if (secure === true) {
              cookie.push('secure');
            }

            document.cookie = cookie.join('; ');
          },

          read: function read(name) {
            var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
            return (match ? decodeURIComponent(match[3]) : null);
          },

          remove: function remove(name) {
            this.write(name, '', Date.now() - 86400000);
          }
        };
      })() :

    // Non standard browser env (web workers, react-native) lack needed support.
      (function nonStandardBrowserEnv() {
        return {
          write: function write() {},
          read: function read() { return null; },
          remove: function remove() {}
        };
      })()
  );

  /**
   * Determines whether the specified URL is absolute
   *
   * @param {string} url The URL to test
   * @returns {boolean} True if the specified URL is absolute, otherwise false
   */
  var isAbsoluteURL$1 = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
  };

  /**
   * Creates a new URL by combining the specified URLs
   *
   * @param {string} baseURL The base URL
   * @param {string} relativeURL The relative URL
   * @returns {string} The combined URL
   */
  var combineURLs$1 = function combineURLs(baseURL, relativeURL) {
    return relativeURL
      ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
      : baseURL;
  };

  var isAbsoluteURL = isAbsoluteURL$1;
  var combineURLs = combineURLs$1;

  /**
   * Creates a new URL by combining the baseURL with the requestedURL,
   * only when the requestedURL is not already an absolute URL.
   * If the requestURL is absolute, this function returns the requestedURL untouched.
   *
   * @param {string} baseURL The base URL
   * @param {string} requestedURL Absolute or relative URL to combine
   * @returns {string} The combined full path
   */
  var buildFullPath$1 = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !isAbsoluteURL(requestedURL)) {
      return combineURLs(baseURL, requestedURL);
    }
    return requestedURL;
  };

  var utils$9 = utils$e;

  // Headers whose duplicates are ignored by node
  // c.f. https://nodejs.org/api/http.html#http_message_headers
  var ignoreDuplicateOf = [
    'age', 'authorization', 'content-length', 'content-type', 'etag',
    'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
    'last-modified', 'location', 'max-forwards', 'proxy-authorization',
    'referer', 'retry-after', 'user-agent'
  ];

  /**
   * Parse headers into an object
   *
   * ```
   * Date: Wed, 27 Aug 2014 08:58:49 GMT
   * Content-Type: application/json
   * Connection: keep-alive
   * Transfer-Encoding: chunked
   * ```
   *
   * @param {String} headers Headers needing to be parsed
   * @returns {Object} Headers parsed into an object
   */
  var parseHeaders$1 = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;

    if (!headers) { return parsed; }

    utils$9.forEach(headers.split('\n'), function parser(line) {
      i = line.indexOf(':');
      key = utils$9.trim(line.substr(0, i)).toLowerCase();
      val = utils$9.trim(line.substr(i + 1));

      if (key) {
        if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
          return;
        }
        if (key === 'set-cookie') {
          parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
        } else {
          parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
        }
      }
    });

    return parsed;
  };

  var utils$8 = utils$e;

  var isURLSameOrigin$1 = (
    utils$8.isStandardBrowserEnv() ?

    // Standard browser envs have full support of the APIs needed to test
    // whether the request URL is of the same origin as current location.
      (function standardBrowserEnv() {
        var msie = /(msie|trident)/i.test(navigator.userAgent);
        var urlParsingNode = document.createElement('a');
        var originURL;

        /**
      * Parse a URL to discover it's components
      *
      * @param {String} url The URL to be parsed
      * @returns {Object}
      */
        function resolveURL(url) {
          var href = url;

          if (msie) {
          // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute('href', href);
            href = urlParsingNode.href;
          }

          urlParsingNode.setAttribute('href', href);

          // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
          return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
              urlParsingNode.pathname :
              '/' + urlParsingNode.pathname
          };
        }

        originURL = resolveURL(window.location.href);

        /**
      * Determine if a URL shares the same origin as the current location
      *
      * @param {String} requestURL The URL to test
      * @returns {boolean} True if URL shares the same origin, otherwise false
      */
        return function isURLSameOrigin(requestURL) {
          var parsed = (utils$8.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
          return (parsed.protocol === originURL.protocol &&
              parsed.host === originURL.host);
        };
      })() :

    // Non standard browser envs (web workers, react-native) lack needed support.
      (function nonStandardBrowserEnv() {
        return function isURLSameOrigin() {
          return true;
        };
      })()
  );

  /**
   * A `Cancel` is an object that is thrown when an operation is canceled.
   *
   * @class
   * @param {string=} message The message.
   */
  function Cancel$3(message) {
    this.message = message;
  }

  Cancel$3.prototype.toString = function toString() {
    return 'Cancel' + (this.message ? ': ' + this.message : '');
  };

  Cancel$3.prototype.__CANCEL__ = true;

  var Cancel_1 = Cancel$3;

  var utils$7 = utils$e;
  var settle = settle$1;
  var cookies = cookies$1;
  var buildURL$1 = buildURL$2;
  var buildFullPath = buildFullPath$1;
  var parseHeaders = parseHeaders$1;
  var isURLSameOrigin = isURLSameOrigin$1;
  var createError = createError$2;
  var defaults$4 = defaults_1;
  var Cancel$2 = Cancel_1;

  var xhr = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
      var requestData = config.data;
      var requestHeaders = config.headers;
      var responseType = config.responseType;
      var onCanceled;
      function done() {
        if (config.cancelToken) {
          config.cancelToken.unsubscribe(onCanceled);
        }

        if (config.signal) {
          config.signal.removeEventListener('abort', onCanceled);
        }
      }

      if (utils$7.isFormData(requestData)) {
        delete requestHeaders['Content-Type']; // Let the browser set it
      }

      var request = new XMLHttpRequest();

      // HTTP basic authentication
      if (config.auth) {
        var username = config.auth.username || '';
        var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
        requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
      }

      var fullPath = buildFullPath(config.baseURL, config.url);
      request.open(config.method.toUpperCase(), buildURL$1(fullPath, config.params, config.paramsSerializer), true);

      // Set the request timeout in MS
      request.timeout = config.timeout;

      function onloadend() {
        if (!request) {
          return;
        }
        // Prepare the response
        var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
        var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
          request.responseText : request.response;
        var response = {
          data: responseData,
          status: request.status,
          statusText: request.statusText,
          headers: responseHeaders,
          config: config,
          request: request
        };

        settle(function _resolve(value) {
          resolve(value);
          done();
        }, function _reject(err) {
          reject(err);
          done();
        }, response);

        // Clean up request
        request = null;
      }

      if ('onloadend' in request) {
        // Use onloadend if available
        request.onloadend = onloadend;
      } else {
        // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
          if (!request || request.readyState !== 4) {
            return;
          }

          // The request errored out and we didn't get a response, this will be
          // handled by onerror instead
          // With one exception: request that using file: protocol, most browsers
          // will return status as 0 even though it's a successful request
          if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
            return;
          }
          // readystate handler is calling before onerror or ontimeout handlers,
          // so we should call onloadend on the next 'tick'
          setTimeout(onloadend);
        };
      }

      // Handle browser request cancellation (as opposed to a manual cancellation)
      request.onabort = function handleAbort() {
        if (!request) {
          return;
        }

        reject(createError('Request aborted', config, 'ECONNABORTED', request));

        // Clean up request
        request = null;
      };

      // Handle low level network errors
      request.onerror = function handleError() {
        // Real errors are hidden from us by the browser
        // onerror should only fire if it's a network error
        reject(createError('Network Error', config, null, request));

        // Clean up request
        request = null;
      };

      // Handle timeout
      request.ontimeout = function handleTimeout() {
        var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
        var transitional = config.transitional || defaults$4.transitional;
        if (config.timeoutErrorMessage) {
          timeoutErrorMessage = config.timeoutErrorMessage;
        }
        reject(createError(
          timeoutErrorMessage,
          config,
          transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
          request));

        // Clean up request
        request = null;
      };

      // Add xsrf header
      // This is only done if running in a standard browser environment.
      // Specifically not if we're in a web worker, or react-native.
      if (utils$7.isStandardBrowserEnv()) {
        // Add xsrf header
        var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

        if (xsrfValue) {
          requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
      }

      // Add headers to the request
      if ('setRequestHeader' in request) {
        utils$7.forEach(requestHeaders, function setRequestHeader(val, key) {
          if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
            // Remove Content-Type if data is undefined
            delete requestHeaders[key];
          } else {
            // Otherwise add header to the request
            request.setRequestHeader(key, val);
          }
        });
      }

      // Add withCredentials to request if needed
      if (!utils$7.isUndefined(config.withCredentials)) {
        request.withCredentials = !!config.withCredentials;
      }

      // Add responseType to request if needed
      if (responseType && responseType !== 'json') {
        request.responseType = config.responseType;
      }

      // Handle progress if needed
      if (typeof config.onDownloadProgress === 'function') {
        request.addEventListener('progress', config.onDownloadProgress);
      }

      // Not all browsers support upload events
      if (typeof config.onUploadProgress === 'function' && request.upload) {
        request.upload.addEventListener('progress', config.onUploadProgress);
      }

      if (config.cancelToken || config.signal) {
        // Handle cancellation
        // eslint-disable-next-line func-names
        onCanceled = function(cancel) {
          if (!request) {
            return;
          }
          reject(!cancel || (cancel && cancel.type) ? new Cancel$2('canceled') : cancel);
          request.abort();
          request = null;
        };

        config.cancelToken && config.cancelToken.subscribe(onCanceled);
        if (config.signal) {
          config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
        }
      }

      if (!requestData) {
        requestData = null;
      }

      // Send the request
      request.send(requestData);
    });
  };

  var utils$6 = utils$e;
  var normalizeHeaderName = normalizeHeaderName$1;
  var enhanceError = enhanceError$2;

  var DEFAULT_CONTENT_TYPE = {
    'Content-Type': 'application/x-www-form-urlencoded'
  };

  function setContentTypeIfUnset(headers, value) {
    if (!utils$6.isUndefined(headers) && utils$6.isUndefined(headers['Content-Type'])) {
      headers['Content-Type'] = value;
    }
  }

  function getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== 'undefined') {
      // For browsers use XHR adapter
      adapter = xhr;
    } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
      // For node use HTTP adapter
      adapter = xhr;
    }
    return adapter;
  }

  function stringifySafely(rawValue, parser, encoder) {
    if (utils$6.isString(rawValue)) {
      try {
        (parser || JSON.parse)(rawValue);
        return utils$6.trim(rawValue);
      } catch (e) {
        if (e.name !== 'SyntaxError') {
          throw e;
        }
      }
    }

    return (encoder || JSON.stringify)(rawValue);
  }

  var defaults$3 = {

    transitional: {
      silentJSONParsing: true,
      forcedJSONParsing: true,
      clarifyTimeoutError: false
    },

    adapter: getDefaultAdapter(),

    transformRequest: [function transformRequest(data, headers) {
      normalizeHeaderName(headers, 'Accept');
      normalizeHeaderName(headers, 'Content-Type');

      if (utils$6.isFormData(data) ||
        utils$6.isArrayBuffer(data) ||
        utils$6.isBuffer(data) ||
        utils$6.isStream(data) ||
        utils$6.isFile(data) ||
        utils$6.isBlob(data)
      ) {
        return data;
      }
      if (utils$6.isArrayBufferView(data)) {
        return data.buffer;
      }
      if (utils$6.isURLSearchParams(data)) {
        setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
        return data.toString();
      }
      if (utils$6.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
        setContentTypeIfUnset(headers, 'application/json');
        return stringifySafely(data);
      }
      return data;
    }],

    transformResponse: [function transformResponse(data) {
      var transitional = this.transitional || defaults$3.transitional;
      var silentJSONParsing = transitional && transitional.silentJSONParsing;
      var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
      var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

      if (strictJSONParsing || (forcedJSONParsing && utils$6.isString(data) && data.length)) {
        try {
          return JSON.parse(data);
        } catch (e) {
          if (strictJSONParsing) {
            if (e.name === 'SyntaxError') {
              throw enhanceError(e, this, 'E_JSON_PARSE');
            }
            throw e;
          }
        }
      }

      return data;
    }],

    /**
     * A timeout in milliseconds to abort a request. If set to 0 (default) a
     * timeout is not created.
     */
    timeout: 0,

    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',

    maxContentLength: -1,
    maxBodyLength: -1,

    validateStatus: function validateStatus(status) {
      return status >= 200 && status < 300;
    },

    headers: {
      common: {
        'Accept': 'application/json, text/plain, */*'
      }
    }
  };

  utils$6.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
    defaults$3.headers[method] = {};
  });

  utils$6.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
    defaults$3.headers[method] = utils$6.merge(DEFAULT_CONTENT_TYPE);
  });

  var defaults_1 = defaults$3;

  var utils$5 = utils$e;
  var defaults$2 = defaults_1;

  /**
   * Transform the data for a request or a response
   *
   * @param {Object|String} data The data to be transformed
   * @param {Array} headers The headers for the request or response
   * @param {Array|Function} fns A single function or Array of functions
   * @returns {*} The resulting transformed data
   */
  var transformData$1 = function transformData(data, headers, fns) {
    var context = this || defaults$2;
    /*eslint no-param-reassign:0*/
    utils$5.forEach(fns, function transform(fn) {
      data = fn.call(context, data, headers);
    });

    return data;
  };

  var isCancel$1 = function isCancel(value) {
    return !!(value && value.__CANCEL__);
  };

  var utils$4 = utils$e;
  var transformData = transformData$1;
  var isCancel = isCancel$1;
  var defaults$1 = defaults_1;
  var Cancel$1 = Cancel_1;

  /**
   * Throws a `Cancel` if cancellation has been requested.
   */
  function throwIfCancellationRequested(config) {
    if (config.cancelToken) {
      config.cancelToken.throwIfRequested();
    }

    if (config.signal && config.signal.aborted) {
      throw new Cancel$1('canceled');
    }
  }

  /**
   * Dispatch a request to the server using the configured adapter.
   *
   * @param {object} config The config that is to be used for the request
   * @returns {Promise} The Promise to be fulfilled
   */
  var dispatchRequest$1 = function dispatchRequest(config) {
    throwIfCancellationRequested(config);

    // Ensure headers exist
    config.headers = config.headers || {};

    // Transform request data
    config.data = transformData.call(
      config,
      config.data,
      config.headers,
      config.transformRequest
    );

    // Flatten headers
    config.headers = utils$4.merge(
      config.headers.common || {},
      config.headers[config.method] || {},
      config.headers
    );

    utils$4.forEach(
      ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
      function cleanHeaderConfig(method) {
        delete config.headers[method];
      }
    );

    var adapter = config.adapter || defaults$1.adapter;

    return adapter(config).then(function onAdapterResolution(response) {
      throwIfCancellationRequested(config);

      // Transform response data
      response.data = transformData.call(
        config,
        response.data,
        response.headers,
        config.transformResponse
      );

      return response;
    }, function onAdapterRejection(reason) {
      if (!isCancel(reason)) {
        throwIfCancellationRequested(config);

        // Transform response data
        if (reason && reason.response) {
          reason.response.data = transformData.call(
            config,
            reason.response.data,
            reason.response.headers,
            config.transformResponse
          );
        }
      }

      return Promise.reject(reason);
    });
  };

  var utils$3 = utils$e;

  /**
   * Config-specific merge-function which creates a new config-object
   * by merging two configuration objects together.
   *
   * @param {Object} config1
   * @param {Object} config2
   * @returns {Object} New object resulting from merging config2 to config1
   */
  var mergeConfig$2 = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};

    function getMergedValue(target, source) {
      if (utils$3.isPlainObject(target) && utils$3.isPlainObject(source)) {
        return utils$3.merge(target, source);
      } else if (utils$3.isPlainObject(source)) {
        return utils$3.merge({}, source);
      } else if (utils$3.isArray(source)) {
        return source.slice();
      }
      return source;
    }

    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(prop) {
      if (!utils$3.isUndefined(config2[prop])) {
        return getMergedValue(config1[prop], config2[prop]);
      } else if (!utils$3.isUndefined(config1[prop])) {
        return getMergedValue(undefined, config1[prop]);
      }
    }

    // eslint-disable-next-line consistent-return
    function valueFromConfig2(prop) {
      if (!utils$3.isUndefined(config2[prop])) {
        return getMergedValue(undefined, config2[prop]);
      }
    }

    // eslint-disable-next-line consistent-return
    function defaultToConfig2(prop) {
      if (!utils$3.isUndefined(config2[prop])) {
        return getMergedValue(undefined, config2[prop]);
      } else if (!utils$3.isUndefined(config1[prop])) {
        return getMergedValue(undefined, config1[prop]);
      }
    }

    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(prop) {
      if (prop in config2) {
        return getMergedValue(config1[prop], config2[prop]);
      } else if (prop in config1) {
        return getMergedValue(undefined, config1[prop]);
      }
    }

    var mergeMap = {
      'url': valueFromConfig2,
      'method': valueFromConfig2,
      'data': valueFromConfig2,
      'baseURL': defaultToConfig2,
      'transformRequest': defaultToConfig2,
      'transformResponse': defaultToConfig2,
      'paramsSerializer': defaultToConfig2,
      'timeout': defaultToConfig2,
      'timeoutMessage': defaultToConfig2,
      'withCredentials': defaultToConfig2,
      'adapter': defaultToConfig2,
      'responseType': defaultToConfig2,
      'xsrfCookieName': defaultToConfig2,
      'xsrfHeaderName': defaultToConfig2,
      'onUploadProgress': defaultToConfig2,
      'onDownloadProgress': defaultToConfig2,
      'decompress': defaultToConfig2,
      'maxContentLength': defaultToConfig2,
      'maxBodyLength': defaultToConfig2,
      'transport': defaultToConfig2,
      'httpAgent': defaultToConfig2,
      'httpsAgent': defaultToConfig2,
      'cancelToken': defaultToConfig2,
      'socketPath': defaultToConfig2,
      'responseEncoding': defaultToConfig2,
      'validateStatus': mergeDirectKeys
    };

    utils$3.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
      var merge = mergeMap[prop] || mergeDeepProperties;
      var configValue = merge(prop);
      (utils$3.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
    });

    return config;
  };

  var data = {
    "version": "0.25.0"
  };

  var VERSION = data.version;

  var validators$1 = {};

  // eslint-disable-next-line func-names
  ['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
    validators$1[type] = function validator(thing) {
      return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
  });

  var deprecatedWarnings = {};

  /**
   * Transitional option validator
   * @param {function|boolean?} validator - set to false if the transitional option has been removed
   * @param {string?} version - deprecated version / removed since version
   * @param {string?} message - some message with additional info
   * @returns {function}
   */
  validators$1.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
      return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }

    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
      if (validator === false) {
        throw new Error(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')));
      }

      if (version && !deprecatedWarnings[opt]) {
        deprecatedWarnings[opt] = true;
        // eslint-disable-next-line no-console
        console.warn(
          formatMessage(
            opt,
            ' has been deprecated since v' + version + ' and will be removed in the near future'
          )
        );
      }

      return validator ? validator(value, opt, opts) : true;
    };
  };

  /**
   * Assert object's properties type
   * @param {object} options
   * @param {object} schema
   * @param {boolean?} allowUnknown
   */

  function assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') {
      throw new TypeError('options must be an object');
    }
    var keys = Object.keys(options);
    var i = keys.length;
    while (i-- > 0) {
      var opt = keys[i];
      var validator = schema[opt];
      if (validator) {
        var value = options[opt];
        var result = value === undefined || validator(value, opt, options);
        if (result !== true) {
          throw new TypeError('option ' + opt + ' must be ' + result);
        }
        continue;
      }
      if (allowUnknown !== true) {
        throw Error('Unknown option ' + opt);
      }
    }
  }

  var validator$1 = {
    assertOptions: assertOptions,
    validators: validators$1
  };

  var utils$2 = utils$e;
  var buildURL = buildURL$2;
  var InterceptorManager = InterceptorManager_1;
  var dispatchRequest = dispatchRequest$1;
  var mergeConfig$1 = mergeConfig$2;
  var validator = validator$1;

  var validators = validator.validators;
  /**
   * Create a new instance of Axios
   *
   * @param {Object} instanceConfig The default config for the instance
   */
  function Axios$1(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
      request: new InterceptorManager(),
      response: new InterceptorManager()
    };
  }

  /**
   * Dispatch a request
   *
   * @param {Object} config The config specific for this request (merged with this.defaults)
   */
  Axios$1.prototype.request = function request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/
    // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === 'string') {
      config = config || {};
      config.url = configOrUrl;
    } else {
      config = configOrUrl || {};
    }

    if (!config.url) {
      throw new Error('Provided config url is not valid');
    }

    config = mergeConfig$1(this.defaults, config);

    // Set config.method
    if (config.method) {
      config.method = config.method.toLowerCase();
    } else if (this.defaults.method) {
      config.method = this.defaults.method.toLowerCase();
    } else {
      config.method = 'get';
    }

    var transitional = config.transitional;

    if (transitional !== undefined) {
      validator.assertOptions(transitional, {
        silentJSONParsing: validators.transitional(validators.boolean),
        forcedJSONParsing: validators.transitional(validators.boolean),
        clarifyTimeoutError: validators.transitional(validators.boolean)
      }, false);
    }

    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
      if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
        return;
      }

      synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

      requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });

    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
      responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });

    var promise;

    if (!synchronousRequestInterceptors) {
      var chain = [dispatchRequest, undefined];

      Array.prototype.unshift.apply(chain, requestInterceptorChain);
      chain = chain.concat(responseInterceptorChain);

      promise = Promise.resolve(config);
      while (chain.length) {
        promise = promise.then(chain.shift(), chain.shift());
      }

      return promise;
    }


    var newConfig = config;
    while (requestInterceptorChain.length) {
      var onFulfilled = requestInterceptorChain.shift();
      var onRejected = requestInterceptorChain.shift();
      try {
        newConfig = onFulfilled(newConfig);
      } catch (error) {
        onRejected(error);
        break;
      }
    }

    try {
      promise = dispatchRequest(newConfig);
    } catch (error) {
      return Promise.reject(error);
    }

    while (responseInterceptorChain.length) {
      promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    }

    return promise;
  };

  Axios$1.prototype.getUri = function getUri(config) {
    if (!config.url) {
      throw new Error('Provided config url is not valid');
    }
    config = mergeConfig$1(this.defaults, config);
    return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
  };

  // Provide aliases for supported request methods
  utils$2.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
    /*eslint func-names:0*/
    Axios$1.prototype[method] = function(url, config) {
      return this.request(mergeConfig$1(config || {}, {
        method: method,
        url: url,
        data: (config || {}).data
      }));
    };
  });

  utils$2.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
    /*eslint func-names:0*/
    Axios$1.prototype[method] = function(url, data, config) {
      return this.request(mergeConfig$1(config || {}, {
        method: method,
        url: url,
        data: data
      }));
    };
  });

  var Axios_1 = Axios$1;

  var Cancel = Cancel_1;

  /**
   * A `CancelToken` is an object that can be used to request cancellation of an operation.
   *
   * @class
   * @param {Function} executor The executor function.
   */
  function CancelToken(executor) {
    if (typeof executor !== 'function') {
      throw new TypeError('executor must be a function.');
    }

    var resolvePromise;

    this.promise = new Promise(function promiseExecutor(resolve) {
      resolvePromise = resolve;
    });

    var token = this;

    // eslint-disable-next-line func-names
    this.promise.then(function(cancel) {
      if (!token._listeners) return;

      var i;
      var l = token._listeners.length;

      for (i = 0; i < l; i++) {
        token._listeners[i](cancel);
      }
      token._listeners = null;
    });

    // eslint-disable-next-line func-names
    this.promise.then = function(onfulfilled) {
      var _resolve;
      // eslint-disable-next-line func-names
      var promise = new Promise(function(resolve) {
        token.subscribe(resolve);
        _resolve = resolve;
      }).then(onfulfilled);

      promise.cancel = function reject() {
        token.unsubscribe(_resolve);
      };

      return promise;
    };

    executor(function cancel(message) {
      if (token.reason) {
        // Cancellation has already been requested
        return;
      }

      token.reason = new Cancel(message);
      resolvePromise(token.reason);
    });
  }

  /**
   * Throws a `Cancel` if cancellation has been requested.
   */
  CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  };

  /**
   * Subscribe to the cancel signal
   */

  CancelToken.prototype.subscribe = function subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }

    if (this._listeners) {
      this._listeners.push(listener);
    } else {
      this._listeners = [listener];
    }
  };

  /**
   * Unsubscribe from the cancel signal
   */

  CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
    if (!this._listeners) {
      return;
    }
    var index = this._listeners.indexOf(listener);
    if (index !== -1) {
      this._listeners.splice(index, 1);
    }
  };

  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  CancelToken.source = function source() {
    var cancel;
    var token = new CancelToken(function executor(c) {
      cancel = c;
    });
    return {
      token: token,
      cancel: cancel
    };
  };

  var CancelToken_1 = CancelToken;

  /**
   * Syntactic sugar for invoking a function and expanding an array for arguments.
   *
   * Common use case would be to use `Function.prototype.apply`.
   *
   *  ```js
   *  function f(x, y, z) {}
   *  var args = [1, 2, 3];
   *  f.apply(null, args);
   *  ```
   *
   * With `spread` this example can be re-written.
   *
   *  ```js
   *  spread(function(x, y, z) {})([1, 2, 3]);
   *  ```
   *
   * @param {Function} callback
   * @returns {Function}
   */
  var spread = function spread(callback) {
    return function wrap(arr) {
      return callback.apply(null, arr);
    };
  };

  var utils$1 = utils$e;

  /**
   * Determines whether the payload is an error thrown by Axios
   *
   * @param {*} payload The value to test
   * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
   */
  var isAxiosError = function isAxiosError(payload) {
    return utils$1.isObject(payload) && (payload.isAxiosError === true);
  };

  var utils = utils$e;
  var bind = bind$2;
  var Axios = Axios_1;
  var mergeConfig = mergeConfig$2;
  var defaults = defaults_1;

  /**
   * Create an instance of Axios
   *
   * @param {Object} defaultConfig The default config for the instance
   * @return {Axios} A new instance of Axios
   */
  function createInstance(defaultConfig) {
    var context = new Axios(defaultConfig);
    var instance = bind(Axios.prototype.request, context);

    // Copy axios.prototype to instance
    utils.extend(instance, Axios.prototype, context);

    // Copy context to instance
    utils.extend(instance, context);

    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
      return createInstance(mergeConfig(defaultConfig, instanceConfig));
    };

    return instance;
  }

  // Create the default instance to be exported
  var axios$1 = createInstance(defaults);

  // Expose Axios class to allow class inheritance
  axios$1.Axios = Axios;

  // Expose Cancel & CancelToken
  axios$1.Cancel = Cancel_1;
  axios$1.CancelToken = CancelToken_1;
  axios$1.isCancel = isCancel$1;
  axios$1.VERSION = data.version;

  // Expose all/spread
  axios$1.all = function all(promises) {
    return Promise.all(promises);
  };
  axios$1.spread = spread;

  // Expose isAxiosError
  axios$1.isAxiosError = isAxiosError;

  axios$2.exports = axios$1;

  // Allow use of default import syntax in TypeScript
  axios$2.exports.default = axios$1;

  var axios = axios$2.exports;

  /**
   * farmOS client method for sending an entity to a Drupal JSON:API server
   * @typedef {Function} deleteEntity
   * @param {String} bundle The bundle type (eg, 'activity', 'equipment', etc).
   * @param {Object} entity The entity being sent to the server.
   * @returns {Promise}
   */

  /**
   * @param {String} entity
   * @param {Function} request
   * @returns {deleteEntity}
   */
  const deleteEntity = (entity, request) => (bundle, id) => request(
    `/api/${entity}/${bundle}/${id}`,
    { method: 'DELETE' },
  );

  function _isFunction$1(x) {
    var type = Object.prototype.toString.call(x);
    return type === '[object Function]' || type === '[object AsyncFunction]' || type === '[object GeneratorFunction]' || type === '[object AsyncGeneratorFunction]';
  }

  var _isFunction_1 = _isFunction$1;

  function _arrayFromIterator$1(iter) {
    var list = [];
    var next;

    while (!(next = iter.next()).done) {
      list.push(next.value);
    }

    return list;
  }

  var _arrayFromIterator_1 = _arrayFromIterator$1;

  function _includesWith$1(pred, x, list) {
    var idx = 0;
    var len = list.length;

    while (idx < len) {
      if (pred(x, list[idx])) {
        return true;
      }

      idx += 1;
    }

    return false;
  }

  var _includesWith_1 = _includesWith$1;

  function _functionName$1(f) {
    // String(x => x) evaluates to "x => x", so the pattern may not match.
    var match = String(f).match(/^function (\w*)/);
    return match == null ? '' : match[1];
  }

  var _functionName_1 = _functionName$1;

  // Based on https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
  function _objectIs$1(a, b) {
    // SameValue algorithm
    if (a === b) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return a !== 0 || 1 / a === 1 / b;
    } else {
      // Step 6.a: NaN == NaN
      return a !== a && b !== b;
    }
  }

  var _objectIs_1 = typeof Object.is === 'function' ? Object.is : _objectIs$1;

  var _curry1$d =

  _curry1_1;
  /**
   * Gives a single-word string description of the (native) type of a value,
   * returning such answers as 'Object', 'Number', 'Array', or 'Null'. Does not
   * attempt to distinguish user Object types any further, reporting them all as
   * 'Object'.
   *
   * @func
   * @memberOf R
   * @since v0.8.0
   * @category Type
   * @sig (* -> {*}) -> String
   * @param {*} val The value to test
   * @return {String}
   * @example
   *
   *      R.type({}); //=> "Object"
   *      R.type(1); //=> "Number"
   *      R.type(false); //=> "Boolean"
   *      R.type('s'); //=> "String"
   *      R.type(null); //=> "Null"
   *      R.type([]); //=> "Array"
   *      R.type(/[A-z]/); //=> "RegExp"
   *      R.type(() => {}); //=> "Function"
   *      R.type(undefined); //=> "Undefined"
   */


  var type$2 =
  /*#__PURE__*/
  _curry1$d(function type(val) {
    return val === null ? 'Null' : val === undefined ? 'Undefined' : Object.prototype.toString.call(val).slice(8, -1);
  });

  var type_1 = type$2;

  var _arrayFromIterator =

  _arrayFromIterator_1;

  var _includesWith =

  _includesWith_1;

  var _functionName =

  _functionName_1;

  var _has$3 =

  _has_1;

  var _objectIs =

  _objectIs_1;

  var keys$2 =

  keys_1;

  var type$1 =

  type_1;
  /**
   * private _uniqContentEquals function.
   * That function is checking equality of 2 iterator contents with 2 assumptions
   * - iterators lengths are the same
   * - iterators values are unique
   *
   * false-positive result will be returned for comparision of, e.g.
   * - [1,2,3] and [1,2,3,4]
   * - [1,1,1] and [1,2,3]
   * */


  function _uniqContentEquals(aIterator, bIterator, stackA, stackB) {
    var a = _arrayFromIterator(aIterator);

    var b = _arrayFromIterator(bIterator);

    function eq(_a, _b) {
      return _equals$1(_a, _b, stackA.slice(), stackB.slice());
    } // if *a* array contains any element that is not included in *b*


    return !_includesWith(function (b, aItem) {
      return !_includesWith(eq, aItem, b);
    }, b, a);
  }

  function _equals$1(a, b, stackA, stackB) {
    if (_objectIs(a, b)) {
      return true;
    }

    var typeA = type$1(a);

    if (typeA !== type$1(b)) {
      return false;
    }

    if (a == null || b == null) {
      return false;
    }

    if (typeof a['fantasy-land/equals'] === 'function' || typeof b['fantasy-land/equals'] === 'function') {
      return typeof a['fantasy-land/equals'] === 'function' && a['fantasy-land/equals'](b) && typeof b['fantasy-land/equals'] === 'function' && b['fantasy-land/equals'](a);
    }

    if (typeof a.equals === 'function' || typeof b.equals === 'function') {
      return typeof a.equals === 'function' && a.equals(b) && typeof b.equals === 'function' && b.equals(a);
    }

    switch (typeA) {
      case 'Arguments':
      case 'Array':
      case 'Object':
        if (typeof a.constructor === 'function' && _functionName(a.constructor) === 'Promise') {
          return a === b;
        }

        break;

      case 'Boolean':
      case 'Number':
      case 'String':
        if (!(typeof a === typeof b && _objectIs(a.valueOf(), b.valueOf()))) {
          return false;
        }

        break;

      case 'Date':
        if (!_objectIs(a.valueOf(), b.valueOf())) {
          return false;
        }

        break;

      case 'Error':
        return a.name === b.name && a.message === b.message;

      case 'RegExp':
        if (!(a.source === b.source && a.global === b.global && a.ignoreCase === b.ignoreCase && a.multiline === b.multiline && a.sticky === b.sticky && a.unicode === b.unicode)) {
          return false;
        }

        break;
    }

    var idx = stackA.length - 1;

    while (idx >= 0) {
      if (stackA[idx] === a) {
        return stackB[idx] === b;
      }

      idx -= 1;
    }

    switch (typeA) {
      case 'Map':
        if (a.size !== b.size) {
          return false;
        }

        return _uniqContentEquals(a.entries(), b.entries(), stackA.concat([a]), stackB.concat([b]));

      case 'Set':
        if (a.size !== b.size) {
          return false;
        }

        return _uniqContentEquals(a.values(), b.values(), stackA.concat([a]), stackB.concat([b]));

      case 'Arguments':
      case 'Array':
      case 'Object':
      case 'Boolean':
      case 'Number':
      case 'String':
      case 'Date':
      case 'Error':
      case 'RegExp':
      case 'Int8Array':
      case 'Uint8Array':
      case 'Uint8ClampedArray':
      case 'Int16Array':
      case 'Uint16Array':
      case 'Int32Array':
      case 'Uint32Array':
      case 'Float32Array':
      case 'Float64Array':
      case 'ArrayBuffer':
        break;

      default:
        // Values of other types are only equal if identical.
        return false;
    }

    var keysA = keys$2(a);

    if (keysA.length !== keys$2(b).length) {
      return false;
    }

    var extendedStackA = stackA.concat([a]);
    var extendedStackB = stackB.concat([b]);
    idx = keysA.length - 1;

    while (idx >= 0) {
      var key = keysA[idx];

      if (!(_has$3(key, b) && _equals$1(b[key], a[key], extendedStackA, extendedStackB))) {
        return false;
      }

      idx -= 1;
    }

    return true;
  }

  var _equals_1 = _equals$1;

  var _curry2$u =

  _curry2_1;

  var _equals =

  _equals_1;
  /**
   * Returns `true` if its arguments are equivalent, `false` otherwise. Handles
   * cyclical data structures.
   *
   * Dispatches symmetrically to the `equals` methods of both arguments, if
   * present.
   *
   * @func
   * @memberOf R
   * @since v0.15.0
   * @category Relation
   * @sig a -> b -> Boolean
   * @param {*} a
   * @param {*} b
   * @return {Boolean}
   * @example
   *
   *      R.equals(1, 1); //=> true
   *      R.equals(1, '1'); //=> false
   *      R.equals([1, 2, 3], [1, 2, 3]); //=> true
   *
   *      const a = {}; a.v = a;
   *      const b = {}; b.v = b;
   *      R.equals(a, b); //=> true
   */


  var equals$4 =
  /*#__PURE__*/
  _curry2$u(function equals(a, b) {
    return _equals(a, b, [], []);
  });

  var equals_1 = equals$4;

  var equals$5 = equals_1;

  var equals$3 =

  equals_1;

  function _indexOf$1(list, a, idx) {
    var inf, item; // Array.prototype.indexOf doesn't exist below IE9

    if (typeof list.indexOf === 'function') {
      switch (typeof a) {
        case 'number':
          if (a === 0) {
            // manually crawl the list to distinguish between +0 and -0
            inf = 1 / a;

            while (idx < list.length) {
              item = list[idx];

              if (item === 0 && 1 / item === inf) {
                return idx;
              }

              idx += 1;
            }

            return -1;
          } else if (a !== a) {
            // NaN
            while (idx < list.length) {
              item = list[idx];

              if (typeof item === 'number' && item !== item) {
                return idx;
              }

              idx += 1;
            }

            return -1;
          } // non-zero numbers can utilise Set


          return list.indexOf(a, idx);
        // all these types can utilise Set

        case 'string':
        case 'boolean':
        case 'function':
        case 'undefined':
          return list.indexOf(a, idx);

        case 'object':
          if (a === null) {
            // null can utilise Set
            return list.indexOf(a, idx);
          }

      }
    } // anything else not covered above, defer to R.equals


    while (idx < list.length) {
      if (equals$3(list[idx], a)) {
        return idx;
      }

      idx += 1;
    }

    return -1;
  }

  var _indexOf_1 = _indexOf$1;

  var _indexOf =

  _indexOf_1;

  function _includes$2(a, list) {
    return _indexOf(list, a, 0) >= 0;
  }

  var _includes_1 = _includes$2;

  function _quote$1(s) {
    var escaped = s.replace(/\\/g, '\\\\').replace(/[\b]/g, '\\b') // \b matches word boundary; [\b] matches backspace
    .replace(/\f/g, '\\f').replace(/\n/g, '\\n').replace(/\r/g, '\\r').replace(/\t/g, '\\t').replace(/\v/g, '\\v').replace(/\0/g, '\\0');
    return '"' + escaped.replace(/"/g, '\\"') + '"';
  }

  var _quote_1 = _quote$1;

  /**
   * Polyfill from <https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toISOString>.
   */

  var pad = function pad(n) {
    return (n < 10 ? '0' : '') + n;
  };

  var _toISOString$1 = typeof Date.prototype.toISOString === 'function' ? function _toISOString(d) {
    return d.toISOString();
  } : function _toISOString(d) {
    return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate()) + 'T' + pad(d.getUTCHours()) + ':' + pad(d.getUTCMinutes()) + ':' + pad(d.getUTCSeconds()) + '.' + (d.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) + 'Z';
  };

  var _toISOString_1 = _toISOString$1;

  function _complement$1(f) {
    return function () {
      return !f.apply(this, arguments);
    };
  }

  var _complement_1 = _complement$1;

  var _complement =

  _complement_1;

  var _curry2$t =

  _curry2_1;

  var filter$1 =

  filter_1;
  /**
   * The complement of [`filter`](#filter).
   *
   * Acts as a transducer if a transformer is given in list position. Filterable
   * objects include plain objects or any object that has a filter method such
   * as `Array`.
   *
   * @func
   * @memberOf R
   * @since v0.1.0
   * @category List
   * @sig Filterable f => (a -> Boolean) -> f a -> f a
   * @param {Function} pred
   * @param {Array} filterable
   * @return {Array}
   * @see R.filter, R.transduce, R.addIndex
   * @example
   *
   *      const isOdd = (n) => n % 2 === 1;
   *
   *      R.reject(isOdd, [1, 2, 3, 4]); //=> [2, 4]
   *
   *      R.reject(isOdd, {a: 1, b: 2, c: 3, d: 4}); //=> {b: 2, d: 4}
   */


  var reject$2 =
  /*#__PURE__*/
  _curry2$t(function reject(pred, filterable) {
    return filter$1(_complement(pred), filterable);
  });

  var reject_1 = reject$2;

  var _includes$1 =

  _includes_1;

  var _map$1 =

  _map_1;

  var _quote =

  _quote_1;

  var _toISOString =

  _toISOString_1;

  var keys$1 =

  keys_1;

  var reject$1 =

  reject_1;

  function _toString$1(x, seen) {
    var recur = function recur(y) {
      var xs = seen.concat([x]);
      return _includes$1(y, xs) ? '<Circular>' : _toString$1(y, xs);
    }; //  mapPairs :: (Object, [String]) -> [String]


    var mapPairs = function (obj, keys) {
      return _map$1(function (k) {
        return _quote(k) + ': ' + recur(obj[k]);
      }, keys.slice().sort());
    };

    switch (Object.prototype.toString.call(x)) {
      case '[object Arguments]':
        return '(function() { return arguments; }(' + _map$1(recur, x).join(', ') + '))';

      case '[object Array]':
        return '[' + _map$1(recur, x).concat(mapPairs(x, reject$1(function (k) {
          return /^\d+$/.test(k);
        }, keys$1(x)))).join(', ') + ']';

      case '[object Boolean]':
        return typeof x === 'object' ? 'new Boolean(' + recur(x.valueOf()) + ')' : x.toString();

      case '[object Date]':
        return 'new Date(' + (isNaN(x.valueOf()) ? recur(NaN) : _quote(_toISOString(x))) + ')';

      case '[object Null]':
        return 'null';

      case '[object Number]':
        return typeof x === 'object' ? 'new Number(' + recur(x.valueOf()) + ')' : 1 / x === -Infinity ? '-0' : x.toString(10);

      case '[object String]':
        return typeof x === 'object' ? 'new String(' + recur(x.valueOf()) + ')' : _quote(x);

      case '[object Undefined]':
        return 'undefined';

      default:
        if (typeof x.toString === 'function') {
          var repr = x.toString();

          if (repr !== '[object Object]') {
            return repr;
          }
        }

        return '{' + mapPairs(x, keys$1(x)).join(', ') + '}';
    }
  }

  var _toString_1 = _toString$1;

  var _curry1$c =

  _curry1_1;

  var _toString =

  _toString_1;
  /**
   * Returns the string representation of the given value. `eval`'ing the output
   * should result in a value equivalent to the input value. Many of the built-in
   * `toString` methods do not satisfy this requirement.
   *
   * If the given value is an `[object Object]` with a `toString` method other
   * than `Object.prototype.toString`, this method is invoked with no arguments
   * to produce the return value. This means user-defined constructor functions
   * can provide a suitable `toString` method. For example:
   *
   *     function Point(x, y) {
   *       this.x = x;
   *       this.y = y;
   *     }
   *
   *     Point.prototype.toString = function() {
   *       return 'new Point(' + this.x + ', ' + this.y + ')';
   *     };
   *
   *     R.toString(new Point(1, 2)); //=> 'new Point(1, 2)'
   *
   * @func
   * @memberOf R
   * @since v0.14.0
   * @category String
   * @sig * -> String
   * @param {*} val
   * @return {String}
   * @example
   *
   *      R.toString(42); //=> '42'
   *      R.toString('abc'); //=> '"abc"'
   *      R.toString([1, 2, 3]); //=> '[1, 2, 3]'
   *      R.toString({foo: 1, bar: 2, baz: 3}); //=> '{"bar": 2, "baz": 3, "foo": 1}'
   *      R.toString(new Date('2001-02-03T04:05:06Z')); //=> 'new Date("2001-02-03T04:05:06.000Z")'
   */


  var toString$2 =
  /*#__PURE__*/
  _curry1$c(function toString(val) {
    return _toString(val, []);
  });

  var toString_1 = toString$2;

  var _curry2$s =

  _curry2_1;

  var _isArray$1 =

  _isArray$5;

  var _isFunction =

  _isFunction_1;

  var _isString$1 =

  _isString_1;

  var toString$1 =

  toString_1;
  /**
   * Returns the result of concatenating the given lists or strings.
   *
   * Note: `R.concat` expects both arguments to be of the same type,
   * unlike the native `Array.prototype.concat` method. It will throw
   * an error if you `concat` an Array with a non-Array value.
   *
   * Dispatches to the `concat` method of the first argument, if present.
   * Can also concatenate two members of a [fantasy-land
   * compatible semigroup](https://github.com/fantasyland/fantasy-land#semigroup).
   *
   * @func
   * @memberOf R
   * @since v0.1.0
   * @category List
   * @sig [a] -> [a] -> [a]
   * @sig String -> String -> String
   * @param {Array|String} firstList The first list
   * @param {Array|String} secondList The second list
   * @return {Array|String} A list consisting of the elements of `firstList` followed by the elements of
   * `secondList`.
   *
   * @example
   *
   *      R.concat('ABC', 'DEF'); // 'ABCDEF'
   *      R.concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
   *      R.concat([], []); //=> []
   */


  var concat =
  /*#__PURE__*/
  _curry2$s(function concat(a, b) {
    if (_isArray$1(a)) {
      if (_isArray$1(b)) {
        return a.concat(b);
      }

      throw new TypeError(toString$1(b) + ' is not an array');
    }

    if (_isString$1(a)) {
      if (_isString$1(b)) {
        return a + b;
      }

      throw new TypeError(toString$1(b) + ' is not a string');
    }

    if (a != null && _isFunction(a['fantasy-land/concat'])) {
      return a['fantasy-land/concat'](b);
    }

    if (a != null && _isFunction(a.concat)) {
      return a.concat(b);
    }

    throw new TypeError(toString$1(a) + ' does not have a method named "concat" or "fantasy-land/concat"');
  });

  var concat_1 = concat;

  var concat$1 = concat_1;

  var _curry2$r =

  _curry2_1;
  /**
   * Returns the second argument if it is not `null`, `undefined` or `NaN`;
   * otherwise the first argument is returned.
   *
   * @func
   * @memberOf R
   * @since v0.10.0
   * @category Logic
   * @sig a -> b -> a | b
   * @param {a} default The default value.
   * @param {b} val `val` will be returned instead of `default` unless `val` is `null`, `undefined` or `NaN`.
   * @return {*} The second value if it is not `null`, `undefined` or `NaN`, otherwise the default value
   * @example
   *
   *      const defaultTo42 = R.defaultTo(42);
   *
   *      defaultTo42(null);  //=> 42
   *      defaultTo42(undefined);  //=> 42
   *      defaultTo42(false);  //=> false
   *      defaultTo42('Ramda');  //=> 'Ramda'
   *      // parseInt('string') results in NaN
   *      defaultTo42(parseInt('string')); //=> 42
   */


  var defaultTo =
  /*#__PURE__*/
  _curry2$r(function defaultTo(d, v) {
    return v == null || v !== v ? d : v;
  });

  var defaultTo_1 = defaultTo;

  var defaultTo$1 = defaultTo_1;

  var _curry1$b =

  _curry1_1;

  var _isArguments =

  _isArguments_1;

  var _isArray =

  _isArray$5;

  var _isObject$1 =

  _isObject_1;

  var _isString =

  _isString_1;
  /**
   * Returns the empty value of its argument's type. Ramda defines the empty
   * value of Array (`[]`), Object (`{}`), String (`''`), and Arguments. Other
   * types are supported if they define `<Type>.empty`,
   * `<Type>.prototype.empty` or implement the
   * [FantasyLand Monoid spec](https://github.com/fantasyland/fantasy-land#monoid).
   *
   * Dispatches to the `empty` method of the first argument, if present.
   *
   * @func
   * @memberOf R
   * @since v0.3.0
   * @category Function
   * @sig a -> a
   * @param {*} x
   * @return {*}
   * @example
   *
   *      R.empty(Just(42));      //=> Nothing()
   *      R.empty([1, 2, 3]);     //=> []
   *      R.empty('unicorns');    //=> ''
   *      R.empty({x: 1, y: 2});  //=> {}
   */


  var empty$1 =
  /*#__PURE__*/
  _curry1$b(function empty(x) {
    return x != null && typeof x['fantasy-land/empty'] === 'function' ? x['fantasy-land/empty']() : x != null && x.constructor != null && typeof x.constructor['fantasy-land/empty'] === 'function' ? x.constructor['fantasy-land/empty']() : x != null && typeof x.empty === 'function' ? x.empty() : x != null && x.constructor != null && typeof x.constructor.empty === 'function' ? x.constructor.empty() : _isArray(x) ? [] : _isString(x) ? '' : _isObject$1(x) ? {} : _isArguments(x) ? function () {
      return arguments;
    }() : void 0 // else
    ;
  });

  var empty_1 = empty$1;

  var _curry1$a =

  _curry1_1;

  var empty =

  empty_1;

  var equals$2 =

  equals_1;
  /**
   * Returns `true` if the given value is its type's empty value; `false`
   * otherwise.
   *
   * @func
   * @memberOf R
   * @since v0.1.0
   * @category Logic
   * @sig a -> Boolean
   * @param {*} x
   * @return {Boolean}
   * @see R.empty
   * @example
   *
   *      R.isEmpty([1, 2, 3]);   //=> false
   *      R.isEmpty([]);          //=> true
   *      R.isEmpty('');          //=> true
   *      R.isEmpty(null);        //=> false
   *      R.isEmpty({});          //=> true
   *      R.isEmpty({length: 0}); //=> false
   */


  var isEmpty =
  /*#__PURE__*/
  _curry1$a(function isEmpty(x) {
    return x != null && equals$2(x, empty(x));
  });

  var isEmpty_1 = isEmpty;

  var isEmpty$1 = isEmpty_1;

  var _curry3$6 =

  _curry3_1;
  /**
   * Tests the final argument by passing it to the given predicate function. If
   * the predicate is not satisfied, the function will return the result of
   * calling the `whenFalseFn` function with the same argument. If the predicate
   * is satisfied, the argument is returned as is.
   *
   * @func
   * @memberOf R
   * @since v0.18.0
   * @category Logic
   * @sig (a -> Boolean) -> (a -> a) -> a -> a
   * @param {Function} pred        A predicate function
   * @param {Function} whenFalseFn A function to invoke when the `pred` evaluates
   *                               to a falsy value.
   * @param {*}        x           An object to test with the `pred` function and
   *                               pass to `whenFalseFn` if necessary.
   * @return {*} Either `x` or the result of applying `x` to `whenFalseFn`.
   * @see R.ifElse, R.when, R.cond
   * @example
   *
   *      let safeInc = R.unless(R.isNil, R.inc);
   *      safeInc(null); //=> null
   *      safeInc(1); //=> 2
   */


  var unless =
  /*#__PURE__*/
  _curry3$6(function unless(pred, whenFalseFn, x) {
    return pred(x) ? x : whenFalseFn(x);
  });

  var unless_1 = unless;

  var unless$1 = unless_1;

  function mergeParams(p1, p2) {
    const params = new URLSearchParams(p1);
    new URLSearchParams(p2).forEach((val, key) => {
      params.append(key, val);
    });
    return params.toString();
  }

  // Helper for determining if a value is a primitive data structure
  const isPrim = val =>
    ['string', 'number', 'boolean'].includes(typeof val) || val === null;

  const logical = {
    $and: 'AND',
    $or: 'OR',
  };
  const comparison = {
    $eq: '%3D',
    $ne: '<>',
    $gt: '>',
    $gte: '>=',
    $lt: '<',
    $lte: '<=',
    $in: 'IN',
    $nin: 'NOT%20IN',
  };

  const truthyForms = [true, 1, 'true', 'TRUE', 'T'];
  const falseyForms = [false, 0, 'false', 'FALSE', 'F'];
  const booleanForms = [...truthyForms, ...falseyForms];
  const booleanTransform = bool => (truthyForms.includes(bool) ? 1 : 0);
  function transformRawValue(transform, raw) {
    let value = raw;
    if (typeof transform === 'function') {
      value = transform(value);
    }
    if (booleanForms.includes(value)) {
      value = booleanTransform(value);
    }
    return value;
  }

  function parseFilter(filter = {}, options = {}) {
    const { filterTransforms = {} } = options;

    function parseComparison(path, expr, comGroup = null, index = 0) {
      const amp = index > 0 ? '&' : '';
      const pre = `filter[${path}-${index}-filter][condition]`;
      const membership = comGroup ? `&${pre}[memberOf]=${comGroup}` : '';
      const [[op, rawValue], ...tail] = Object.entries(expr);
      const val = transformRawValue(filterTransforms[path], rawValue);
      if (val === null) {
        const pathStr = `${amp}filter[${path}-filter][condition][path]=${path}`;
        const opStr = `&filter[${path}-filter][condition][operator]=IS%20NULL`;
        return pathStr + opStr + membership;
      }
      const urlEncodedOp = comparison[op];
      if (!urlEncodedOp) throw new Error(`Invalid comparison operator: ${op}`);
      const pathStr = `${amp}${pre}[path]=${path}`;
      const opStr = `&${pre}[operator]=${urlEncodedOp}`;
      const valStr = Array.isArray(val)
        ? val.reduce((substr, v, i) => `${substr}&${pre}[value][${i}]=${v}`, '')
        : `&${pre}[value]=${val}`;
      const str = pathStr + opStr + valStr + membership;
      if (tail.length === 0) return str;
      const nextExpr = Object.fromEntries(tail);
      return str + parseComparison(path, nextExpr, comGroup, index + 1);
    }

    function parseLogic(op, filters, logicGroup, logicDepth) {
      const label = `group-${logicDepth}`;
      const conjunction = `&filter[${label}][group][conjunction]=${logical[op]}`;
      const membership = logicGroup ? `&filter[${label}][condition][memberOf]=${logicGroup}` : '';
      return filters.reduce(
        // eslint-disable-next-line no-use-before-define
        (params, f) => mergeParams(params, parser(f, label, logicDepth + 1)),
        conjunction + membership,
      );
    }

    function parseField(path, val, fieldGroup, fieldDepth) {
      if (isPrim(val)) {
        return parseComparison(path, { $eq: val }, fieldGroup);
      }
      if (Array.isArray(val) || '$or' in val) {
        const arr = Array.isArray(val) ? val : val.$or;
        if (!Array.isArray(arr)) {
          throw new Error(`The value of \`${path}.$or\` must be an array. `
          + `Invalid constructor: ${arr.constructor.name}`);
        }
        const filters = arr.map(v => (isPrim(v) ? { [path]: v } : v));
        return parseLogic('$or', filters, fieldGroup, fieldDepth + 1);
      }
      if ('$and' in val) {
        if (!Array.isArray(val.$and)) {
          throw new Error(`The value of \`${path}.$and\` must be an array. `
          + `Invalid constructor: ${val.$and.constructor.name}`);
        }
        return parseLogic('$and', val.$and, fieldGroup, fieldDepth + 1);
      }
      // Otherwise we assume val is an object and all its properties are comparison
      // operators; parseComparison will throw if any property is NOT a comp op.
      return parseComparison(path, val, fieldGroup);
    }

    const parser = (_filter, group, depth = 0) => {
      if (Array.isArray(_filter)) {
        return parseLogic('$or', _filter, group, depth);
      }
      let params = '';
      const entries = Object.entries(_filter);
      if (entries.length === 0) return params;
      const [[key, val], ...rest] = entries;
      if (['$and', '$or'].includes(key)) {
        params = parseLogic(key, val, group, depth);
      }
      if (key && val !== undefined) {
        params = parseField(key, val, group, depth);
      }
      if (rest.length === 0) return params;
      const tailParams = parser(Object.fromEntries(rest));
      return mergeParams(params, tailParams);
    };

    return parser(filter);
  }

  /**
   * @typedef {Object} FetchOptions
   * @property {Object} [filter]
   * @property {Object} [filterTransforms]
   * @property {Array|String} [include]
   * @property {Number} [limit]
   * @property {Object} [sort]
   */

  /**
   * farmOS client method for fetching entities from a Drupal JSON:API server
   * @typedef {Function} fetchEntity
   * @param {String} bundle The bundle type (eg, 'activity', 'equipment', etc).
   * @param {FetchOptions} [options] Options for the fetch request.
   * @returns {Promise}
   */

  /** @type {(limit: Number?) => String} */
  const parseLimit = limit =>
    (Number.isInteger(limit) && limit > 0 ? `&page[limit]=${limit}` : '');
  const concatSortParams = (prev, [path, direction]) =>
    `${prev !== '' ? ',' : ''}${direction === 'DESC' ? '-' : ''}${path}`;
  /** @type {(sort: Object?) => String} */
  const parseSort = compose$1(
    unless$1(isEmpty$1, concat$1('&sort=')),
    reduce$6(concatSortParams, ''),
    Object.entries,
    defaultTo$1({}),
  );

  /** @type {(sort: Array) => String} */
  const parseIncludeArray = reduce$6(
    (params, str) => `${params || '&include='}${params ? ',' : ''}${str}`,
    '',
  );
  /** @type {(sort: Array|String?) => String} */
  const parseInclude = include => {
    if (Array.isArray(include)) return parseIncludeArray(include);
    if (!include || typeof include !== 'string') return '';
    return `&include=${include}`;
  };

  /**
   * @param {FetchOptions} options
   * @returns {String}
   */
  function parseFetchParams(options = {}) {
    const {
      filter, filterTransforms, include, limit, sort,
    } = options;
    const filterParams = parseFilter(filter, { filterTransforms });
    const limitParams = parseLimit(limit);
    const sortParams = parseSort(sort);
    const includeParams = parseInclude(include);
    return filterParams + limitParams + sortParams + includeParams;
  }

  /**
   * @param {String} entity
   * @param {Function} request
   * @returns {fetchEntity}
   */
  const fetchEntity = (entity, request) => (bundle, options) =>
    request(`/api/${entity}/${bundle}?${parseFetchParams(options)}`);

  var _curry3$5 =

  _curry3_1;

  var _has$2 =

  _has_1;
  /**
   * Creates a new object with the own properties of the two provided objects. If
   * a key exists in both objects, the provided function is applied to the key
   * and the values associated with the key in each object, with the result being
   * used as the value associated with the key in the returned object.
   *
   * @func
   * @memberOf R
   * @since v0.19.0
   * @category Object
   * @sig ((String, a, a) -> a) -> {a} -> {a} -> {a}
   * @param {Function} fn
   * @param {Object} l
   * @param {Object} r
   * @return {Object}
   * @see R.mergeDeepWithKey, R.merge, R.mergeWith
   * @example
   *
   *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
   *      R.mergeWithKey(concatValues,
   *                     { a: true, thing: 'foo', values: [10, 20] },
   *                     { b: true, thing: 'bar', values: [15, 35] });
   *      //=> { a: true, b: true, thing: 'bar', values: [10, 20, 15, 35] }
   * @symb R.mergeWithKey(f, { x: 1, y: 2 }, { y: 5, z: 3 }) = { x: 1, y: f('y', 2, 5), z: 3 }
   */


  var mergeWithKey$2 =
  /*#__PURE__*/
  _curry3$5(function mergeWithKey(fn, l, r) {
    var result = {};
    var k;

    for (k in l) {
      if (_has$2(k, l)) {
        result[k] = _has$2(k, r) ? fn(k, l[k], r[k]) : l[k];
      }
    }

    for (k in r) {
      if (_has$2(k, r) && !_has$2(k, result)) {
        result[k] = r[k];
      }
    }

    return result;
  });

  var mergeWithKey_1 = mergeWithKey$2;

  var _curry3$4 =

  _curry3_1;

  var _isObject =

  _isObject_1;

  var mergeWithKey$1 =

  mergeWithKey_1;
  /**
   * Creates a new object with the own properties of the two provided objects.
   * If a key exists in both objects:
   * - and both associated values are also objects then the values will be
   *   recursively merged.
   * - otherwise the provided function is applied to the key and associated values
   *   using the resulting value as the new value associated with the key.
   * If a key only exists in one object, the value will be associated with the key
   * of the resulting object.
   *
   * @func
   * @memberOf R
   * @since v0.24.0
   * @category Object
   * @sig ((String, a, a) -> a) -> {a} -> {a} -> {a}
   * @param {Function} fn
   * @param {Object} lObj
   * @param {Object} rObj
   * @return {Object}
   * @see R.mergeWithKey, R.mergeDeepWith
   * @example
   *
   *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
   *      R.mergeDeepWithKey(concatValues,
   *                         { a: true, c: { thing: 'foo', values: [10, 20] }},
   *                         { b: true, c: { thing: 'bar', values: [15, 35] }});
   *      //=> { a: true, b: true, c: { thing: 'bar', values: [10, 20, 15, 35] }}
   */


  var mergeDeepWithKey =
  /*#__PURE__*/
  _curry3$4(function mergeDeepWithKey(fn, lObj, rObj) {
    return mergeWithKey$1(function (k, lVal, rVal) {
      if (_isObject(lVal) && _isObject(rVal)) {
        return mergeDeepWithKey(fn, lVal, rVal);
      } else {
        return fn(k, lVal, rVal);
      }
    }, lObj, rObj);
  });

  var mergeDeepWithKey_1 = mergeDeepWithKey;

  var mergeDeepWithKey$1 = mergeDeepWithKey_1;

  var _curry2$q =

  _curry2_1;
  /**
   * Returns a partial copy of an object containing only the keys specified. If
   * the key does not exist, the property is ignored.
   *
   * @func
   * @memberOf R
   * @since v0.1.0
   * @category Object
   * @sig [k] -> {k: v} -> {k: v}
   * @param {Array} names an array of String property names to copy onto a new object
   * @param {Object} obj The object to copy from
   * @return {Object} A new object with only properties from `names` on it.
   * @see R.omit, R.props
   * @example
   *
   *      R.pick(['a', 'd'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1, d: 4}
   *      R.pick(['a', 'e', 'f'], {a: 1, b: 2, c: 3, d: 4}); //=> {a: 1}
   */


  var pick =
  /*#__PURE__*/
  _curry2$q(function pick(names, obj) {
    var result = {};
    var idx = 0;

    while (idx < names.length) {
      if (names[idx] in obj) {
        result[names[idx]] = obj[names[idx]];
      }

      idx += 1;
    }

    return result;
  });

  var pick_1 = pick;

  var pick$1 = pick_1;

  var _curry2$p =

  _curry2_1;
  /**
   * Tests a regular expression against a String. Note that this function will
   * return an empty array when there are no matches. This differs from
   * [`String.prototype.match`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/match)
   * which returns `null` when there are no matches.
   *
   * @func
   * @memberOf R
   * @since v0.1.0
   * @category String
   * @sig RegExp -> String -> [String | Undefined]
   * @param {RegExp} rx A regular expression.
   * @param {String} str The string to match against
   * @return {Array} The list of matches or empty array.
   * @see R.test
   * @example
   *
   *      R.match(/([a-z]a)/g, 'bananas'); //=> ['ba', 'na', 'na']
   *      R.match(/a/, 'b'); //=> []
   *      R.match(/a/, null); //=> TypeError: null does not have a method named "match"
   */


  var match =
  /*#__PURE__*/
  _curry2$p(function match(rx, str) {
    return str.match(rx) || [];
  });

  var match_1 = match;

  var match$1 = match_1;

  var _curry2$o =

  _curry2_1;
  /**
   * Wraps a function of any arity (including nullary) in a function that accepts
   * exactly `n` parameters. Any extraneous parameters will not be passed to the
   * supplied function.
   *
   * @func
   * @memberOf R
   * @since v0.1.0
   * @category Function
   * @sig Number -> (* -> a) -> (* -> a)
   * @param {Number} n The desired arity of the new function.
   * @param {Function} fn The function to wrap.
   * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
   *         arity `n`.
   * @see R.binary, R.unary
   * @example
   *
   *      const takesTwoArgs = (a, b) => [a, b];
   *
   *      takesTwoArgs.length; //=> 2
   *      takesTwoArgs(1, 2); //=> [1, 2]
   *
   *      const takesOneArg = R.nAry(1, takesTwoArgs);
   *      takesOneArg.length; //=> 1
   *      // Only `n` arguments are passed to the wrapped function
   *      takesOneArg(1, 2); //=> [1, undefined]
   * @symb R.nAry(0, f)(a, b) = f()
   * @symb R.nAry(1, f)(a, b) = f(a)
   * @symb R.nAry(2, f)(a, b) = f(a, b)
   */


  var nAry$1 =
  /*#__PURE__*/
  _curry2$o(function nAry(n, fn) {
    switch (n) {
      case 0:
        return function () {
          return fn.call(this);
        };

      case 1:
        return function (a0) {
          return fn.call(this, a0);
        };

      case 2:
        return function (a0, a1) {
          return fn.call(this, a0, a1);
        };

      case 3:
        return function (a0, a1, a2) {
          return fn.call(this, a0, a1, a2);
        };

      case 4:
        return function (a0, a1, a2, a3) {
          return fn.call(this, a0, a1, a2, a3);
        };

      case 5:
        return function (a0, a1, a2, a3, a4) {
          return fn.call(this, a0, a1, a2, a3, a4);
        };

      case 6:
        return function (a0, a1, a2, a3, a4, a5) {
          return fn.call(this, a0, a1, a2, a3, a4, a5);
        };

      case 7:
        return function (a0, a1, a2, a3, a4, a5, a6) {
          return fn.call(this, a0, a1, a2, a3, a4, a5, a6);
        };

      case 8:
        return function (a0, a1, a2, a3, a4, a5, a6, a7) {
          return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7);
        };

      case 9:
        return function (a0, a1, a2, a3, a4, a5, a6, a7, a8) {
          return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7, a8);
        };

      case 10:
        return function (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
          return fn.call(this, a0, a1, a2, a3, a4, a5, a6, a7, a8, a9);
        };

      default:
        throw new Error('First argument to nAry must be a non-negative integer no greater than ten');
    }
  });

  var nAry_1 = nAry$1;

  var _curry1$9 =

  _curry1_1;

  var nAry =

  nAry_1;
  /**
   * Wraps a function of any arity (including nullary) in a function that accepts
   * exactly 1 parameter. Any extraneous parameters will not be passed to the
   * supplied function.
   *
   * @func
   * @memberOf R
   * @since v0.2.0
   * @category Function
   * @sig (* -> b) -> (a -> b)
   * @param {Function} fn The function to wrap.
   * @return {Function} A new function wrapping `fn`. The new function is guaranteed to be of
   *         arity 1.
   * @see R.binary, R.nAry
   * @example
   *
   *      const takesTwoArgs = function(a, b) {
   *        return [a, b];
   *      };
   *      takesTwoArgs.length; //=> 2
   *      takesTwoArgs(1, 2); //=> [1, 2]
   *
   *      const takesOneArg = R.unary(takesTwoArgs);
   *      takesOneArg.length; //=> 1
   *      // Only 1 argument is passed to the wrapped function
   *      takesOneArg(1, 2); //=> [1, undefined]
   * @symb R.unary(f)(a, b, c) = f(a)
   */


  var unary =
  /*#__PURE__*/
  _curry1$9(function unary(fn) {
    return nAry(1, fn);
  });

  var unary_1 = unary;

  var unary$1 = unary_1;

  /**
   * @type {RegExp} Identifies valid format for an entity type (eg 'log--activity)
   * and groups matches by type, entity & bundle.
   */
  const entityTypeRegEx = /(\w+)--(\w+)/;
  /**
   * @type {Function} Validates a string as an entity type and parses it.
   * @param {String} type A possible entity type (eg, 'log--activity').
   * @returns {{ type?: String, entity?: String, bundle?: String }}
   *  */
  const parseEntityType = unary$1(compose$1(
    ([type, entity, bundle]) => ({ type, entity, bundle }),
    match$1(entityTypeRegEx),
    defaultTo$1(''),
  ));
  /**
   * @type {(fields?: Object) => Object} Takes any object containing entity data,
   * such as props or fields, then normalizes the type, bundle & field.
   * @param {{ type?: String, entity?: String, bundle?: string }} fields
   * @returns {{ type?: String, entity?: String, bundle?: String }}
   */
  function parseTypeFromFields(fields = {}) {
    let { entity, bundle, type } = fields;
    if (type) ({ entity, bundle } = parseEntityType(type));
    if (!type && entity && bundle) type = `${entity}--${bundle}`;
    return { entity, bundle, type };
  }

  /**
   * @typedef {Array<{ type: String, filter: Object|Array }>} FiltersByType
   */
  /**
   * @param {Object|Array|Undefined} filter
   * @param {Array<String>} validTypes
   * @returns {FiltersByType}
   */
  function splitFilterByType(filter, validTypes) {
    /** @type {FiltersByType} */
    const filtersByType = [];

    // A plain array is equivalent to an object w/ an array as the `$or` property.
    // In both cases, the array must itself contain valid filters, which can be
    // evaluated recursively.
    if (Array.isArray(filter.$or) || Array.isArray(filter)) {
      (filter.$or || filter).forEach((f) => {
        splitFilterByType(f, validTypes).forEach((fbtA) => {
          // Instead of just adding every filterByType to the list, look for a
          // matching type that's already been added.
          const fbtB = filtersByType.find(fbtZ => fbtZ.type === fbtA.type);
          // If so, combine them into a single object w/ an array of filters.
          if (fbtB) {
            // Both matching and current filters can be an array or single filter,
            // so concat onto an empty array to flatten them and reassign it.
            fbtB.filter = [].concat(fbtB.filter, fbtA.filter);
          // Otherwise, add the new filterByType to the list entirely as-is.
          } else {
            filtersByType.push(fbtA);
          }
        });
      });
      return filtersByType;
    }

    // The filter must either be an object (logical $and) or an array (logical $or).
    // If it's neither, then it's not a valid filter, so return the empty array.
    if (typeof filter !== 'object') return filtersByType;

    // Technically any object is equivalent to an object w/ an `$and` property,
    // which is itself an object. Also, one type filter is not permitted to be
    // nested under another, so we can safely pluck the type and ignore the rest.
    const { type, ...rest } = typeof filter.$and === 'object' ? filter.$and : filter;

    // The case of filtering by a single type.
    if (typeof type === 'string') {
      if (!validTypes.includes(type)) return filtersByType;
      filtersByType.push({ type, filter: rest });
    }
    // The case of filtering by multiple types.
    if (Array.isArray(type)) {
      type.forEach((t) => {
        if (validTypes.includes(t)) {
          filtersByType.push({ type: t, filter: rest });
        }
      });
    }
    // An undefined or null type is interpreted as ALL types, so push the rest of
    // the filter properties onto the array for each and every valid type.
    if ([undefined, null].includes(type)) {
      validTypes.forEach((t) => {
        filtersByType.push({ type: t, filter: rest });
      });
    }
    return filtersByType;
  }

  const toResourceId = compose$1(
    pick$1(['id', 'type']),
    path$2(['data', 'data']),
  );
  const mapResponseData = response =>
    (Array.isArray(response) ? response.map(toResourceId) : toResourceId(response));
  const concatRelationshp = (original, updated) =>
    (Array.isArray(original) ? concat$1(original, updated) : updated);
  const updateRelationship = mergeDeepWithKey$1((key, related, original) =>
    (key === 'data' ? concatRelationshp(original, related) : original));
  // Update the fields on an entity that had files related to it on those fields.
  // The responses are from separate requests to send the files, with a special
  // file entity's id and type contained in the response data. The updated entity
  // is sent in a subsequent request only after all files are sent.
  const updateFileField = reduce$6((entity, [field, response]) => {
    const relationship = {
      relationships: {
        [field]: {
          data: mapResponseData(response),
        },
      },
    };
    return updateRelationship(entity, relationship);
  });
  const toRequestConfig = curryN$7(2, (url, { data = null, filename = 'untitled' } = {}) => {
    if (!data) return Promise.resolve(null);
    const headers = {
      'Content-Type': 'application/octet-stream',
      'Content-Disposition': `file; filename="${filename}"`,
    };
    return {
      data, headers, method: 'POST', url,
    };
  });

  function sendFiles(request, hostEntity, files = {}) {
    const { entity, bundle } = parseTypeFromFields(hostEntity);
    const fileRequests = Object.entries(files).map(([field, attributes]) => {
      const url = `/api/${entity}/${bundle}/${field}`;
      const sendFile = compose$1(request, toRequestConfig(url));
      const promise = Array.isArray(attributes)
        ? Promise.all(attributes.map(sendFile))
        : sendFile(attributes);
      return promise.then(response => [field, response]);
    });

    return Promise.all(fileRequests).then(updateFileField(hostEntity));
  }

  /**
   * @typedef {Object} SendOptions
   * @property {Object} [files]
   */
  /**
   * farmOS client method for sending an entity to a Drupal JSON:API server
   * @typedef {Function} sendEntity
   * @param {String} bundle The bundle type (eg, 'activity', 'equipment', etc).
   * @param {Object} entity The entity being sent to the server.
   * @param {SendOptions} [options]
   * @returns {Promise}
   */

  /**
   * @type {Function}
   * @param {String} entityName
   * @param {Function} request
   * @returns {sendEntity}
   */
  var sendEntity = (entityName, request) => function send(bundle, entity, options = {}) {
    const post = data => request({
      data: JSON.stringify({ data }),
      method: 'POST',
      url: `/api/${entityName}/${bundle}`,
    });
    const patch = data => request({
      data: JSON.stringify({ data }),
      method: 'PATCH',
      url: `/api/${entityName}/${bundle}/${data.id}`,
    });
    const is404 = error => error.response && error.response.status === 404;

    function sendEntity(data) {
      if (!data.id) return post(data);
      // We assume if an entity has an id it is a PATCH request, but that may not be
      // the case if it has a client-generated id. Such a PATCH request will result
      // in a 404 (NOT FOUND), since the endpoint includes the id. We handle this
      // error with a POST request, but otherwise return a rejected promise.
      return patch(data).catch(e => (is404(e) ? post(data) : Promise.reject(e)));
    }

    if (!options.files) return sendEntity(entity);
    return sendFiles(request, entity, options.files).then(sendEntity);
  };

  /**
   * @typedef {Object} OAuthMethods
   * @property {Function} authorize
   * @property {Function} getToken
   */

  /**
   * @typedef {Function} OAuthMixin
   * @param {import('axios').AxiosInstance} request
   * @param {Object} authOptions
   * @property {String} authOptions.host
   * @property {String} authOptions.clientId
   * @property {Function} [authOptions.getToken]
   * @property {Function} [authOptions.setToken]
   * @returns {Object}
   */
  function oAuth(request, authOptions) {
    let memToken = {};
    const {
      host = '',
      clientId = '',
      getToken = () => memToken,
      setToken = (t) => { memToken = t; },
    } = authOptions;
    const accessTokenUri = `${host}/oauth/token`;

    /*
     * SUBSCRIBE TO TOKEN REFRESH
     * Based on https://gist.github.com/mkjiau/650013a99c341c9f23ca00ccb213db1c
     */
    // Keep track if the OAuth token is being refreshed.
    let isRefreshing = false;

    // Array of callbacks to call once token is refreshed.
    let subscribers = [];

    // Add to array of callbacks.
    function subscribeTokenRefresh(resolve, reject) {
      subscribers.push({ resolve, reject });
    }

    // Call all subscribers.
    function onRefreshed(token) {
      subscribers.forEach(({ resolve }) => { resolve(token); });
    }

    // Make sure promises fulfill with a rejection if the refresh fails.
    function onFailedRefresh(error) {
      subscribers.forEach(({ reject }) => { reject(error); });
    }

    // Helper function to parse tokens from server.
    function parseToken(token) {
      // Calculate new expiration time.
      const newToken = !token.expires
        ? { ...token, expires: (Date.now() + token.expires_in * 1000) }
        : token;

      // Update the token state.
      setToken(newToken);

      return newToken;
    }

    // Helper function to refresh OAuth2 token.
    function refreshToken(token) {
      isRefreshing = true;
      const refreshParams = new URLSearchParams();
      refreshParams.append('grant_type', 'refresh_token');
      refreshParams.append('client_id', clientId);
      refreshParams.append('refresh_token', token);
      return axios.post(accessTokenUri, refreshParams)
        .then((res) => {
          const newToken = parseToken(res.data);
          isRefreshing = false;
          onRefreshed(newToken.access_token);
          subscribers = [];
          return newToken;
        })
        .catch((error) => {
          onFailedRefresh(error);
          subscribers = [];
          isRefreshing = false;
          throw error;
        });
    }

    // Helper function to get an OAuth access token.
    // This will attempt to refresh the token if needed.
    // Returns a Promise that resvoles as the access token.
    function getAccessToken(token) {
      // Wait for new access token if currently refreshing.
      if (isRefreshing) {
        return new Promise(subscribeTokenRefresh);
      }

      // Refresh if token expired.
      // - 1000 ms to factor for tokens that might expire while in flight.
      if (!isRefreshing && token.expires - 1000 < Date.now()) {
        return new Promise((resolve, reject) => {
          refreshToken(token.refresh_token)
            .then(t => resolve(t.access_token))
            .catch(reject);
        });
      }

      // Else return the current access token.
      return Promise.resolve(token.access_token);
    }

    // Add axios request interceptor to the client.
    // This adds the Authorization Bearer token header.
    request.interceptors.request.use(
      config => getAccessToken(getToken() || {})
        .then(accessToken => ({
          ...config,
          headers: {
            ...config.headers,
            // Only add access token to header.
            Authorization: `Bearer ${accessToken}`,
          },
        }))
        .catch((error) => { throw error; }),
      Promise.reject,
    );

    // Add axios response interceptor to the client.
    // This tries to resolve 403 errors due to expired tokens.
    request.interceptors.response.use(undefined, (err) => {
      const { config } = err;
      const originalRequest = config;

      if (err.response && err.response.status === 403) {
        // Refresh the token and retry.
        if (!isRefreshing) {
          isRefreshing = true;
          const token = getToken();
          return refreshToken(token ? token.refresh_token : {}).then((t) => {
            originalRequest.headers.Authorization = `Bearer ${t.access_token}`;
            return axios(originalRequest);
          }).catch((error) => { throw error; });
        }
        // Else subscribe for new access token after refresh.
        const requestSubscribers = new Promise((resolve, reject) => {
          subscribeTokenRefresh(
            (token) => {
              originalRequest.headers.Authorization = `Bearer ${token}`;
              resolve(axios(originalRequest));
            },
            reject,
          );
        });
        return requestSubscribers;
      }
      throw err;
    });
    return {
      authorize: (user, password) => axios(accessTokenUri, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Accept: 'json',
        },
        data: `grant_type=password&username=${user}&password=${password}&client_id=${clientId}`,
      }).then(res => parseToken(res.data)).catch((error) => { throw error; }),
      getToken,
    };
  }

  /**
   * Private `concat` function to merge two array-like objects.
   *
   * @private
   * @param {Array|Arguments} [set1=[]] An array-like object.
   * @param {Array|Arguments} [set2=[]] An array-like object.
   * @return {Array} A new, merged array.
   * @example
   *
   *      _concat([4, 5, 6], [1, 2, 3]); //=> [4, 5, 6, 1, 2, 3]
   */

  function _concat$2(set1, set2) {
    set1 = set1 || [];
    set2 = set2 || [];
    var idx;
    var len1 = set1.length;
    var len2 = set2.length;
    var result = [];
    idx = 0;

    while (idx < len1) {
      result[result.length] = set1[idx];
      idx += 1;
    }

    idx = 0;

    while (idx < len2) {
      result[result.length] = set2[idx];
      idx += 1;
    }

    return result;
  }

  var _concat_1 = _concat$2;

  var _concat$1 =

  _concat_1;

  var _curry2$n =

  _curry2_1;
  /**
   * Returns a new list containing the contents of the given list, followed by
   * the given element.
   *
   * @func
   * @memberOf R
   * @since v0.1.0
   * @category List
   * @sig a -> [a] -> [a]
   * @param {*} el The element to add to the end of the new list.
   * @param {Array} list The list of elements to add a new item to.
   *        list.
   * @return {Array} A new list containing the elements of the old list followed by `el`.
   * @see R.prepend
   * @example
   *
   *      R.append('tests', ['write', 'more']); //=> ['write', 'more', 'tests']
   *      R.append('tests', []); //=> ['tests']
   *      R.append(['tests'], ['write', 'more']); //=> ['write', 'more', ['tests']]
   */


  var append =
  /*#__PURE__*/
  _curry2$n(function append(el, list) {
    return _concat$1(list, [el]);
  });

  var append_1 = append;

  var append$1 = append_1;

  var _curry1$8 =

  _curry1_1;

  var curryN$4 =

  curryN_1;
  /**
   * Returns a curried equivalent of the provided function. The curried function
   * has two unusual capabilities. First, its arguments needn't be provided one
   * at a time. If `f` is a ternary function and `g` is `R.curry(f)`, the
   * following are equivalent:
   *
   *   - `g(1)(2)(3)`
   *   - `g(1)(2, 3)`
   *   - `g(1, 2)(3)`
   *   - `g(1, 2, 3)`
   *
   * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
   * "gaps", allowing partial application of any combination of arguments,
   * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
   * the following are equivalent:
   *
   *   - `g(1, 2, 3)`
   *   - `g(_, 2, 3)(1)`
   *   - `g(_, _, 3)(1)(2)`
   *   - `g(_, _, 3)(1, 2)`
   *   - `g(_, 2)(1)(3)`
   *   - `g(_, 2)(1, 3)`
   *   - `g(_, 2)(_, 3)(1)`
   *
   * @func
   * @memberOf R
   * @since v0.1.0
   * @category Function
   * @sig (* -> a) -> (* -> a)
   * @param {Function} fn The function to curry.
   * @return {Function} A new, curried function.
   * @see R.curryN, R.partial
   * @example
   *
   *      const addFourNumbers = (a, b, c, d) => a + b + c + d;
   *
   *      const curriedAddFourNumbers = R.curry(addFourNumbers);
   *      const f = curriedAddFourNumbers(1, 2);
   *      const g = f(3);
   *      g(4); //=> 10
   */


  var curry =
  /*#__PURE__*/
  _curry1$8(function curry(fn) {
    return curryN$4(fn.length, fn);
  });

  var curry_1 = curry;

  var curry$1 = curry_1;

  var _curry2$m =

  _curry2_1;
  /**
   * Creates a new object by recursively evolving a shallow copy of `object`,
   * according to the `transformation` functions. All non-primitive properties
   * are copied by reference.
   *
   * A `transformation` function will not be invoked if its corresponding key
   * does not exist in the evolved object.
   *
   * @func
   * @memberOf R
   * @since v0.9.0
   * @category Object
   * @sig {k: (v -> v)} -> {k: v} -> {k: v}
   * @param {Object} transformations The object specifying transformation functions to apply
   *        to the object.
   * @param {Object} object The object to be transformed.
   * @return {Object} The transformed object.
   * @example
   *
   *      const tomato = {firstName: '  Tomato ', data: {elapsed: 100, remaining: 1400}, id:123};
   *      const transformations = {
   *        firstName: R.trim,
   *        lastName: R.trim, // Will not get invoked.
   *        data: {elapsed: R.add(1), remaining: R.add(-1)}
   *      };
   *      R.evolve(transformations, tomato); //=> {firstName: 'Tomato', data: {elapsed: 101, remaining: 1399}, id:123}
   */


  var evolve =
  /*#__PURE__*/
  _curry2$m(function evolve(transformations, object) {
    var result = object instanceof Array ? [] : {};
    var transformation, key, type;

    for (key in object) {
      transformation = transformations[key];
      type = typeof transformation;
      result[key] = type === 'function' ? transformation(object[key]) : transformation && type === 'object' ? evolve(transformation, object[key]) : object[key];
    }

    return result;
  });

  var evolve_1 = evolve;

  var evolve$1 = evolve_1;

  /** @type {(x: any) => Boolean} */
  const isObject = x => typeof x === 'object' && x !== null;

  const reduceObjIndexed = curry$1((fn, init, obj) => reduce$6(
    (acc, [key, val]) => fn(acc, val, key),
    init,
    Object.entries(obj),
  ));

  const createObserver = () => {
    const listeners = new Map();
    const subscribe = ((callback) => {
      listeners.set(callback, callback);
      return () => {
        listeners.delete(callback);
      };
    });
    const next = (event) => {
      listeners.forEach((callback) => {
        callback(event);
      });
    };
    return { subscribe, next };
  };

  /**
   * @template D
   */
  /**
  /**
   * @typedef {{ data: D, fulfilled: any[], rejected: any[] }} AltogetherResult
   * @property {D} data
   * @property {any[]} fulfilled
   * @property {any[]} rejected
   */
  /**
   * @typedef {(promises: Promise[]) => AltogetherResult} AltogetherPartial
   */

  /**
   * Handles a list of promises of compatible type that will be executed in parallel.
   * It wraps `Promise.allSettled()` and partitions the results based on their status,
   * 'fulfilled' or 'rejected', while also applying a transform function that iterates
   * through all fulfilled values and returns the cumulated result as 'data'.
   * @typedef {Function} altogether
   * @param {Function} transform
   * @param {D} [initData=null]
   * @param {Promise[]} [promises=[]]
   * @returns {Promise<AltogetherPartial|AltogetherResult>}
   */
  const altogether = curry$1((transform, initData, promises) =>
    Promise.allSettled(promises || []).then(reduce$6((all, result) => {
      const { reason, value, status } = result;
      if (status === 'fulfilled') {
        return evolve$1({
          data: d => transform(value, d),
          fulfilled: append$1(value),
        }, all);
      }
      return evolve$1({
        rejected: append$1(reason),
      }, all);
    }, { data: initData || null, fulfilled: [], rejected: [] })));

  const byType = {
    string: () => '',
    boolean: () => false,
    object: () => null,
    array: () => [],
  };
  const byFormat = {
    'date-time': () => new Date().toISOString(),
  };
  const defaultOptions = { byType, byFormat };

  /**
   * @typedef {Object} EntityReference
   * @property {String} id A v4 UUID as specified by RFC 4122.
   * @property {String} type Corresponding to the entity bundle (eg, 'activity').
   */

  /**
   * @typedef {Object} Entity
   * @property {String} id A v4 UUID as specified by RFC 4122.
   * @property {String} type The combined form of entity & bundle (eg, 'log--activity').
   * @property {Object} attributes Values directly attributable to this entity.
   * @property {Object.<String, EntityReference|Array.<EntityReference>>} relationships
   * References to other entities that define a one-to-one or one-to-many relationship.
   * @property {Object} meta Non-domain information associated with the creation,
   * modification, storage and transmission of the entity.
   * @property {String} meta.created An ISO 8601 date-time string indicating when
   * the entity was first created, either locally or remotely.
   * @property {String} meta.changed An ISO 8601 date-time string indicating when
   * the entity was last changed, either locally or remotely.
   * @property {Object} meta.remote
   * @property {Object} meta.fieldChanges
   * @property {Array} meta.conflicts
   */

  // Configuration objects for the entities supported by this library.

  /**
   * @typedef {Object} EntityConfig
   * @property {Object} nomenclature
   * @property {Object} nomenclature.name
   * @property {Object} nomenclature.shortName
   * @property {Object} nomenclature.plural
   * @property {Object} nomenclature.shortPlural
   * @property {Object} nomenclature.display
   * @property {Object} nomenclature.displayPlural
   * @property {Object} defaultOptions
   * @property {Object} defaultOptions.byType
   * @property {Object} defaultOptions.byFormat
   */

  /** @type {Object.<String, EntityConfig>} */
  /**
   * @typedef {Object.<String, EntityConfig>} DefaultEntities
   * @property {EntityConfig} asset
   * @property {EntityConfig} log
   * @property {EntityConfig} plan
   * @property {EntityConfig} quantity
   * @property {EntityConfig} taxonomy_term
   * @property {EntityConfig} user
   */
  var defaultEntities = {
    asset: {
      nomenclature: {
        name: 'asset',
        shortName: 'asset',
        plural: 'assets',
        shortPlural: 'assets',
        display: 'Asset',
        displayPlural: 'Assets',
      },
      defaultOptions,
    },
    file: {
      nomenclature: {
        name: 'file',
        shortName: 'file',
        plural: 'files',
        shortPlural: 'files',
        display: 'File',
        displayPlural: 'Files',
      },
      defaultOptions,
    },
    log: {
      nomenclature: {
        name: 'log',
        shortName: 'log',
        plural: 'logs',
        shortPlural: 'logs',
        display: 'Log',
        displayPlural: 'Logs',
      },
      defaultOptions,
    },
    plan: {
      nomenclature: {
        name: 'plan',
        shortName: 'plan',
        plural: 'plans',
        shortPlural: 'plans',
        display: 'Plan',
        displayPlural: 'Plans',
      },
      defaultOptions,
    },
    quantity: {
      nomenclature: {
        name: 'quantity',
        shortName: 'quantity',
        plural: 'quantities',
        shortPlural: 'quantities',
        display: 'Quantity',
        displayPlural: 'Quantities',
      },
      defaultOptions,
    },
    taxonomy_term: {
      nomenclature: {
        name: 'taxonomy_term',
        shortName: 'term',
        plural: 'taxonomy_terms',
        shortPlural: 'terms',
        display: 'Taxonomy Term',
        displayPlural: 'Taxonomy Terms',
      },
      defaultOptions,
    },
    user: {
      nomenclature: {
        name: 'user',
        shortName: 'user',
        plural: 'users',
        shortPlural: 'users',
        display: 'User',
        displayPlural: 'Users',
      },
      defaultOptions,
    },
  };

  const entityMethods = (fn, allConfigs) =>
    reduceObjIndexed((methods, config) => ({
      ...methods,
      [config.nomenclature.shortName]: {
        ...fn(config),
      },
    }), {}, allConfigs);

  /** The methods for transmitting farmOS data structures, such as assets, logs,
   * etc, to a farmOS server.
   * @typedef {Object} ClientEntityMethods
   * @property {import('./fetch.js').fetchEntity} fetch
   * @property {import('./send.js').sendEntity} send
   * @property {import('./delete.js').deleteEntity} delete
   */

  /**
   * Fetch JSON Schema documents for farmOS data structures.
   * @typedef {Function} FetchSchema
   * @param {string} [entity] The farmOS entity for which you wish to retrieve schemata.
   * @param {string} [bundle] The entity bundle for which you wish to retrieve schemata.
   * @returns {Promise<EntitySchemata|BundleSchemata|JsonSchema>}
   */

  /**
   * @typedef {Function} AuthMixin
   * @param {import('axios').AxiosInstance} request
   * @param {Object} authOptions
   * @property {String} authOptions.host
   * @returns {Object<string,function>}
   */

  /** A collection of functions for transmitting farmOS data structures to and
   * from a farmOS Drupal 9 server using JSON:API.
   * @typedef {Object} FarmClient
   * @property {import('axios').AxiosInstance} request
   * @property {Function} [authorize]
   * @property {Function} [getToken]
   * @property {Function} info
   * @property {Object} schema
   * @property {FetchSchema} schema.fetch
   * @property {ClientEntityMethods} asset
   * @property {ClientEntityMethods} log
   * @property {ClientEntityMethods} plan
   * @property {ClientEntityMethods} quantity
   * @property {ClientEntityMethods} term
   * @property {ClientEntityMethods} user
   */

  /**
   * @typedef {import('../entities.js').EntityConfig} EntityConfig
   */

  /**
   * Create a farm client for interacting with farmOS servers.
   * @typedef {Function} client
   * @param {String} host
   * @param {Object} [options]
   * @property {AuthMixin} [options.auth=oauth]
   * @property {Object<String, EntityConfig>} [options.entities=defaultEntities]
   * @property {String} [options.clientId]
   * @property {Function} [options.getToken]
   * @property {Function} [options.setToken]
   * @returns {FarmClient}
   */
  function client(host, options) {
    const {
      auth = oAuth,
      entities = defaultEntities,
      ...authOptions
    } = options;

    // Instantiate axios client.
    const clientOptions = {
      baseURL: host,
      headers: {
        'Content-Type': 'application/vnd.api+json',
        Accept: 'application/vnd.api+json',
      },
    };
    const request = axios.create(clientOptions);

    const authMethods = auth(request, { host, ...authOptions }) || {};

    const farm = {
      ...authMethods,
      request,
      info() {
        return request('/api');
      },
      schema: {
        fetch(entity, bundle) {
          return request(`/api/${entity}/${bundle}/resource/schema`);
        },
      },
      ...entityMethods(({ nomenclature: { name } }) => ({
        delete: deleteEntity(name, request),
        fetch: fetchEntity(name, request),
        send: sendEntity(name, request),
      }), entities),
    };
    return farm;
  }

  var _curry2$l =

  _curry2_1;
  /**
   * Returns a new object that does not contain a `prop` property.
   *
   * @func
   * @memberOf R
   * @since v0.10.0
   * @category Object
   * @sig String -> {k: v} -> {k: v}
   * @param {String} prop The name of the property to dissociate
   * @param {Object} obj The object to clone
   * @return {Object} A new object equivalent to the original but without the specified property
   * @see R.assoc, R.omit
   * @example
   *
   *      R.dissoc('b', {a: 1, b: 2, c: 3}); //=> {a: 1, c: 3}
   */


  var dissoc =
  /*#__PURE__*/
  _curry2$l(function dissoc(prop, obj) {
    var result = {};

    for (var p in obj) {
      result[p] = obj[p];
    }

    delete result[prop];
    return result;
  });

  var dissoc_1 = dissoc;

  var dissoc$1 = dissoc_1;

  var _curry1$7 =

  _curry1_1;
  /**
   * Checks if the input value is `null` or `undefined`.
   *
   * @func
   * @memberOf R
   * @since v0.9.0
   * @category Type
   * @sig * -> Boolean
   * @param {*} x The value to test.
   * @return {Boolean} `true` if `x` is `undefined` or `null`, otherwise `false`.
   * @example
   *
   *      R.isNil(null); //=> true
   *      R.isNil(undefined); //=> true
   *      R.isNil(0); //=> false
   *      R.isNil([]); //=> false
   */


  var isNil$1 =
  /*#__PURE__*/
  _curry1$7(function isNil(x) {
    return x == null;
  });

  var isNil_1 = isNil$1;

  var isNil$2 = isNil_1;

  var _curry2$k =

  _curry2_1;

  var _has$1 =

  _has_1;

  var isNil =

  isNil_1;
  /**
   * Returns whether or not a path exists in an object. Only the object's
   * own properties are checked.
   *
   * @func
   * @memberOf R
   * @since v0.26.0
   * @category Object
   * @typedefn Idx = String | Int
   * @sig [Idx] -> {a} -> Boolean
   * @param {Array} path The path to use.
   * @param {Object} obj The object to check the path in.
   * @return {Boolean} Whether the path exists.
   * @see R.has
   * @example
   *
   *      R.hasPath(['a', 'b'], {a: {b: 2}});         // => true
   *      R.hasPath(['a', 'b'], {a: {b: undefined}}); // => true
   *      R.hasPath(['a', 'b'], {a: {c: 2}});         // => false
   *      R.hasPath(['a', 'b'], {});                  // => false
   */


  var hasPath$1 =
  /*#__PURE__*/
  _curry2$k(function hasPath(_path, obj) {
    if (_path.length === 0 || isNil(obj)) {
      return false;
    }

    var val = obj;
    var idx = 0;

    while (idx < _path.length) {
      if (!isNil(val) && _has$1(_path[idx], val)) {
        val = val[_path[idx]];
        idx += 1;
      } else {
        return false;
      }
    }

    return true;
  });

  var hasPath_1 = hasPath$1;

  var hasPath$2 = hasPath_1;

  var _curry2$j =

  _curry2_1;

  var hasPath =

  hasPath_1;
  /**
   * Returns whether or not an object has an own property with the specified name
   *
   * @func
   * @memberOf R
   * @since v0.7.0
   * @category Object
   * @sig s -> {s: x} -> Boolean
   * @param {String} prop The name of the property to check for.
   * @param {Object} obj The object to query.
   * @return {Boolean} Whether the property exists.
   * @example
   *
   *      const hasName = R.has('name');
   *      hasName({name: 'alice'});   //=> true
   *      hasName({name: 'bob'});     //=> true
   *      hasName({});                //=> false
   *
   *      const point = {x: 0, y: 0};
   *      const pointHas = R.has(R.__, point);
   *      pointHas('x');  //=> true
   *      pointHas('y');  //=> true
   *      pointHas('z');  //=> false
   */


  var has =
  /*#__PURE__*/
  _curry2$j(function has(prop, obj) {
    return hasPath([prop], obj);
  });

  var has_1 = has;

  var has$1 = has_1;

  var _curry2$i =

  _curry2_1;

  var _reduce$1 =

  _reduce_1;

  var keys =

  keys_1;
  /**
   * An Object-specific version of [`map`](#map). The function is applied to three
   * arguments: *(value, key, obj)*. If only the value is significant, use
   * [`map`](#map) instead.
   *
   * @func
   * @memberOf R
   * @since v0.9.0
   * @category Object
   * @sig ((*, String, Object) -> *) -> Object -> Object
   * @param {Function} fn
   * @param {Object} obj
   * @return {Object}
   * @see R.map
   * @example
   *
   *      const xyz = { x: 1, y: 2, z: 3 };
   *      const prependKeyAndDouble = (num, key, obj) => key + (num * 2);
   *
   *      R.mapObjIndexed(prependKeyAndDouble, xyz); //=> { x: 'x2', y: 'y4', z: 'z6' }
   */


  var mapObjIndexed =
  /*#__PURE__*/
  _curry2$i(function mapObjIndexed(fn, obj) {
    return _reduce$1(function (acc, key) {
      acc[key] = fn(obj[key], key, obj);
      return acc;
    }, {}, keys(obj));
  });

  var mapObjIndexed_1 = mapObjIndexed;

  var mapObjIndexed$1 = mapObjIndexed_1;

  var _curry2$h =

  _curry2_1;

  var path =

  path_1;
  /**
   * Returns a function that when supplied an object returns the indicated
   * property of that object, if it exists.
   *
   * @func
   * @memberOf R
   * @since v0.1.0
   * @category Object
   * @typedefn Idx = String | Int
   * @sig Idx -> {s: a} -> a | Undefined
   * @param {String|Number} p The property name or array index
   * @param {Object} obj The object to query
   * @return {*} The value at `obj.p`.
   * @see R.path, R.nth
   * @example
   *
   *      R.prop('x', {x: 100}); //=> 100
   *      R.prop('x', {}); //=> undefined
   *      R.prop(0, [100]); //=> 100
   *      R.compose(R.inc, R.prop('x'))({ x: 3 }) //=> 4
   */


  var prop$1 =
  /*#__PURE__*/
  _curry2$h(function prop(p, obj) {
    return path([p], obj);
  });

  var prop_1 = prop$1;

  var prop$2 = prop_1;

  var _curry3$3 =

  _curry3_1;
  /**
   * Replace a substring or regex match in a string with a replacement.
   *
   * The first two parameters correspond to the parameters of the
   * `String.prototype.replace()` function, so the second parameter can also be a
   * function.
   *
   * @func
   * @memberOf R
   * @since v0.7.0
   * @category String
   * @sig RegExp|String -> String -> String -> String
   * @param {RegExp|String} pattern A regular expression or a substring to match.
   * @param {String} replacement The string to replace the matches with.
   * @param {String} str The String to do the search and replacement in.
   * @return {String} The result.
   * @example
   *
   *      R.replace('foo', 'bar', 'foo foo foo'); //=> 'bar foo foo'
   *      R.replace(/foo/, 'bar', 'foo foo foo'); //=> 'bar foo foo'
   *
   *      // Use the "g" (global) flag to replace all occurrences:
   *      R.replace(/foo/g, 'bar', 'foo foo foo'); //=> 'bar bar bar'
   */


  var replace =
  /*#__PURE__*/
  _curry3$3(function replace(regex, replacement, str) {
    return str.replace(regex, replacement);
  });

  var replace_1 = replace;

  var replace$1 = replace_1;

  var _concat =

  _concat_1;

  var _curry1$6 =

  _curry1_1;

  var curryN$3 =

  curryN_1;
  /**
   * Creates a new list iteration function from an existing one by adding two new
   * parameters to its callback function: the current index, and the entire list.
   *
   * This would turn, for instance, [`R.map`](#map) function into one that
   * more closely resembles `Array.prototype.map`. Note that this will only work
   * for functions in which the iteration callback function is the first
   * parameter, and where the list is the last parameter. (This latter might be
   * unimportant if the list parameter is not used.)
   *
   * @func
   * @memberOf R
   * @since v0.15.0
   * @category Function
   * @category List
   * @sig ((a ... -> b) ... -> [a] -> *) -> ((a ..., Int, [a] -> b) ... -> [a] -> *)
   * @param {Function} fn A list iteration function that does not pass index or list to its callback
   * @return {Function} An altered list iteration function that passes (item, index, list) to its callback
   * @example
   *
   *      const mapIndexed = R.addIndex(R.map);
   *      mapIndexed((val, idx) => idx + '-' + val, ['f', 'o', 'o', 'b', 'a', 'r']);
   *      //=> ['0-f', '1-o', '2-o', '3-b', '4-a', '5-r']
   */


  var addIndex =
  /*#__PURE__*/
  _curry1$6(function addIndex(fn) {
    return curryN$3(fn.length, function () {
      var idx = 0;
      var origFn = arguments[0];
      var list = arguments[arguments.length - 1];
      var args = Array.prototype.slice.call(arguments, 0);

      args[0] = function () {
        var result = origFn.apply(this, _concat(arguments, [idx, list]));
        idx += 1;
        return result;
      };

      return fn.apply(this, args);
    });
  });

  var addIndex_1 = addIndex;

  var addIndex$1 = addIndex_1;

  function _cloneRegExp$2(pattern) {
    return new RegExp(pattern.source, (pattern.global ? 'g' : '') + (pattern.ignoreCase ? 'i' : '') + (pattern.multiline ? 'm' : '') + (pattern.sticky ? 'y' : '') + (pattern.unicode ? 'u' : ''));
  }

  var _cloneRegExp_1 = _cloneRegExp$2;

  var _cloneRegExp$1 =

  _cloneRegExp_1;

  var type =

  type_1;
  /**
   * Copies an object.
   *
   * @private
   * @param {*} value The value to be copied
   * @param {Array} refFrom Array containing the source references
   * @param {Array} refTo Array containing the copied source references
   * @param {Boolean} deep Whether or not to perform deep cloning.
   * @return {*} The copied value.
   */


  function _clone$1(value, refFrom, refTo, deep) {
    var copy = function copy(copiedValue) {
      var len = refFrom.length;
      var idx = 0;

      while (idx < len) {
        if (value === refFrom[idx]) {
          return refTo[idx];
        }

        idx += 1;
      }

      refFrom[idx + 1] = value;
      refTo[idx + 1] = copiedValue;

      for (var key in value) {
        copiedValue[key] = deep ? _clone$1(value[key], refFrom, refTo, true) : value[key];
      }

      return copiedValue;
    };

    switch (type(value)) {
      case 'Object':
        return copy({});

      case 'Array':
        return copy([]);

      case 'Date':
        return new Date(value.valueOf());

      case 'RegExp':
        return _cloneRegExp$1(value);

      default:
        return value;
    }
  }

  var _clone_1 = _clone$1;

  var _clone =

  _clone_1;

  var _curry1$5 =

  _curry1_1;
  /**
   * Creates a deep copy of the value which may contain (nested) `Array`s and
   * `Object`s, `Number`s, `String`s, `Boolean`s and `Date`s. `Function`s are
   * assigned by reference rather than copied
   *
   * Dispatches to a `clone` method if present.
   *
   * @func
   * @memberOf R
   * @since v0.1.0
   * @category Object
   * @sig {*} -> {*}
   * @param {*} value The object or array to clone
   * @return {*} A deeply cloned copy of `val`
   * @example
   *
   *      const objects = [{}, {}, {}];
   *      const objectsClone = R.clone(objects);
   *      objects === objectsClone; //=> false
   *      objects[0] === objectsClone[0]; //=> false
   */


  var clone =
  /*#__PURE__*/
  _curry1$5(function clone(value) {
    return value != null && typeof value.clone === 'function' ? value.clone() : _clone(value, [], [], true);
  });

  var clone_1 = clone;

  var clone$1 = clone_1;

  function _identity$1(x) {
    return x;
  }

  var _identity_1 = _identity$1;

  var _curry1$4 =

  _curry1_1;

  var _identity =

  _identity_1;
  /**
   * A function that does nothing but return the parameter supplied to it. Good
   * as a default or placeholder function.
   *
   * @func
   * @memberOf R
   * @since v0.1.0
   * @category Function
   * @sig a -> a
   * @param {*} x The value to return.
   * @return {*} The input value, `x`.
   * @example
   *
   *      R.identity(1); //=> 1
   *
   *      const obj = {};
   *      R.identity(obj) === obj; //=> true
   * @symb R.identity(a) = a
   */


  var identity =
  /*#__PURE__*/
  _curry1$4(_identity);

  var identity_1 = identity;

  var identity$1 = identity_1;

  const URIre = /^(http[s]?:\/\/)?([^/\s:#]+)?(:[0-9]+)?((?:\/?\w?)+(?:\/?[\w\-.]+[^#?\s])?)?(\??[^#?\s]+)?(#(?:\/?[\w\-$])*)?$/;

  /**
   * @typedef {Object} UriComponents
   * @prop {?string} match - The full URI that matched the query.
   * @prop {?string} scheme - The protocol, either "http://" or "https://".
   * @prop {?string} domain - The domain and/or subdomain (eg, "api.example.com").
   * @prop {?string} port - The port if specified (eg, ":80").
   * @prop {?string} path - The relative directory path and/or file name (eg, "/foo/index.html").
   * @prop {?string} query - Search params (eg, "?foo=42&bar=36").
   * @prop {?string} fragment - The hash or JSON pointer (eg, "#Introduction", "#$defs/address").
   */

  /**
   * Parses a URI into its component strings.
   * @param {string} uri
   * @returns {UriComponents}
   */
  function parseURI(uri) {
    const groups = uri.match(URIre) || [];
    const [
      match, scheme, domain, port, path, query, fragment,
    ] = groups;
    return {
      match, scheme, domain, port, path, query, fragment,
    };
  }

  var _curry2$g =

  _curry2_1;
  /**
   * Returns the larger of its two arguments.
   *
   * @func
   * @memberOf R
   * @since v0.1.0
   * @category Relation
   * @sig Ord a => a -> a -> a
   * @param {*} a
   * @param {*} b
   * @return {*}
   * @see R.maxBy, R.min
   * @example
   *
   *      R.max(789, 123); //=> 789
   *      R.max('a', 'b'); //=> 'b'
   */


  var max$4 =
  /*#__PURE__*/
  _curry2$g(function max(a, b) {
    return b > a ? b : a;
  });

  var max_1 = max$4;

  var _curry2$f =

  _curry2_1;

  var map$3 =

  map_1;

  var prop =

  prop_1;
  /**
   * Returns a new list by plucking the same named property off all objects in
   * the list supplied.
   *
   * `pluck` will work on
   * any [functor](https://github.com/fantasyland/fantasy-land#functor) in
   * addition to arrays, as it is equivalent to `R.map(R.prop(k), f)`.
   *
   * @func
   * @memberOf R
   * @since v0.1.0
   * @category List
   * @sig Functor f => k -> f {k: v} -> f v
   * @param {Number|String} key The key name to pluck off of each object.
   * @param {Array} f The array or functor to consider.
   * @return {Array} The list of values for the given key.
   * @see R.props
   * @example
   *
   *      var getAges = R.pluck('age');
   *      getAges([{name: 'fred', age: 29}, {name: 'wilma', age: 27}]); //=> [29, 27]
   *
   *      R.pluck(0, [[1, 2], [3, 4]]);               //=> [1, 3]
   *      R.pluck('val', {a: {val: 3}, b: {val: 5}}); //=> {a: 3, b: 5}
   * @symb R.pluck('x', [{x: 1, y: 2}, {x: 3, y: 4}, {x: 5, y: 6}]) = [1, 3, 5]
   * @symb R.pluck(0, [[1, 2], [3, 4], [5, 6]]) = [1, 3, 5]
   */


  var pluck$3 =
  /*#__PURE__*/
  _curry2$f(function pluck(p, list) {
    return map$3(prop(p), list);
  });

  var pluck_1 = pluck$3;

  var _curry1$3 =

  _curry1_1;

  var curryN$2 =

  curryN_1;

  var max$3 =

  max_1;

  var pluck$2 =

  pluck_1;

  var reduce$3 =

  reduce_1;
  /**
   * Takes a list of predicates and returns a predicate that returns true for a
   * given list of arguments if at least one of the provided predicates is
   * satisfied by those arguments.
   *
   * The function returned is a curried function whose arity matches that of the
   * highest-arity predicate.
   *
   * @func
   * @memberOf R
   * @since v0.9.0
   * @category Logic
   * @sig [(*... -> Boolean)] -> (*... -> Boolean)
   * @param {Array} predicates An array of predicates to check
   * @return {Function} The combined predicate
   * @see R.allPass
   * @example
   *
   *      const isClub = R.propEq('suit', '♣');
   *      const isSpade = R.propEq('suit', '♠');
   *      const isBlackCard = R.anyPass([isClub, isSpade]);
   *
   *      isBlackCard({rank: '10', suit: '♣'}); //=> true
   *      isBlackCard({rank: 'Q', suit: '♠'}); //=> true
   *      isBlackCard({rank: 'Q', suit: '♦'}); //=> false
   */


  var anyPass =
  /*#__PURE__*/
  _curry1$3(function anyPass(preds) {
    return curryN$2(reduce$3(max$3, 0, pluck$2('length', preds)), function () {
      var idx = 0;
      var len = preds.length;

      while (idx < len) {
        if (preds[idx].apply(this, arguments)) {
          return true;
        }

        idx += 1;
      }

      return false;
    });
  });

  var anyPass_1 = anyPass;

  var anyPass$1 = anyPass_1;

  const hasAny = compose$1(anyPass$1, map$5(has$1));

  /**
   * @typedef {import('./reference').JsonSchema} JsonSchema
   * @typedef {import('./reference').JsonSchemaDereferenced} JsonSchemaDereferenced
   */

  const logicalKeywords = ['allOf', 'anyOf', 'oneOf', 'not'];
  /** @type {(JsonSchema) => boolean} */
  const hasLogicalKeyword = hasAny(logicalKeywords);

  /** @type {(x: any) => Boolean} */
  const boolOrThrow = (x) => {
    if (typeof x === 'boolean') return x;
    throw new Error(`Invalid schema: ${x}`);
  };

  /**
   * @template T
   * @param {(t: T, i: number) => T} transform
   * @param {Array.<T>} array
   * @returns {Array.<T>}
  */
  const mapIndexed = addIndex$1(map$5);

  /**
   * JSON Schema: A complete definition can probably be imported from a library.
   * @typedef {Object|Boolean} JsonSchema
   */

  /**
   * JSON Schema Dereferenced: A JSON Schema, but w/o any $ref keywords. As such,
   * it may contain circular references that cannot be serialized.
   * @typedef {Object|Boolean} JsonSchemaDereferenced
   */

  const trimPathRexEx = /^[/#\s]*|[/#\s]*$/g;
  /** @type {(path: string) => String} */
  const trimPath = path => path.replace(trimPathRexEx, '');

  /**
   * Resolve a schema definition from a JSON pointer reference.
   * @param {JsonSchema} schema
   * @param {string} pointer - A relative URI provided as the `$ref` keyword.
   * @returns {JsonSchema}
   */
  const getDefinition = (schema, pointer) => {
    const pathSegments = trimPath(pointer).split('/');
    const subschema = path$2(pathSegments, schema);
    if (subschema === undefined) return true;
    return subschema;
  };

  /**
   * Resolve the `$ref` keyword in given schema to its corresponding subschema.
   * @param {JsonSchema} root - The root schema that contained the reference.
   * @param {string} ref - The URI provided as the `$ref` keyword in the root
   *  schema or one of its subschemas.
   * @param {Object} [options]
   * @param {string} [options.retrievalURI] - The URI where the schema was found.
   * @param {Object.<string, JsonSchemaDereferenced>} [options.knownReferences] -
   * An object mapping known references to their corresponding dereferenced schemas.
   * @returns {JsonSchema}
   */
  const getReference = (root, ref, options = {}) => {
    if (typeof ref !== 'string' || ref === '') {
      const submsg = ref === '' ? '[empty string]' : ref;
      throw new Error(`Invalid reference: ${submsg}`);
    }
    const { retrievalURI, knownReferences = {} } = options;
    if (ref in knownReferences) return knownReferences[ref];
    if (!isObject(root)) return boolOrThrow(root);
    // The $id keyword takes precedence according to the JSON Schema spec.
    const rootURI = root.$id || retrievalURI || null;
    const {
      scheme = '', domain = '', port = '', path = '', fragment = '',
    } = parseURI(ref);
    const baseURI = scheme + domain + port + path;
    const baseIsRoot = rootURI === baseURI || ref === fragment;
    let refRoot;
    if (baseIsRoot) refRoot = root;
    if (!baseIsRoot && baseURI in knownReferences) refRoot = knownReferences[baseURI];
    if (refRoot === undefined) return true;
    if (fragment) return getDefinition(refRoot, fragment);
    return refRoot;
  };

  const setInPlace = (obj, path = [], val) => {
    if (path.length < 1) return;
    const [i, ...tail] = path;
    if (!['string', 'number'].includes(typeof i)) throw new Error('Invalid path');
    if (!(i in obj)) throw new Error('Path not found');
    if (tail.length === 0) {
      obj[i] = val; // eslint-disable-line no-param-reassign
      return;
    }
    setInPlace(obj[i], tail, val);
  };

  /**
   * Takes a schema which may contain the $ref keyword in it or in its subschemas,
   * and returns an equivalent schema where those references have been replaced
   * with the full schema document.
   * @param {JsonSchema} root - The root schema to be dereferenced.
   * @param {Object} [options]
   * @param {string} [options.retrievalURI] - The URI where the schema was found.
   * @param {string[]} [options.ignore] - A list of schemas to ignore. They will
   * subsequently be referenced as `true`.
   * @param {Object.<string, JsonSchema>} [options.knownReferences] - An object mapping
   * known references to their corresponding schemas. They will also be dereferenced.
   * @returns {JsonSchemaDereferenced}
   */
  const dereference = (root, options = {}) => {
    const { retrievalURI, ignore = [], knownReferences = {} } = options;

    const knownRefsMap = new Map();
    /** @type {(ref: string, refSchema: JsonSchema) => void} */
    const setKnownRef = (ref, refSchema) => {
      const appliedSchema = ignore.includes(ref) ? true : refSchema;
      knownRefsMap.set(ref, appliedSchema);
    };
    Object.entries(knownReferences).forEach(([ref, refSchema]) => {
      // We could just use setKnownRef here, but this prevents unnecessary recursion;
      const schema = ignore.includes(ref) ? true : dereference(refSchema);
      knownRefsMap.set(ref, schema);
    });

    // Set ignore refs to true to start, so they don't have to be checked in every
    // call to `deref` below.
    ignore.forEach((ref) => { knownRefsMap.set(ref, true); });
    const baseURI = root.$id || retrievalURI || null;
    const _root = clone$1(root);

    /** @type {(schema: JsonSchema, path?: Array.<string|number>) => JsonSchemaDereferenced} */
    const deref = (schema, path = []) => {
      if (!isObject(schema)) return boolOrThrow(schema);
      let _schema = schema;
      const set = (cb) => {
        _schema = cb(_schema);
        setInPlace(_root, path, _schema);
      };
      const derefSubschema = keyword => sub => deref(sub, [...path, keyword]);
      const derefSubschemaObject = keyword => mapObjIndexed$1((sub, prop) =>
        deref(sub, [...path, keyword, prop]));
      const derefSubschemaArray = keyword => mapIndexed((sub, i) =>
        deref(sub, [...path, keyword, i]));
      const schemaTypes = {
        string: identity$1,
        number: identity$1,
        integer: identity$1,
        object: evolve$1({
          properties: derefSubschemaObject('properties'),
          patternProperties: derefSubschemaObject('patternProperties'),
          additionalProperties: derefSubschema('additionalProperties'),
        }),
        array: evolve$1({
          items: derefSubschema('items'),
          contains: derefSubschema('contains'),
          prefixItems: derefSubschemaArray('prefixItems'),
        }),
        boolean: identity$1,
        null: identity$1,
      };
      if ('type' in _schema && _schema.type in schemaTypes) {
        set(schemaTypes[_schema.type]);
      }
      if (hasLogicalKeyword(_schema)) {
        set(evolve$1({
          allOf: derefSubschemaArray('allOf'),
          anyOf: derefSubschemaArray('allOf'),
          oneOf: derefSubschemaArray('allOf'),
          not: derefSubschema('not'),
        }));
      }
      if ('$ref' in _schema) {
        const { $ref } = _schema;
        // Anything beginning with # or /, the followed only by # or /.
        const rootHashRE = /^[/#]+[/#]?$/;
        const refIsRoot = rootHashRE.test($ref) || $ref === baseURI;
        const refKey = refIsRoot ? baseURI : $ref;
        if (knownRefsMap.has(refKey)) {
          set(() => knownRefsMap.get(refKey));
        } else if (refIsRoot) {
          set(() => _root);
          setKnownRef(baseURI, _root);
        } else {
          const opts = {
            knownReferences: Object.fromEntries(knownRefsMap),
            retrievalURI,
          };
          set(() => getReference(_root, $ref, opts));
          set(sub => deref(sub, path));
          setKnownRef($ref, _schema);
        }
      }
      if (isObject(_schema) && '$id' in _schema) setKnownRef(_schema.$id, _schema);
      return _schema;
    };
    return deref(_root);
  };

  var _curry3$2 =

  _curry3_1;

  var mergeWithKey =

  mergeWithKey_1;
  /**
   * Creates a new object with the own properties of the two provided objects. If
   * a key exists in both objects, the provided function is applied to the values
   * associated with the key in each object, with the result being used as the
   * value associated with the key in the returned object.
   *
   * @func
   * @memberOf R
   * @since v0.19.0
   * @category Object
   * @sig ((a, a) -> a) -> {a} -> {a} -> {a}
   * @param {Function} fn
   * @param {Object} l
   * @param {Object} r
   * @return {Object}
   * @see R.mergeDeepWith, R.merge, R.mergeWithKey
   * @example
   *
   *      R.mergeWith(R.concat,
   *                  { a: true, values: [10, 20] },
   *                  { b: true, values: [15, 35] });
   *      //=> { a: true, b: true, values: [10, 20, 15, 35] }
   */


  var mergeWith =
  /*#__PURE__*/
  _curry3$2(function mergeWith(fn, l, r) {
    return mergeWithKey(function (_, _l, _r) {
      return fn(_l, _r);
    }, l, r);
  });

  var mergeWith_1 = mergeWith;

  var mergeWith$1 = mergeWith_1;

  /**
   * @typedef {import('./reference').JsonSchema} JsonSchema
   * @typedef {import('./reference').JsonSchemaDereferenced} JsonSchemaDereferenced
   */

  /**
   * Provide a dereferenced schema and get back the object corresponding to the
   * "properties" keyword. A schema of type "array" will also be checked for the
   * "items" keyword and any corresponding properties it has. Properties found
   * under contitional keywords "allOf", "anyOf", "oneOf" and "not" will be
   * merged; however, the "$ref" keyword will NOT be handled and will throw an
   * error if encountered.
   * @param {JsonSchemaDereferenced} schema - Must NOT contain the "$ref" keyword,
   * nor subschemas containing "$ref".
   * @returns {Object.<string, JsonSchemaDereferenced>}
   */
  const getProperties = (schema) => {
    if (!isObject(schema)) return {};
    if ('$ref' in schema) {
      // It is the responsibility of the caller to dereference the schema first.
      const msg = `Unknown schema reference ($ref): "${schema.$ref}". `
      + 'Try dereferencing the schema before trying to access its properties or defaults.';
      throw new Error(msg);
    }
    if ('properties' in schema) {
      return schema.properties;
    }
    if ('items' in schema && 'properties' in schema.items) {
      return schema.items.properties;
    }
    if (hasLogicalKeyword(schema)) {
      const keyword = logicalKeywords.find(k => k in schema);
      if (keyword === 'not') {
        return map$5(p => ({ not: p }), getProperties(schema.not));
      }
      return schema[keyword].reduce((props, subschema) => {
        const subProps = getProperties(subschema);
        const strategy = (b, a) => {
          const aList = keyword in a ? a[keyword] : [a];
          const bList = keyword in b ? b[keyword] : [b];
          return { [keyword]: [...aList, ...bList] };
        };
        return mergeWith$1(strategy, props, subProps);
      }, {});
    }
    return {};
  };

  /**
   * Provide a dereferenced schema of type 'object', and get back the subschema
   * corresponding to the specified property name.
   * @param {JsonSchemaDereferenced} schema - Must NOT contain the `$ref` keyword,
   * nor subschemas containing `$ref`.
   * @param  {string} property - The name of a property under the `properties` keyword.
   * @returns {JsonSchemaDereferenced}
   */
  const getProperty = (schema, property) => {
    if (typeof schema === 'boolean') return {};
    if (typeof property !== 'string') throw new Error(`Invalid property: ${property}`);
    const properties = getProperties(schema);
    if (property in properties) {
      return properties[property];
    }
    return {};
  };

  /**
   * Provide a dereferenced schema of type 'object', and get back the subschema
   * corresponding to the specified property name, or to the specified path.
   * @param {JsonSchemaDereferenced} schema - Must NOT contain the `$ref` keyword,
   * nor subschemas containing `$ref`.
   * @param  {...string|string[]} path - A property name, or array of property names.
   * @returns {JsonSchemaDereferenced}
   */
  const getPath = (schema, ...path) => {
    if (typeof schema === 'boolean') return {};
    const pathArray = path.flat();
    if (pathArray.length === 0) return schema;
    const [head, ...tail] = pathArray;
    if (typeof head !== 'string') throw new Error(`Invalid path in subschema: ${head}`);
    const subschema = getProperty(schema, head);
    if (!isObject(subschema)) return {};
    if (tail.length > 0) {
      return getPath(subschema, tail);
    }
    return subschema;
  };

  /**
   * Provide a dereferenced schema of type 'object', and get back a list of all its
   * specified properties, or the properties of the subschema indicated by its path.
   * @param {JsonSchemaDereferenced} schema - Must NOT contain the `$ref` keyword, nor
   * subschemas containing `$ref`.
   * @param  {...string|string[]} [path] - A property name, or array of property names.
   * @returns {string[]}
   */
  const listProperties = (schema, ...path) => {
    if (typeof schema === 'boolean') return [];
    const subschema = path.length > 0 ? getPath(schema, path.flat()) : schema;
    if ('properties' in subschema) {
      return Object.keys(subschema.properties);
    }
    return [];
  };

  /**
   * @typedef {import('./reference').JsonSchema} JsonSchema
   * @typedef {import('./reference').JsonSchemaDereferenced} JsonSchemaDereferenced
   */

  /** Transform function
   * @typedef {(JsonSchemaDereferenced) => *} SchemaTransform
   */

  /**
   * Get the default value at a given path for a given schema.
   * @param {JsonSchemaDereferenced} schema
   * @param {string[]|string} [path] - A property name or array of property names.
   * @param {Object} [options]
   * @param {Object.<string, SchemaTransform>} [options.byType]
   * @param {Object.<string, SchemaTransform>} [options.byFormat]
   * @param {Object.<string, SchemaTransform>|string|boolean} [options.byProperty]
   * @param {Object} [options.use]
   * @returns {*}
   */
  const getDefault = (schema, path = [], options = {}) => {
    const subschema = getPath(schema, path);
    if (!isObject(subschema)) return undefined;
    if ('default' in subschema) return subschema.default;
    if ('const' in subschema) return subschema.const;

    // For recursive calls
    /** @type {(sub: JsonSchemaDereferenced) => *} */
    const getDef = sub => getDefault(sub, [], options);
    /** @typedef {JsonSchemaDereferenced[]|Object.<string, JsonSchemaDereferenced>} SchemaFunctor */
    /** @type {(sub: SchemaFunctor) => Array|Object} */
    const mapGetDef = map$5(getDef);

    if (hasLogicalKeyword(subschema) && subschema.type === 'object') {
      return evolve$1({
        allOf: mapGetDef,
        anyOf: mapGetDef,
        oneOf: mapGetDef,
        not: getDef,
      }, subschema);
    }
    const { type } = subschema;
    if (type === 'null') {
      // This is the only case that should return null; if a default can't be
      // resolved, undefined should be returned, as below.
      return null;
    }
    const {
      byType, byFormat, use,
    } = options;
    if (type === 'string') {
      if (byFormat && 'format' in subschema && subschema.format in byFormat) {
        const { [subschema.format]: transform } = byFormat;
        return transform(subschema);
      }
    }
    if (use && ['number', 'integer'].includes(type)) {
      const keywords = ['minimum', 'maximum', 'multipleOf'];
      const useOptions = Array.isArray(use) ? use : [use];
      const kw = useOptions.find(k => k in subschema && keywords.includes(k));
      if (kw !== undefined) return subschema[kw];
    }
    // Evaluate byType last, so options of higher specificity take precedence.
    if (byType && type in byType) {
      const { [type]: transform } = byType;
      return transform(subschema);
    }
    return undefined;
  };

  const dropMilliseconds = replace$1(/\.\d\d\d/, '');
  const safeIso = t => t && new Date(t).toISOString();
  const safeUnix = t => t && Math.floor(new Date(t).valueOf() / 1000);

  // These functions correspond to string formats in the JSON Schema for an entity
  // and are used to convert between local formats and server-supported formats.
  const transformsByFormat = {
    'date-time': safeUnix,
  };
  const transformsByMetafield = {
    created: safeUnix,
    changed: safeUnix,
    revision_created: safeUnix,
  };
  /**
   * The transforms need to be regenerated whenever the schemata are set, so the
   * format transforms can be mapped to every field with that format.
   * @param {import('../../model/index').EntitySchemata} schemata
   * @returns {FieldTransforms}
   */
  const generateFieldTransforms = (schemata) => {
    const formats = transformsByFormat;
    /** @type {FieldTransforms} */
    const transforms = {};
    const entities = Object.keys(schemata);
    entities.forEach((entity) => {
      transforms[entity] = {};
      Object.entries(schemata[entity]).forEach(([bundle, schema]) => {
        transforms[entity][bundle] = { ...transformsByMetafield };
        const attributes = getPath(schema, 'attributes');
        const relationships = getPath(schema, 'relationships');
        const fieldSchemata = { ...attributes.properties, ...relationships.properties };
        Object.entries(fieldSchemata).forEach(([field, sub]) => {
          if (isObject(sub) && 'format' in sub && sub.format in formats) {
            const { [sub.format]: transform } = formats;
            transforms[entity][bundle][field] = transform;
          }
        });
      });
    });
    return transforms;
  };

  const drupalMetaFields = {
    attributes: [
      'created',
      'changed',
      'drupal_internal__id',
      'drupal_internal__revision_id',
      'langcode',
      'revision_created',
      'revision_log_message',
      'default_langcode',
      'revision_translation_affected',
      'revision_default',
    ],
    relationships: ['revision_user', 'uid'],
  };
  const removeDrupalMetaSchemas = drupalFields => evolve$1({
    properties: omit$1(drupalFields),
    required: rFilter(field => !drupalFields.includes(field)),
  });

  // Drupal's jsonapi_schema module classifies certain enumerable values as plain
  // strings; e.g., "status" should be an enumerable of ['pending', 'done']. To
  // avoid errors w/o enums a default is provided.
  const attributeDefaults = {
    asset: {
      status: 'active',
    },
    log: {
      status: 'pending',
    },
    plan: {
      status: 'active',
    },
    user: {
      langcode: 'en',
    },
  };

  // Relationships are comprised of either one resource identifier objects, or an
  // array of resource identifier objects. For now, we'll just use the same schema
  // regardless of the resource type, but the type could be constrained to an enum
  // or a const value.
  const transformResourceSchema = (subschema) => {
    const resourceSchema = {
      type: 'object',
      required: ['id', 'type'],
      properties: {
        id: {
          type: 'string',
          title: 'Resource ID',
          format: 'uuid',
          maxLength: 128,
        },
        type: { type: 'string' },
      },
    };
    const { properties: { data: { type } }, title } = subschema;
    if (type === 'object') {
      return { title, ...resourceSchema };
    }
    return { type, title, items: resourceSchema };
  };

  const transformD9Schema = (d9Schema) => {
    const {
      $id, $schema, title, definitions: { type, attributes, relationships },
    } = d9Schema;
    const { entity, bundle } = parseEntityType(type.const);
    const defaultTitle = `${bundle} ${entity}`;

    const transformAttributeFields = evolve$1({
      properties: mapObjIndexed$1((subschema, propName) => {
        const hasOwnDefault = isObject(subschema) && 'default' in subschema;
        if (hasOwnDefault) return subschema;
        const standardDefault = path$2([entity, propName], attributeDefaults);
        if (!standardDefault) return subschema;
        return { ...subschema, default: standardDefault };
      }),
    });
    const transformRelationshipFields = evolve$1({
      properties: map$5(transformResourceSchema),
    });
    const transformAttributesSchema = compose$1(
      transformAttributeFields,
      removeDrupalMetaSchemas(drupalMetaFields.attributes),
    );
    const transformRelationshipsSchema = compose$1(
      transformRelationshipFields,
      removeDrupalMetaSchemas(drupalMetaFields.relationships.concat(`${entity}_type`)),
    );

    return {
      $schema,
      $id,
      title: title || defaultTitle,
      type: 'object',
      properties: {
        id: { type: 'string', format: 'uuid' },
        type,
        meta: { type: 'object' },
        attributes: transformAttributesSchema(attributes),
        relationships: transformRelationshipsSchema(relationships),
      },
    };
  };

  /**
   * @typedef {Object.<string, function>} BundleTransforms
   * @typedef {Object.<string, BundleTransforms>} EntityTransforms
   * @typedef {Object.<string, EntityTransforms>} FieldTransforms
   */
  /**
   * @typedef {Function} safeTransforms
   * @param {String} type Entity type (eg, 'log--activity')
   * @param {FieldTransforms} [fns] Collection of tranform functions
   * @returns {BundleTransforms}
   */
  const safeTransforms = (type, fns = {}) => {
    const { entity, bundle } = parseEntityType(type);
    const transforms = fns[entity] && fns[entity][bundle];
    return transforms || {};
  };

  /**
   * @type {(relationship: object|array) => object} For nesting relationships and
   * other fields withn objects under the property 'data'.
   */
  const nestData = unless$1(has$1('data'), data => ({ data }));

  /**
   * For transforming local entities into acceptable format for D9 JSON:API farmOS.
   * @param {import('../../entities').Entity} data The actual data of such an entity
   * @param {FieldTransforms} transforms Collection of transforms
   * @returns {Object}
   */
  const transformLocalEntity = (data, transforms) => compose$1(
    dissoc$1('meta'),
    evolve$1({
      attributes: {
        /**
         * @see https://github.com/farmOS/farmOS.js/issues/74
         */
        archived: dropMilliseconds,
        timestamp: dropMilliseconds,
        ...safeTransforms(data.type, transforms),
      },
      relationships: map$5(nestData),
    }),
  )(data);

  const transformRemoteAttributes = compose$1(
    evolve$1({ timestamp: safeIso }),
    omit$1(drupalMetaFields.attributes),
  );
  const transformRemoteRelationships = compose$1(
    map$5(prop$2('data')),
    omit$1(drupalMetaFields.attributes),
  );
  const makeFieldChanges = (attrs, rels) => ({
    ...map$5(() => safeIso(attrs.changed), omit$1(drupalMetaFields.attributes, attrs)),
    ...map$5(() => safeIso(rels.changed), omit$1(drupalMetaFields.relationships, rels)),
  });

  const emptyAttrs = { created: null, changed: null, drupal_internal__id: null };
  const transformRemoteEntity = (setLastSync = false) => (remote) => {
    const {
      id, type, attributes = emptyAttrs, relationships = {},
    } = remote;
    const { entity } = parseEntityType(type);
    return {
      id,
      type,
      meta: {
        created: safeIso(attributes.created),
        changed: safeIso(attributes.changed),
        fieldChanges: makeFieldChanges(attributes, relationships),
        conflicts: [],
        remote: {
          lastSync: setLastSync ? new Date().toISOString() : null,
          url: `/${entity}/${attributes.drupal_internal__id}`,
          meta: {
            attributes: pick$1(drupalMetaFields.attributes, attributes),
            relationships: pick$1(drupalMetaFields.relationships, relationships),
          },
        },
      },
      attributes: transformRemoteAttributes(attributes),
      relationships: transformRemoteRelationships(relationships),
    };
  };

  const transformFetchResponse = evolve$1({
    data: map$5(transformRemoteEntity(false)),
  });

  const transformSendResponse = compose$1(
    transformRemoteEntity(true),
    path$2(['data', 'data']),
  );

  var _curry1$2 =

  _curry1_1;

  var curryN$1 =

  curryN_1;

  var max$2 =

  max_1;

  var pluck$1 =

  pluck_1;

  var reduce$2 =

  reduce_1;
  /**
   * Takes a list of predicates and returns a predicate that returns true for a
   * given list of arguments if every one of the provided predicates is satisfied
   * by those arguments.
   *
   * The function returned is a curried function whose arity matches that of the
   * highest-arity predicate.
   *
   * @func
   * @memberOf R
   * @since v0.9.0
   * @category Logic
   * @sig [(*... -> Boolean)] -> (*... -> Boolean)
   * @param {Array} predicates An array of predicates to check
   * @return {Function} The combined predicate
   * @see R.anyPass
   * @example
   *
   *      const isQueen = R.propEq('rank', 'Q');
   *      const isSpade = R.propEq('suit', '♠︎');
   *      const isQueenOfSpades = R.allPass([isQueen, isSpade]);
   *
   *      isQueenOfSpades({rank: 'Q', suit: '♣︎'}); //=> false
   *      isQueenOfSpades({rank: 'Q', suit: '♠︎'}); //=> true
   */


  var allPass =
  /*#__PURE__*/
  _curry1$2(function allPass(preds) {
    return curryN$1(reduce$2(max$2, 0, pluck$1('length', preds)), function () {
      var idx = 0;
      var len = preds.length;

      while (idx < len) {
        if (!preds[idx].apply(this, arguments)) {
          return false;
        }

        idx += 1;
      }

      return true;
    });
  });

  var allPass_1 = allPass;

  var allPass$1 = allPass_1;

  function _reduced$2(x) {
    return x && x['@@transducer/reduced'] ? x : {
      '@@transducer/value': x,
      '@@transducer/reduced': true
    };
  }

  var _reduced_1 = _reduced$2;

  var _curry2$e =

  _curry2_1;

  var _reduced$1 =

  _reduced_1;

  var _xfBase$3 =

  _xfBase$6;

  var XAny =
  /*#__PURE__*/
  function () {
    function XAny(f, xf) {
      this.xf = xf;
      this.f = f;
      this.any = false;
    }

    XAny.prototype['@@transducer/init'] = _xfBase$3.init;

    XAny.prototype['@@transducer/result'] = function (result) {
      if (!this.any) {
        result = this.xf['@@transducer/step'](result, false);
      }

      return this.xf['@@transducer/result'](result);
    };

    XAny.prototype['@@transducer/step'] = function (result, input) {
      if (this.f(input)) {
        this.any = true;
        result = _reduced$1(this.xf['@@transducer/step'](result, true));
      }

      return result;
    };

    return XAny;
  }();

  var _xany$1 =
  /*#__PURE__*/
  _curry2$e(function _xany(f, xf) {
    return new XAny(f, xf);
  });

  var _xany_1 = _xany$1;

  var _curry2$d =

  _curry2_1;

  var _dispatchable$3 =

  _dispatchable_1;

  var _xany =

  _xany_1;
  /**
   * Returns `true` if at least one of the elements of the list match the predicate,
   * `false` otherwise.
   *
   * Dispatches to the `any` method of the second argument, if present.
   *
   * Acts as a transducer if a transformer is given in list position.
   *
   * @func
   * @memberOf R
   * @since v0.1.0
   * @category List
   * @sig (a -> Boolean) -> [a] -> Boolean
   * @param {Function} fn The predicate function.
   * @param {Array} list The array to consider.
   * @return {Boolean} `true` if the predicate is satisfied by at least one element, `false`
   *         otherwise.
   * @see R.all, R.none, R.transduce
   * @example
   *
   *      const lessThan0 = R.flip(R.lt)(0);
   *      const lessThan2 = R.flip(R.lt)(2);
   *      R.any(lessThan0)([1, 2]); //=> false
   *      R.any(lessThan2)([1, 2]); //=> true
   */


  var any =
  /*#__PURE__*/
  _curry2$d(
  /*#__PURE__*/
  _dispatchable$3(['any'], _xany, function any(fn, list) {
    var idx = 0;

    while (idx < list.length) {
      if (fn(list[idx])) {
        return true;
      }

      idx += 1;
    }

    return false;
  }));

  var any_1 = any;

  var any$1 = any_1;

  var _curry3$1 =

  _curry3_1;
  /**
   * Makes a shallow clone of an object, setting or overriding the specified
   * property with the given value. Note that this copies and flattens prototype
   * properties onto the new object as well. All non-primitive properties are
   * copied by reference.
   *
   * @func
   * @memberOf R
   * @since v0.8.0
   * @category Object
   * @sig String -> a -> {k: v} -> {k: v}
   * @param {String} prop The property name to set
   * @param {*} val The new value
   * @param {Object} obj The object to clone
   * @return {Object} A new object equivalent to the original except for the changed property.
   * @see R.dissoc, R.pick
   * @example
   *
   *      R.assoc('c', 3, {a: 1, b: 2}); //=> {a: 1, b: 2, c: 3}
   */


  var assoc =
  /*#__PURE__*/
  _curry3$1(function assoc(prop, val, obj) {
    var result = {};

    for (var p in obj) {
      result[p] = obj[p];
    }

    result[prop] = val;
    return result;
  });

  var assoc_1 = assoc;

  var assoc$1 = assoc_1;

  var _isArrayLike$1 =

  _isArrayLike_1;
  /**
   * `_makeFlat` is a helper function that returns a one-level or fully recursive
   * function based on the flag passed in.
   *
   * @private
   */


  function _makeFlat$1(recursive) {
    return function flatt(list) {
      var value, jlen, j;
      var result = [];
      var idx = 0;
      var ilen = list.length;

      while (idx < ilen) {
        if (_isArrayLike$1(list[idx])) {
          value = recursive ? flatt(list[idx]) : list[idx];
          j = 0;
          jlen = value.length;

          while (j < jlen) {
            result[result.length] = value[j];
            j += 1;
          }
        } else {
          result[result.length] = list[idx];
        }

        idx += 1;
      }

      return result;
    };
  }

  var _makeFlat_1 = _makeFlat$1;

  function _forceReduced$1(x) {
    return {
      '@@transducer/value': x,
      '@@transducer/reduced': true
    };
  }

  var _forceReduced_1 = _forceReduced$1;

  var _forceReduced =

  _forceReduced_1;

  var _isArrayLike =

  _isArrayLike_1;

  var _reduce =

  _reduce_1;

  var _xfBase$2 =

  _xfBase$6;

  var preservingReduced = function (xf) {
    return {
      '@@transducer/init': _xfBase$2.init,
      '@@transducer/result': function (result) {
        return xf['@@transducer/result'](result);
      },
      '@@transducer/step': function (result, input) {
        var ret = xf['@@transducer/step'](result, input);
        return ret['@@transducer/reduced'] ? _forceReduced(ret) : ret;
      }
    };
  };

  var _flatCat$1 = function _xcat(xf) {
    var rxf = preservingReduced(xf);
    return {
      '@@transducer/init': _xfBase$2.init,
      '@@transducer/result': function (result) {
        return rxf['@@transducer/result'](result);
      },
      '@@transducer/step': function (result, input) {
        return !_isArrayLike(input) ? _reduce(rxf, result, [input]) : _reduce(rxf, result, input);
      }
    };
  };

  var _flatCat_1 = _flatCat$1;

  var _curry2$c =

  _curry2_1;

  var _flatCat =

  _flatCat_1;

  var map$2 =

  map_1;

  var _xchain$1 =
  /*#__PURE__*/
  _curry2$c(function _xchain(f, xf) {
    return map$2(f, _flatCat(xf));
  });

  var _xchain_1 = _xchain$1;

  var _curry2$b =

  _curry2_1;

  var _dispatchable$2 =

  _dispatchable_1;

  var _makeFlat =

  _makeFlat_1;

  var _xchain =

  _xchain_1;

  var map$1 =

  map_1;
  /**
   * `chain` maps a function over a list and concatenates the results. `chain`
   * is also known as `flatMap` in some libraries.
   *
   * Dispatches to the `chain` method of the second argument, if present,
   * according to the [FantasyLand Chain spec](https://github.com/fantasyland/fantasy-land#chain).
   *
   * If second argument is a function, `chain(f, g)(x)` is equivalent to `f(g(x), x)`.
   *
   * Acts as a transducer if a transformer is given in list position.
   *
   * @func
   * @memberOf R
   * @since v0.3.0
   * @category List
   * @sig Chain m => (a -> m b) -> m a -> m b
   * @param {Function} fn The function to map with
   * @param {Array} list The list to map over
   * @return {Array} The result of flat-mapping `list` with `fn`
   * @example
   *
   *      const duplicate = n => [n, n];
   *      R.chain(duplicate, [1, 2, 3]); //=> [1, 1, 2, 2, 3, 3]
   *
   *      R.chain(R.append, R.head)([1, 2, 3]); //=> [1, 2, 3, 1]
   */


  var chain =
  /*#__PURE__*/
  _curry2$b(
  /*#__PURE__*/
  _dispatchable$2(['fantasy-land/chain', 'chain'], _xchain, function chain(fn, monad) {
    if (typeof monad === 'function') {
      return function (x) {
        return fn(monad(x))(x);
      };
    }

    return _makeFlat(false)(map$1(fn, monad));
  }));

  var chain_1 = chain;

  var chain$1 = chain_1;

  var _has =

  _has_1; // Based on https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/assign


  function _objectAssign$1(target) {
    if (target == null) {
      throw new TypeError('Cannot convert undefined or null to object');
    }

    var output = Object(target);
    var idx = 1;
    var length = arguments.length;

    while (idx < length) {
      var source = arguments[idx];

      if (source != null) {
        for (var nextKey in source) {
          if (_has(nextKey, source)) {
            output[nextKey] = source[nextKey];
          }
        }
      }

      idx += 1;
    }

    return output;
  }

  var _objectAssign_1 = typeof Object.assign === 'function' ? Object.assign : _objectAssign$1;

  var _objectAssign =

  _objectAssign_1;

  var _curry2$a =

  _curry2_1;
  /**
   * Create a new object with the own properties of the first object merged with
   * the own properties of the second object. If a key exists in both objects,
   * the value from the second object will be used.
   *
   * @func
   * @memberOf R
   * @since v0.26.0
   * @category Object
   * @sig {k: v} -> {k: v} -> {k: v}
   * @param {Object} l
   * @param {Object} r
   * @return {Object}
   * @see R.mergeLeft, R.mergeDeepRight, R.mergeWith, R.mergeWithKey
   * @example
   *
   *      R.mergeRight({ 'name': 'fred', 'age': 10 }, { 'age': 40 });
   *      //=> { 'name': 'fred', 'age': 40 }
   *
   *      const withDefaults = R.mergeRight({x: 0, y: 0});
   *      withDefaults({y: 2}); //=> {x: 0, y: 2}
   * @symb R.mergeRight(a, b) = {...a, ...b}
   */


  var mergeRight =
  /*#__PURE__*/
  _curry2$a(function mergeRight(l, r) {
    return _objectAssign({}, l, r);
  });

  var mergeRight_1 = mergeRight;

  var mergeRight$1 = mergeRight_1;

  var _curry2$9 =

  _curry2_1;

  var _map =

  _map_1;

  var curryN =

  curryN_1;

  var max$1 =

  max_1;

  var pluck =

  pluck_1;

  var reduce$1 =

  reduce_1;
  /**
   * Accepts a converging function and a list of branching functions and returns
   * a new function. The arity of the new function is the same as the arity of
   * the longest branching function. When invoked, this new function is applied
   * to some arguments, and each branching function is applied to those same
   * arguments. The results of each branching function are passed as arguments
   * to the converging function to produce the return value.
   *
   * @func
   * @memberOf R
   * @since v0.4.2
   * @category Function
   * @sig ((x1, x2, ...) -> z) -> [((a, b, ...) -> x1), ((a, b, ...) -> x2), ...] -> (a -> b -> ... -> z)
   * @param {Function} after A function. `after` will be invoked with the return values of
   *        `fn1` and `fn2` as its arguments.
   * @param {Array} functions A list of functions.
   * @return {Function} A new function.
   * @see R.useWith
   * @example
   *
   *      const average = R.converge(R.divide, [R.sum, R.length])
   *      average([1, 2, 3, 4, 5, 6, 7]) //=> 4
   *
   *      const strangeConcat = R.converge(R.concat, [R.toUpper, R.toLower])
   *      strangeConcat("Yodel") //=> "YODELyodel"
   *
   * @symb R.converge(f, [g, h])(a, b) = f(g(a, b), h(a, b))
   */


  var converge$1 =
  /*#__PURE__*/
  _curry2$9(function converge(after, fns) {
    return curryN(reduce$1(max$1, 0, pluck('length', fns)), function () {
      var args = arguments;
      var context = this;
      return after.apply(context, _map(function (fn) {
        return fn.apply(context, args);
      }, fns));
    });
  });

  var converge_1 = converge$1;

  var _curry1$1 =

  _curry1_1;

  var converge =

  converge_1;
  /**
   * juxt applies a list of functions to a list of values.
   *
   * @func
   * @memberOf R
   * @since v0.19.0
   * @category Function
   * @sig [(a, b, ..., m) -> n] -> ((a, b, ..., m) -> [n])
   * @param {Array} fns An array of functions
   * @return {Function} A function that returns a list of values after applying each of the original `fns` to its parameters.
   * @see R.applySpec
   * @example
   *
   *      const getRange = R.juxt([Math.min, Math.max]);
   *      getRange(3, 4, 9, -3); //=> [-3, 9]
   * @symb R.juxt([f, g, h])(a, b) = [f(a, b), g(a, b), h(a, b)]
   */


  var juxt$1 =
  /*#__PURE__*/
  _curry1$1(function juxt(fns) {
    return converge(function () {
      return Array.prototype.slice.call(arguments, 0);
    }, fns);
  });

  var juxt_1 = juxt$1;

  var filter =

  filter_1;

  var juxt =

  juxt_1;

  var reject =

  reject_1;
  /**
   * Takes a predicate and a list or other `Filterable` object and returns the
   * pair of filterable objects of the same type of elements which do and do not
   * satisfy, the predicate, respectively. Filterable objects include plain objects or any object
   * that has a filter method such as `Array`.
   *
   * @func
   * @memberOf R
   * @since v0.1.4
   * @category List
   * @sig Filterable f => (a -> Boolean) -> f a -> [f a, f a]
   * @param {Function} pred A predicate to determine which side the element belongs to.
   * @param {Array} filterable the list (or other filterable) to partition.
   * @return {Array} An array, containing first the subset of elements that satisfy the
   *         predicate, and second the subset of elements that do not satisfy.
   * @see R.filter, R.reject
   * @example
   *
   *      R.partition(R.includes('s'), ['sss', 'ttt', 'foo', 'bars']);
   *      // => [ [ 'sss', 'bars' ],  [ 'ttt', 'foo' ] ]
   *
   *      R.partition(R.includes('s'), { a: 'sss', b: 'ttt', foo: 'bars' });
   *      // => [ { a: 'sss', foo: 'bars' }, { b: 'ttt' }  ]
   */


  var partition =
  /*#__PURE__*/
  juxt([filter, reject]);
  var partition_1 = partition;

  var partition$1 = partition_1;

  var _curry2$8 =

  _curry2_1;
  /**
   * Returns a partial copy of an object containing only the keys that satisfy
   * the supplied predicate.
   *
   * @func
   * @memberOf R
   * @since v0.8.0
   * @category Object
   * @sig ((v, k) -> Boolean) -> {k: v} -> {k: v}
   * @param {Function} pred A predicate to determine whether or not a key
   *        should be included on the output object.
   * @param {Object} obj The object to copy from
   * @return {Object} A new object with only properties that satisfy `pred`
   *         on it.
   * @see R.pick, R.filter
   * @example
   *
   *      const isUpperCase = (val, key) => key.toUpperCase() === key;
   *      R.pickBy(isUpperCase, {a: 1, b: 2, A: 3, B: 4}); //=> {A: 3, B: 4}
   */


  var pickBy =
  /*#__PURE__*/
  _curry2$8(function pickBy(test, obj) {
    var result = {};

    for (var prop in obj) {
      if (test(obj[prop], prop, obj)) {
        result[prop] = obj[prop];
      }
    }

    return result;
  });

  var pickBy_1 = pickBy;

  var pickBy$1 = pickBy_1;

  var _curry2$7 =

  _curry2_1;
  /**
   * Returns a copy of the list, sorted according to the comparator function,
   * which should accept two values at a time and return a negative number if the
   * first value is smaller, a positive number if it's larger, and zero if they
   * are equal. Please note that this is a **copy** of the list. It does not
   * modify the original.
   *
   * @func
   * @memberOf R
   * @since v0.1.0
   * @category List
   * @sig ((a, a) -> Number) -> [a] -> [a]
   * @param {Function} comparator A sorting function :: a -> b -> Int
   * @param {Array} list The list to sort
   * @return {Array} a new array with its elements sorted by the comparator function.
   * @example
   *
   *      const diff = function(a, b) { return a - b; };
   *      R.sort(diff, [4,2,7,5]); //=> [2, 4, 5, 7]
   */


  var sort =
  /*#__PURE__*/
  _curry2$7(function sort(comparator, list) {
    return Array.prototype.slice.call(list, 0).sort(comparator);
  });

  var sort_1 = sort;

  var sort$1 = sort_1;

  var _curry2$6 =

  _curry2_1;

  var _reduced =

  _reduced_1;

  var _xfBase$1 =

  _xfBase$6;

  var XTake =
  /*#__PURE__*/
  function () {
    function XTake(n, xf) {
      this.xf = xf;
      this.n = n;
      this.i = 0;
    }

    XTake.prototype['@@transducer/init'] = _xfBase$1.init;
    XTake.prototype['@@transducer/result'] = _xfBase$1.result;

    XTake.prototype['@@transducer/step'] = function (result, input) {
      this.i += 1;
      var ret = this.n === 0 ? result : this.xf['@@transducer/step'](result, input);
      return this.n >= 0 && this.i >= this.n ? _reduced(ret) : ret;
    };

    return XTake;
  }();

  var _xtake$1 =
  /*#__PURE__*/
  _curry2$6(function _xtake(n, xf) {
    return new XTake(n, xf);
  });

  var _xtake_1 = _xtake$1;

  var _curry2$5 =

  _curry2_1;

  var _dispatchable$1 =

  _dispatchable_1;

  var _xtake =

  _xtake_1;

  var slice =

  slice_1;
  /**
   * Returns the first `n` elements of the given list, string, or
   * transducer/transformer (or object with a `take` method).
   *
   * Dispatches to the `take` method of the second argument, if present.
   *
   * @func
   * @memberOf R
   * @since v0.1.0
   * @category List
   * @sig Number -> [a] -> [a]
   * @sig Number -> String -> String
   * @param {Number} n
   * @param {*} list
   * @return {*}
   * @see R.drop
   * @example
   *
   *      R.take(1, ['foo', 'bar', 'baz']); //=> ['foo']
   *      R.take(2, ['foo', 'bar', 'baz']); //=> ['foo', 'bar']
   *      R.take(3, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
   *      R.take(4, ['foo', 'bar', 'baz']); //=> ['foo', 'bar', 'baz']
   *      R.take(3, 'ramda');               //=> 'ram'
   *
   *      const personnel = [
   *        'Dave Brubeck',
   *        'Paul Desmond',
   *        'Eugene Wright',
   *        'Joe Morello',
   *        'Gerry Mulligan',
   *        'Bob Bates',
   *        'Joe Dodge',
   *        'Ron Crotty'
   *      ];
   *
   *      const takeFive = R.take(5);
   *      takeFive(personnel);
   *      //=> ['Dave Brubeck', 'Paul Desmond', 'Eugene Wright', 'Joe Morello', 'Gerry Mulligan']
   * @symb R.take(-1, [a, b]) = [a, b]
   * @symb R.take(0, [a, b]) = []
   * @symb R.take(1, [a, b]) = [a]
   * @symb R.take(2, [a, b]) = [a, b]
   */


  var take$2 =
  /*#__PURE__*/
  _curry2$5(
  /*#__PURE__*/
  _dispatchable$1(['take'], _xtake, function take(n, xs) {
    return slice(0, n < 0 ? Infinity : n, xs);
  }));

  var take_1 = take$2;

  var _curry2$4 =

  _curry2_1;

  var equals$1 =

  equals_1;

  var take$1 =

  take_1;
  /**
   * Checks if a list starts with the provided sublist.
   *
   * Similarly, checks if a string starts with the provided substring.
   *
   * @func
   * @memberOf R
   * @since v0.24.0
   * @category List
   * @sig [a] -> [a] -> Boolean
   * @sig String -> String -> Boolean
   * @param {*} prefix
   * @param {*} list
   * @return {Boolean}
   * @see R.endsWith
   * @example
   *
   *      R.startsWith('a', 'abc')                //=> true
   *      R.startsWith('b', 'abc')                //=> false
   *      R.startsWith(['a'], ['a', 'b', 'c'])    //=> true
   *      R.startsWith(['b'], ['a', 'b', 'c'])    //=> false
   */


  var startsWith =
  /*#__PURE__*/
  _curry2$4(function (prefix, list) {
    return equals$1(take$1(prefix.length, list), prefix);
  });

  var startsWith_1 = startsWith;

  var startsWith$1 = startsWith_1;

  function _isRegExp$1(x) {
    return Object.prototype.toString.call(x) === '[object RegExp]';
  }

  var _isRegExp_1 = _isRegExp$1;

  var _cloneRegExp =

  _cloneRegExp_1;

  var _curry2$3 =

  _curry2_1;

  var _isRegExp =

  _isRegExp_1;

  var toString =

  toString_1;
  /**
   * Determines whether a given string matches a given regular expression.
   *
   * @func
   * @memberOf R
   * @since v0.12.0
   * @category String
   * @sig RegExp -> String -> Boolean
   * @param {RegExp} pattern
   * @param {String} str
   * @return {Boolean}
   * @see R.match
   * @example
   *
   *      R.test(/^x/, 'xyz'); //=> true
   *      R.test(/^y/, 'xyz'); //=> false
   */


  var test =
  /*#__PURE__*/
  _curry2$3(function test(pattern, str) {
    if (!_isRegExp(pattern)) {
      throw new TypeError('‘test’ requires a value of type RegExp as its first argument; received ' + toString(pattern));
    }

    return _cloneRegExp(pattern).test(str);
  });

  var test_1 = test;

  var test$1 = test_1;

  var _includes =

  _includes_1;

  var _Set$1 =
  /*#__PURE__*/
  function () {
    function _Set() {
      /* globals Set */
      this._nativeSet = typeof Set === 'function' ? new Set() : null;
      this._items = {};
    }

    // until we figure out why jsdoc chokes on this
    // @param item The item to add to the Set
    // @returns {boolean} true if the item did not exist prior, otherwise false
    //
    _Set.prototype.add = function (item) {
      return !hasOrAdd(item, true, this);
    }; //
    // @param item The item to check for existence in the Set
    // @returns {boolean} true if the item exists in the Set, otherwise false
    //


    _Set.prototype.has = function (item) {
      return hasOrAdd(item, false, this);
    }; //
    // Combines the logic for checking whether an item is a member of the set and
    // for adding a new item to the set.
    //
    // @param item       The item to check or add to the Set instance.
    // @param shouldAdd  If true, the item will be added to the set if it doesn't
    //                   already exist.
    // @param set        The set instance to check or add to.
    // @return {boolean} true if the item already existed, otherwise false.
    //


    return _Set;
  }();

  function hasOrAdd(item, shouldAdd, set) {
    var type = typeof item;
    var prevSize, newSize;

    switch (type) {
      case 'string':
      case 'number':
        // distinguish between +0 and -0
        if (item === 0 && 1 / item === -Infinity) {
          if (set._items['-0']) {
            return true;
          } else {
            if (shouldAdd) {
              set._items['-0'] = true;
            }

            return false;
          }
        } // these types can all utilise the native Set


        if (set._nativeSet !== null) {
          if (shouldAdd) {
            prevSize = set._nativeSet.size;

            set._nativeSet.add(item);

            newSize = set._nativeSet.size;
            return newSize === prevSize;
          } else {
            return set._nativeSet.has(item);
          }
        } else {
          if (!(type in set._items)) {
            if (shouldAdd) {
              set._items[type] = {};
              set._items[type][item] = true;
            }

            return false;
          } else if (item in set._items[type]) {
            return true;
          } else {
            if (shouldAdd) {
              set._items[type][item] = true;
            }

            return false;
          }
        }

      case 'boolean':
        // set._items['boolean'] holds a two element array
        // representing [ falseExists, trueExists ]
        if (type in set._items) {
          var bIdx = item ? 1 : 0;

          if (set._items[type][bIdx]) {
            return true;
          } else {
            if (shouldAdd) {
              set._items[type][bIdx] = true;
            }

            return false;
          }
        } else {
          if (shouldAdd) {
            set._items[type] = item ? [false, true] : [true, false];
          }

          return false;
        }

      case 'function':
        // compare functions for reference equality
        if (set._nativeSet !== null) {
          if (shouldAdd) {
            prevSize = set._nativeSet.size;

            set._nativeSet.add(item);

            newSize = set._nativeSet.size;
            return newSize === prevSize;
          } else {
            return set._nativeSet.has(item);
          }
        } else {
          if (!(type in set._items)) {
            if (shouldAdd) {
              set._items[type] = [item];
            }

            return false;
          }

          if (!_includes(item, set._items[type])) {
            if (shouldAdd) {
              set._items[type].push(item);
            }

            return false;
          }

          return true;
        }

      case 'undefined':
        if (set._items[type]) {
          return true;
        } else {
          if (shouldAdd) {
            set._items[type] = true;
          }

          return false;
        }

      case 'object':
        if (item === null) {
          if (!set._items['null']) {
            if (shouldAdd) {
              set._items['null'] = true;
            }

            return false;
          }

          return true;
        }

      /* falls through */

      default:
        // reduce the search size of heterogeneous sets by creating buckets
        // for each type.
        type = Object.prototype.toString.call(item);

        if (!(type in set._items)) {
          if (shouldAdd) {
            set._items[type] = [item];
          }

          return false;
        } // scan through all previously applied items


        if (!_includes(item, set._items[type])) {
          if (shouldAdd) {
            set._items[type].push(item);
          }

          return false;
        }

        return true;
    }
  } // A simple Set type that honours R.equals semantics


  var _Set_1 = _Set$1;

  var _Set =

  _Set_1;

  var _curry2$2 =

  _curry2_1;
  /**
   * Returns a new list containing only one copy of each element in the original
   * list, based upon the value returned by applying the supplied function to
   * each list element. Prefers the first item if the supplied function produces
   * the same value on two items. [`R.equals`](#equals) is used for comparison.
   *
   * @func
   * @memberOf R
   * @since v0.16.0
   * @category List
   * @sig (a -> b) -> [a] -> [a]
   * @param {Function} fn A function used to produce a value to use during comparisons.
   * @param {Array} list The array to consider.
   * @return {Array} The list of unique items.
   * @example
   *
   *      R.uniqBy(Math.abs, [-1, -5, 2, 10, 1, 2]); //=> [-1, -5, 2, 10]
   */


  var uniqBy =
  /*#__PURE__*/
  _curry2$2(function uniqBy(fn, list) {
    var set = new _Set();
    var result = [];
    var idx = 0;
    var appliedItem, item;

    while (idx < list.length) {
      item = list[idx];
      appliedItem = fn(item);

      if (set.add(appliedItem)) {
        result.push(item);
      }

      idx += 1;
    }

    return result;
  });

  var uniqBy_1 = uniqBy;

  var uniqBy$1 = uniqBy_1;

  // Unique ID creation requires a high quality random # generator. In the browser we therefore
  // require the crypto API and do not support built-in fallback to lower quality random number
  // generators (like Math.random()).
  var getRandomValues;
  var rnds8 = new Uint8Array(16);
  function rng() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!getRandomValues) {
      // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
      // find the complete implementation of crypto (msCrypto) on IE11.
      getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);

      if (!getRandomValues) {
        throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
      }
    }

    return getRandomValues(rnds8);
  }

  var REGEX = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

  function validate(uuid) {
    return typeof uuid === 'string' && REGEX.test(uuid);
  }

  /**
   * Convert array of 16 byte values to UUID string format of the form:
   * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
   */

  var byteToHex = [];

  for (var i = 0; i < 256; ++i) {
    byteToHex.push((i + 0x100).toString(16).substr(1));
  }

  function stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields

    if (!validate(uuid)) {
      throw TypeError('Stringified UUID is invalid');
    }

    return uuid;
  }

  function v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

    if (buf) {
      offset = offset || 0;

      for (var i = 0; i < 16; ++i) {
        buf[offset + i] = rnds[i];
      }

      return buf;
    }

    return stringify(rnds);
  }

  // Constants for sending requests via Drupal's JSON:API module.
  const BASE_URI = '/api';
  const SUB_URL = '/subrequests?_format=json';
  const headers = {
    Accept: 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json',
  };

  // Fields that contain a subrequest are separated as dependent fields, distinct
  // from constant fields, whose values are known immediately.
  const isKeyword = startsWith$1('$');
  const isSubrequest = o => any$1(isKeyword, Object.keys(o || {}));
  const splitFields = partition$1(isSubrequest);

  // For use with fetch filters, to keep only their constant fields and drop any
  // operators such as `'$lt'`, `'$or'`, etc.
  const dropKeywords = pickBy$1((v, k) => !isKeyword(k));

  // Subrequests that contain a JSONPath wildcard may have multiple subresponses,
  // which are each given Content-Ids comprised of the original requestId appended
  // w/ an additional fragment, which is itself comprised of the blueprint key
  // where the wildcard was found plus an index. For instance, if a subrequest is
  // given a uri of '/api/log/input/{{find-logs.body@$.data[*].id}}' and has a
  // requestId of 'update-input', the first two subresponse that corresponds to it
  // will have Content-Ids of 'update-input#uri{0}' and 'update-input#uri{1}',
  // respectively. Therefore, each Content-Id is parsed so the subresponse can be
  // more easily matched with its corresponding subrequest.
  const contentIdRE = /([^#\s]+)((?:#(?:body|uri)\{\d\}){0,2}$)/;
  const bodyRE = /(#body\{\d+\})/;
  const uriRE = /(#uri\{\d+\})/;
  function parseContentId(string) {
    const [contentId, requestId, fragment] = match$1(contentIdRE, string);
    const [, body = null] = match$1(bodyRE, fragment || '');
    const [, uri = null] = match$1(uriRE, fragment || '');
    return {
      contentId, requestId, fragment, body, uri,
    };
  }

  function parseCommand(reqId) {
    const pathSegments = reqId.split('::');
    const lastPathSegment = pathSegments[pathSegments.length - 1];
    const [command] = lastPathSegment.split(':');
    return command;
  }
  const commandRelations = {
    $find: 'array',
    $create: 'object',
    $createIfNotFound: 'object',
    $update: 'object',
  };
  // Formatter for JSONPath tokens, defaults to one-to-one ('object') relation.
  const fmtDataToken = (requestId, field, relation = 'object') =>
    `{{${requestId}.body@$.data${relation === 'array' ? '[*]' : ''}.${field}}}`;
  // Format the data token, but parse the requestId first to determine if it's for
  // a one-to-one or one-to-many relationship, based on the command.
  function parseDataToken(requestId, field) {
    const command = parseCommand(requestId);
    const relation = commandRelations[command];
    return fmtDataToken(requestId, field, relation);
  }

  // Determine if a relationship for a given schema is one-to-one (ie, 'object')
  // or one-to-many (ie, 'array').
  const typeOfRelationship = (schema, field) => path$2([
    'properties', 'relationships', 'properties', field, 'type',
  ], schema);

  const fmtRequestId = (prefix, command, type) => `${prefix}::${command}:${type}`;

  // Wrapper merely provides an instance of FarmObject via dependency injection.
  function withSubrequests(model, connection) {
    // Called before any requests have been sent, unlike resolveDependencies. This
    // is mutually recursive with parseSubrequests, and is how each subrequest and
    // its child subrequests are assigned their priority number, which accordingly
    // determines the batch of subrequests in which it will be sent to the server.
    function parseDependentFields(fields, command, prefix) {
      const [dependentFields, constants] = splitFields(fields);
      const { bundle, entity, type } = parseTypeFromFields(constants);
      const requestId = fmtRequestId(prefix, command, type);
      const dependencies = {}; let priority = 0; const subrequests = {};
      Object.entries(dependentFields).forEach(([field, sub]) => {
        const nextPrefix = `${requestId}.${field}`;
        dependencies[field] = [];
        const requests = parseSubrequest(sub, nextPrefix);
        Object.entries(requests).forEach(([reqId, req]) => {
          dependencies[field].push(reqId);
          if (req.priority > priority) priority = req.priority;
          subrequests[reqId] = req;
        });
      });
      return {
        bundle, constants, dependencies, entity, priority, requestId, subrequests, type,
      };
    }

    // This is called by blueprint functions just before the subrequest is batched
    // and actually sent to the server. This way, dependencies from earlier batches
    // of requests can be resolved to static values, and concurrent dependencies
    // (ie, dependencies that will be part of the same batch) can be suitably
    // formatted according to the JSONPath spec.
    function resolveDependencies(fieldData, ready, prior) {
      const {
        bundle, dependencies, entity, requestId,
      } = fieldData;
      const schema = model.schema.get(entity, bundle);

      // Resolved fields include data from prior request batches, as well as concurrent
      // requests that do not require a post hoc subrequest.
      const resolved = {};
      // The names of unresolved fields will be collected, but are ultimately left
      // to the blueprint functions to handle independently.
      const unresolved = [];
      // Post hoc subrequests are concurrent blueprints for creating relationships
      // that must be added to the entity separately from the main 'create'
      // subrequest, using the entity's relationship endpoint. This is likely b/c
      // the dependency uses a JSONPath wildcard, which can't be resolved to a
      // resource identifier w/o a separate subrequest.
      const posthoc = [];
      // Only concurrent reqIds are added to waitFor, which is why it is done here
      // and is not the sole responsibility of the commands.
      const waitFor = [];

      // Match a requestId with its corresponding prior responses, if any exist.
      // The contentId is included in each response object, so just use the values.
      const matchWithResponses = reqId => Object.values(prior)
        .filter(sub => reqId === sub.requestId);
      // Field dependencies, as an array of raw requestIds, are mapped to an array
      // of corresponding resource identifiers from prior responses.
      const mapDependenciesToResources = compose$1(
        // Take only the first occurrence of the resource, which will be from the
        // most recent request since they've already been sorted by priority.
        uniqBy$1(prop$2('id')),
        // Strip it down to the resource identifier alone.
        map$5(pick$1(['id', 'type'])),
        rFilter((data) => data && 'id' in data && 'type' in data),
        // Flatten the array of nested data objects/arrays.
        chain$1(path$2(['body', 'data'])),
        // Responses are sorted by highest priority, which corresponds to the most recent.
        // In the future it may also be useful to parse the requestId as a tie-breaker.
        sort$1((a, b) => a.priority - b.priority),
        // The array of requestIds, are each flatmapped to an array of matching responses.
        chain$1(matchWithResponses),
      );

      // Iterate over all dependencies, resolving their corresponding fields using
      // the most up-to-date (highest priority) data available.
      Object.entries(dependencies).forEach(([field, fieldDeps]) => {
        // Based on JSON Schema types, a field has a relation type of 'object' for
        // ONE-TO-ONE relationships, or 'array' for ONE-TO-MANY relationships.
        const relation = typeOfRelationship(schema, field);
        const depPrefix = `${requestId}.${field}::`;
        const trimPrefix = d => d.replace(depPrefix, '');
        const isDirect = d => !trimPrefix(d).includes('::');
        const directDeps = fieldDeps.filter(isDirect);
        const concurrentIds = Object.keys(ready).filter(id => directDeps.includes(id));
        const resources = mapDependenciesToResources(directDeps);
        // ONE-TO-ONE RELATIONSHIPS
        if (relation === 'object') {
          // Concurrent dependencies are taken first b/c they will be the most recent.
          if (concurrentIds.length > 0) {
            // Taking the first result, whether there's one or many and w/o
            // sorting by priority b/c they will all be the same priority.
            const [reqId] = concurrentIds;
            // These are the only request ids that this request needs to wait for;
            // all others can be resolved or, in the case of one-to-many relationships,
            // they will be added independently as post hoc requests.
            waitFor.push(reqId);
            const resource = {
              id: fmtDataToken(reqId, 'id'),
              type: path$2([reqId, 'type'], ready),
            };
            resolved[field] = resource;
          } else if (resources.length > 0) {
            const [resource] = resources;
            resolved[field] = resource;
          } else {
            unresolved.push(field);
          }
        // ONE-TO-MANY RELATIONSHIPS
        } else if (relation === 'array') {
          // Concurrent dependencies will be updated in a separate subrequest sent
          // to the parent entity's relationships enpoint; that subrequest will be
          // in the same batch, but subsequent to the original subrequest; hence,
          // they are separated as "posthoc" (ie, "after the fact") dependencies.
          concurrentIds.forEach((reqId) => {
            const dRevId = 'attributes.drupal_internal__revision_id';
            const dId = 'attributes.drupal_internal__id';
            const data = [{
              id: parseDataToken(reqId, 'id'),
              type: parseDataToken(reqId, 'type'),
              // The target's revision id is required primarily for quantities,
              // but it doesn't hurt to add it for all others as well.
              meta: {
                target_revision_id: parseDataToken(reqId, dRevId),
                drupal_internal__target_id: parseDataToken(reqId, dId),
              },
            }];
            const basePath = `${BASE_URI}/${entity}/${bundle}/${fmtDataToken(requestId, 'id')}`;
            const blueprint = {
              requestId: `${requestId}.${field}`,
              // Note the entity's relationship endpoint is used here.
              uri: `${basePath}/relationships/${field}`,
              waitFor: [reqId, requestId],
              action: 'create',
              headers,
              body: JSON.stringify({ data }),
            };
            posthoc.push(blueprint);
          });
          // Only dependencies from prior request batches can be fully resolved.
          resolved[field] = resources;
        } else {
          console.warn(`Uknown field in subrequest for ${bundle} ${entity}: ${field}`);
        }
      });

      return {
        resolved, posthoc, unresolved, waitFor,
      };
    }

    // Convert an entity or array of entities into Drupal format, then stringify.
    function fmtLocalData(raw) {
      const transforms = generateFieldTransforms(model.schema.get());
      const data = Array.isArray(raw)
        ? raw.map(d => transformLocalEntity(d, transforms))
        : transformLocalEntity(raw, transforms);
      return JSON.stringify({ data });
    }

    // A safe way of calling entity methods, such as `farm.term.create()`.
    function callEntityMethod(entity, method, ...args) {
      if (typeof entity !== 'string' || !(entity in defaultEntities)) return null;
      const { [entity]: { nomenclature: { shortName } } } = defaultEntities;
      if (!shortName || typeof method !== 'string') return null;
      let { [shortName]: { [method]: fn } } = model;
      if (typeof fn !== 'function') ({ [shortName]: { [method]: fn } } = connection);
      if (typeof fn !== 'function') return null;
      return fn(...args);
    }

    // const { compare } = new Intl.Collator();
    // const sortKeys = obj => sort(([k1], [k2]) => compare(k1, k2), Object.keys(obj));
    // function getCommandFingerprint(keyword, args, prefix, options) {
    // }
    // function isOneTimeCommand(command, options = {}) {
    //   if (options.$once) return true;
    //   if (command.startsWith('$find') && options.$createIfNotFound) return true;
    //   return false;
    // }
    const commands = {
      map(keyword, args, prefix, options) {
        const command = this[keyword];
        if (Array.isArray(args)) {
          // console.log('MAPPING: ', keyword);
          // console.log('args', args);
          // console.log('options', options);
          // if (isOneTimeCommand(keyword, options)) {
          //   const tailOptions = { ...options, $createIfNotFound: false, $once: false };
          //   return args.reduce((subs, argument, i) => {
          //     const headIndex = args.findIndex(equals(argument));
          //     const opts = headIndex === i ? options : tailOptions;
          //     const sub = command(argument, `${prefix}.${i}`, opts);
          //     return { ...subs, ...sub };
          //   }, {});
          // }
          return args.reduce((subs, value, i) => ({
            ...subs,
            ...command(value, `${prefix}.${i}`, options),
          }), {});
        }
        return command(args, prefix, options);
      },
      $create(fields, prefix) {
        if (Array.isArray(fields)) return this.map('$create', fields, prefix);
        const fieldData = parseDependentFields(fields, '$create', prefix);
        const {
          bundle, constants, dependencies, entity, priority, subrequests, requestId, type,
        } = fieldData;
        const blueprint = (ready, prior) => {
          const {
            resolved, posthoc, unresolved, waitFor,
          } = resolveDependencies(fieldData, ready, prior);
          unresolved.forEach((field) => {
            const msg = `Unable to resolve ${field} field while creating `
              + `${bundle} ${entity}. Request ID: ${requestId}`;
            console.warn(msg);
          });
          const props = { ...resolved, ...constants };
          const action = 'create';
          const data = callEntityMethod(entity, 'create', props);
          if (!data) return [];
          const body = fmtLocalData(data);
          const uri = `${BASE_URI}/${entity}/${bundle}`;
          const current = {
            action, body, headers, requestId, uri, waitFor,
          };
          return [current, ...posthoc];
        };
        return {
          ...subrequests,
          [requestId]: {
            blueprint, bundle, dependencies, entity, priority, type,
          },
        };
      },
      $find(filter, prefix, opts) {
        const { $createIfNotFound, $limit, $sort } = opts;
        const schemata = model.schema.get();
        const filterTransforms = generateFieldTransforms(schemata);
        const validTypes = Object.entries(schemata)
          .flatMap(([e, s]) => Object.keys(s).map(b => `${e}--${b}`));
        const filtersByType = splitFilterByType(filter, validTypes);

        const subrequests = {};
        filtersByType.forEach(({ type, filter: typeFilter }) => {
          const { entity, bundle } = parseEntityType(type);
          // The initial fetch request with filter & other search parameters.
          const requestId = fmtRequestId(prefix, '$find', type);
          // Nested subrequests are disallowed in $find commands, meaning they have
          // no dependencies, and so should always be included in the first batch of
          // subrequests; hence, they will always have a priority of 0.
          const priority = 0;
          const params = parseFetchParams({
            filter: typeFilter, filterTransforms, limit: $limit, sort: $sort,
          });
          const blueprint = () => [{
            action: 'view',
            headers,
            requestId,
            uri: `${BASE_URI}/${entity}/${bundle}?${params}`,
          }];
          subrequests[requestId] = {
            blueprint, bundle, entity, priority, type,
          };
        });

        if (!$createIfNotFound || validTypes.length < 1) return subrequests;

        // Arbitrarily pop the first type.
        const [{ type, filter: typeFilter }] = filtersByType;
        const { entity, bundle } = parseEntityType(type);
        const requestId = fmtRequestId(prefix, '$createIfNotFound', type);
        // A list of request ids is created before the above requestId is added to
        // the subrequests object, and before the blueprint is evaluated.
        const findRequestIds = Object.keys(subrequests);
        // A separate create request is only added when $createIfNotFound is true;
        // Even then, its blueprint returns the empty array (ie, no-op),
        // unless all prior find requests come back empty.
        const blueprint = (_, prior) => {
          const results = Object.values(prior)
            .filter(sub => findRequestIds.includes(sub.requestId) && sub.body)
            .flatMap((sub) => sub.body.data || []);
          if (results.length > 0) return [];
          const props = { ...dropKeywords(typeFilter), type };
          const data = callEntityMethod(entity, 'create', props);
          if (!data) return [];
          return [{
            action: 'create',
            body: fmtLocalData(data),
            headers,
            requestId,
            uri: `${BASE_URI}/${entity}/${bundle}`,
          }];
        };
        // Because $find requests are always priority 0, this will always be 1.
        const priority = 1;
        // $createIfNotFound is a one-time-command, which should not be repeated,
        // so provide this fingerprint so it can be deduplicated.
        const fingerprint = {
          keyword: '$createIfNotFound', args: filter, prefix, options: opts,
        };
        subrequests[requestId] = {
          blueprint, bundle, entity, fingerprint, priority, type,
        };
        return subrequests;
      },
      $update(fields, prefix) {
        if (Array.isArray(fields)) this.map('$update', fields, prefix);
        if (!validate(fields.id)) return commands.$create(fields, prefix);
        const fieldData = parseDependentFields(fields, '$update', prefix);
        const {
          bundle, constants, dependencies, entity, priority, subrequests, requestId, type,
        } = fieldData;
        const blueprint = (ready, prior) => {
          const {
            resolved, posthoc, unresolved, waitFor,
          } = resolveDependencies(fieldData, ready, prior);
          unresolved.forEach((field) => {
            const msg = `Unable to resolve ${field} field while updating `
              + `${bundle} ${entity}. Request ID: ${requestId}`;
            console.warn(msg);
          });
          const action = 'update';
          const data = callEntityMethod(entity, 'update', constants, resolved);
          if (!data) return [];
          const body = fmtLocalData(data);
          const uri = `${BASE_URI}/${entity}/${bundle}/${fields.id}`;
          const current = {
            action, body, headers, requestId, uri, waitFor,
          };
          return [current, ...posthoc];
        };
        return {
          ...subrequests,
          [requestId]: {
            blueprint, bundle, dependencies, entity, priority, type,
          },
        };
      },
    };

    const splitCommandsAndOptions = compose$1(
      map$5(Object.fromEntries),
      partition$1(([key]) => key in commands),
      Object.entries,
    );

    // Commands like $createIfNotFound should only be used once, so remove duplicates.
    function dedupeOneTimeCommands(subrequests) {
      const replacements = new Map();
      const deduped = Object.entries(subrequests).reduce((subs, [requestId, sub], i, all) => {
        if (is$1(Object, sub.fingerprint)) {
          if (sub.fingerprint.keyword === '$createIfNotFound') {
            const isEqual = compose$1(
              equals$5(sub.fingerprint.args),
              path$2([1, 'fingerprint', 'args']),
            );
            const firstIndex = all.findIndex(isEqual);
            if (firstIndex !== i) {
              const [firstReqId] = all[firstIndex];
              replacements.set(requestId, firstReqId);
              return subs;
            }
          }
        }
        return { ...subs, [requestId]: sub };
      }, {});
      // Search for JSONPath tokens that contain any of the duplicate request ids
      // and replace them with the request id of the first subrequest that matched
      // the same fingerprint.
      const replaceTokens = initStr => Array.from(replacements.entries())
        .reduce((prev, [dupeReqId, firstReqId]) => {
          // Use the RegExp constructor with a template literal as the pattern, so
          // the function parameterss can be included in the expression, bounded
          // by "{{" and ".body@$" to make sure it matches only the full request id.
          const tokenPattern = `\\{\\{${dupeReqId}.body@$`
            .replaceAll('$', '\\$')
            .replaceAll('.', '\\.');
          const tokenRE = new RegExp(tokenPattern, 'g');
          return prev.replaceAll(tokenRE, `{{${firstReqId}.body@$`);
        }, initStr);
      // Swap an entire string for another if it's a duplicate.
      const swap = reqId => (replacements.has(reqId) ? replacements.get(reqId) : reqId);
      const replaceOneTimeCommands = map$5(evolve$1({
        blueprint: map$5(evolve$1({
          body: replaceTokens,
          uri: replaceTokens,
          waitFor: map$5(swap),
        })),
        dependencies: map$5(map$5(swap)),
      }));
      const replaced = replaceOneTimeCommands(deduped);
      return replaced;
    }

    /** @type {(subrequest?: Object, prefix?: String) => Object.<string, object>} */
    function parseSubrequest(subrequest = {}, prefix = '$ROOT') {
      const [comms, options] = splitCommandsAndOptions(subrequest);
      if (Object.keys(comms).length < 1) {
        const joinedOpts = Object.keys(options).join(', ');
        const joinedActs = Object.keys(commands).join(', ');
        const msg = `Missing or invalid command in subrequest at ${prefix}. `
        + `Only the following options or keys were included: ${joinedOpts}. `
        + `Include one of the following valid commands instead: ${joinedActs}.`;
        throw new Error(msg);
      }
      return Object.entries(comms).reduce((prevSubs, [keyword, args]) => {
        const nextSub = commands.map(keyword, args, prefix, options);
        return { ...prevSubs, ...nextSub };
      }, {});
    }

    /** @type {(requests: Object, responses?: Array, priority?: Number) => Promise<Array>} */
    function chainSubrequests(requests, responses = [], priority = 0) {
      // Separate requests with the current priority level from all later requests.
      const [ready, next] = partition$1(r => r.priority === priority, requests);
      // Each response contains one "batch" (ie, the same priority) of subresponses
      // but blueprint functions expect one big object containing all priorities.
      const mergeResponses = compose$1(
        // Using mergeRight as the reducer merges all batches of subresponses into a
        // single object. Because they're keyed to contentId, they shouldn't collide.
        reduce$6(mergeRight$1, {}),
        // The data property on each response object contains the subresponses.
        map$5(prop$2('data')),
      );
      const prior = mergeResponses(responses);

      // Determine if a request (req) depends upon another separate request,
      // based on the former's dependencies and the latter's requestId (id).
      const isDependent = (req, id) => {
        const { dependencies = {} } = req;
        const allDeps = Object.values(dependencies).flat();
        return allDeps.includes(id);
      };
      // Even once ready requests have been partitioned from pending ones, they
      // must still be sorted according to which ones depend upon each other. This
      // prevents subrequests from referencing dependencies that have resolved to
      // a 'noop' will be removed from the collection of concurrent subrequests.
      function sortByDependencies(unsorted, sorted = []) {
        const [head, ...tail] = unsorted;
        if (tail.length < 1) return [...sorted, head];
        const [idA, reqA] = head;
        const aDependsOn = []; const dependsOnA = []; const independent = [];
        tail.forEach(([idB, reqB]) => {
          if (isDependent(reqA, idB)) {
            aDependsOn.push([idB, reqB]);
          } else if (isDependent(reqB, idA)) {
            dependsOnA.push([idB, reqB]);
          } else {
            independent.push([idB, reqB]);
          }
        });
        const circularDependency = !aDependsOn.every(([i]) => dependsOnA.every(([j]) => i !== j));
        if (circularDependency) throw new Error('Circular dependency detected!');
        if (aDependsOn.length === 0) {
          return sortByDependencies(tail, [...sorted, head]);
        }
        const resorted = [...independent, ...aDependsOn, head, ...dependsOnA];
        return sortByDependencies(resorted, sorted);
      }

      // Once they've been sorted, the blueprints of ready requests must be evaluated
      // sequentially, and if their blueprint is empty (ie, a 'noop'), they must be
      // removed from the final list of concurrent requests, b/c leaving them in can
      // result in a server error if it encounters a requestId it doesn't recognize.
      const concatConcurrentRequests = reduce$6((concurrent, [reqId, req]) => {
        const resolved = evolve$1({
          blueprint: bp => bp(concurrent, prior),
        }, req);
        if (resolved.blueprint.length < 1) return concurrent;
        return assoc$1(reqId, resolved, concurrent);
      }, {});
      // Combine all the above steps to take a batch of ready requests and return
      // the final blueprint array to send to the server's subrequest endpoint.
      const resolveBlueprints = compose$1(
        chain$1(prop$2('blueprint')),
        Object.values,
        dedupeOneTimeCommands,
        concatConcurrentRequests,
        sortByDependencies,
        Object.entries,
      );
      function pruneUnmetDependencies(blueprint) {
        const requestIds = blueprint.map(b => b.requestId);
        const pruned = blueprint.filter(({ waitFor = [] }) =>
          waitFor.length < 1 || waitFor.every(id => requestIds.includes(id)));
        if (pruned.length === blueprint.length || pruned.length === 0) return pruned;
        return pruneUnmetDependencies(pruned);
      }
      const concatBlueprints = compose$1(
        pruneUnmetDependencies,
        resolveBlueprints,
      );

      // Merge a batch of subresponses w/ their original request data.
      const mergeResponseWithRequest = evolve$1({
        // The data property on the main response object contains the subresponses,
        // each keyed to their contentId. Map over each subresponse and match it with
        // its corresponding request, merge them into one object, and parse the body.
        data: mapObjIndexed$1(compose$1(
          // Parse the body of each subresponse.
          evolve$1({ body: JSON.parse }),
          // Merge the request data with the response data.
          sub => mergeRight$1(requests[sub.requestId], sub),
          // Parse the contentId to get the original requestId, key and index, then
          // merge those properties with the rest of the subresponse.
          (sub, contentId) => mergeRight$1(parseContentId(contentId), sub),
        )),
      });

      // Add an incoming response, along w/ its request data, to the list of
      // prior responses, so they can be returned to the caller, or passed to the
      // next recursive call of chainSubrequst.
      const concatSubresponses = (response) => {
        const merged = mergeResponseWithRequest(response);
        return responses.concat(merged);
      };

      const data = concatBlueprints(ready);
      const promise = connection.request(SUB_URL, { method: 'POST', data })
        .then(concatSubresponses);
      if (Object.keys(next).length === 0) return promise;
      return promise.then(done => chainSubrequests(next, done, priority + 1));
    }

    // Convert the initial data of a send request, either an entity or an array of
    // entities, into a subrequest with either a single $create or $update
    // command, depending on
    function toSubrequest(data, options) {
      if (Array.isArray(data)) {
        const concatSubs = (a, b) => [].concat(a).concat(b);
        return data.reduce((prevSubs, subData) => {
          const nextSub = toSubrequest(subData, options);
          return mergeWith$1(concatSubs, prevSubs, nextSub);
        }, {});
      }
      let { subrequest: fields = {} } = options;
      if (is$1(Function, options.subrequest)) fields = options.subrequest(data);
      const isPostRequest = !data.id || model.meta.isUnsynced(data);
      const command = isPostRequest ? '$create' : '$update';
      const fieldTransforms = generateFieldTransforms(model.schema.get());
      const remote = transformLocalEntity(data, fieldTransforms);
      const {
        id, type, attributes, relationships,
      } = remote;
      fields = { ...relationships, ...fields };
      const argument = {
        id, type, ...attributes, ...fields,
      };
      return { [command]: argument };
    }

    const rootRE = /^\$ROOT(\.?\d?)::\$(create|update):\w+--\w+$/g;
    const isRootRequest = compose$1(
      test$1(rootRE),
      prop$2('requestId'),
    );
    const hasData = hasPath$2(['body', 'data']);
    const hasRootData = allPass$1([isRootRequest, hasData]);
    const transformSubresponses = compose$1(
      map$5(transformRemoteEntity(true)),
      map$5(path$2(['body', 'data'])),
      rFilter(hasRootData),
      chain$1(Object.values),
      map$5(prop$2('data')),
    );
    return function sendWithSubrequest(data, options) {
      const subrequest = toSubrequest(data, options);
      const requests = parseSubrequest(subrequest, '$ROOT');
      return chainSubrequests(requests).then((raw) => {
        const responses = transformSubresponses(raw);
        return responses;
      });
    };
  }

  /**
   * @typedef {import('../../utils').AltogetherResult} AltogetherResult
   * @typedef {import('../../json-schema/reference').JsonSchema} JsonSchema
   * @typedef {import('../../model/index').EntitySchemata} EntitySchemata
   * @typedef {import('../../model/index').BundleSchemata} BundleSchemata
   */

  /**
   * Fetch JSON Schema documents for farmOS data structures.
   * @typedef {Function} FetchSchema
   * @param {string} [entity] The farmOS entity for which you wish to retrieve schemata.
   * @param {string} [bundle] The entity bundle for which you wish to retrieve schemata.
   * @returns {Promise<AltogetherResult<JsonSchema|EntitySchemata|BundleSchemata>>}
   */

  const DRUPAL_PAGE_LIMIT = 50;

  /**
   * @typedef {import('../../entities.js').EntityConfig} EntityConfig
   */
  /**
   * @param {import('../../model/index').FarmModel} model
   * @param {Object} opts
   * @property {Object<String, EntityConfig>} [opts.entities=defaultEntities]
   * @returns {import('../index.js').FarmClient}
   */
  function adapter(model, opts) {
    const {
      host, maxPageLimit = DRUPAL_PAGE_LIMIT, entities = defaultEntities, ...rest
    } = opts;
    const connection = client(host, { ...rest, entities });
    const initSchemata = model.schema.get();
    let fieldTransforms = generateFieldTransforms(initSchemata);
    model.schema.on('set', (schemata) => {
      fieldTransforms = generateFieldTransforms(schemata);
    });

    // For chaining consecutive requests for the next page of resources until the
    // provided limit is reached, or there are no further resources to fetch.
    const chainRequests = (req, limit, prev = [], total = 0) => req.then((res) => {
      let next = path$2(['data', 'links', 'next', 'href'], res);
      const resLength = path$2(['data', 'data', 'length'], res);
      const newTotal = total + resLength;
      const all = prev.concat(res);
      if (!next || newTotal >= limit) return all;
      const remainder = limit - newTotal;
      if (remainder < maxPageLimit) next = `${next}&page[limit]=${remainder}`;
      const url = new URL(next);
      const nextReq = connection.request(url.pathname + url.search);
      return chainRequests(nextReq, limit, all, newTotal);
    });

    const fetchAndSetSchemata = ({ entity, bundle }) =>
      connection.schema.fetch(entity, bundle).then((response) => {
        const { data: d9Schema } = response;
        const schema = transformD9Schema(d9Schema);
        model.schema.set(entity, bundle, schema);
        return response;
      });

    const sendWithSubrequest = withSubrequests(model, connection);

    return {
      ...connection,
      schema: {
        /** @type {FetchSchema} */
        fetch(...args) {
          let entity; let bundle;
          const [arg1, arg2] = args;
          if (arg1 && !arg2) {
            ({ entity = arg1, bundle } = parseEntityType(arg1));
          }
          if (arg1 && arg2) {
            ({ entity = arg1, bundle = arg2 } = parseEntityType(arg2));
          }
          if (entity in entities && bundle) {
            return fetchAndSetSchemata({ entity, bundle }).then(response => ({
              data: model.schema.get(entity, bundle),
              fulfilled: [response],
              rejected: [],
            })).catch(response => ({
              data: null,
              fulfilled: [],
              rejected: [response],
            }));
          }
          const transformSchemaResults = (_, data) => (data === null
            ? model.schema.get(entity, bundle)
            : data);
          const aggregateSchemaRequests = compose$1(
            altogether(transformSchemaResults, null),
            map$5(fetchAndSetSchemata),
            !entity ? rFilter(o => o.entity in entities) : rFilter(o => o.entity === entity),
            map$5(parseEntityType),
            Object.keys,
            path$2(['data', 'links']),
          );
          return connection.request('/api/').then(aggregateSchemaRequests);
        },
      },
      ...entityMethods(({ nomenclature: { name, shortName } }) => ({
        ...connection[shortName],
        /** @type {(options: import('../fetch.js').FetchOptions) => Promise} */
        fetch: (options) => {
          const {
            filter, include, limit, sort,
          } = options;
          const validTypes = Object.keys(model.schema.get(name)).map(b => `${name}--${b}`);
          const bundleRequests = splitFilterByType(filter, validTypes).map((f) => {
            const { type, ...tFilter } = f;
            /** @type {import('../fetch.js').FetchOptions} */
            const fetchOptions = {
              ...tFilter, include, limit, sort,
            };
            const { bundle } = parseEntityType(type);
            if (name in fieldTransforms && bundle in fieldTransforms[name]) {
              fetchOptions.filterTransforms = fieldTransforms[name][bundle];
            }
            const req = connection[shortName].fetch(bundle, fetchOptions);
            return chainRequests(req, limit);
          });
          const concatBundle = (response, data) => {
            const bundle = response.flatMap(path$2(['data', 'data']));
            const included = response.flatMap(path$2(['data', 'included']));
            return data.concat(bundle).concat(included).filter(o => !!o);
          };
          return altogether(concatBundle, [], bundleRequests)
            .then(transformFetchResponse);
        },
        send(entity, options) {
          const hasSubrequest = options && is$1(Object, options.subrequest);
          if (hasSubrequest || is$1(Array, entity)) {
            return sendWithSubrequest(entity, options);
          }
          const { bundle } = parseTypeFromFields(entity);
          const data = transformLocalEntity(entity, fieldTransforms);
          return connection[shortName].send(bundle, data, options)
            .then(transformSendResponse);
        },
      }), entities),
    };
  }

  var take =

  take_1;

  function dropLast$2(n, xs) {
    return take(n < xs.length ? xs.length - n : 0, xs);
  }

  var _dropLast$1 = dropLast$2;

  var _curry2$1 =

  _curry2_1;

  var _xfBase =

  _xfBase$6;

  var XDropLast =
  /*#__PURE__*/
  function () {
    function XDropLast(n, xf) {
      this.xf = xf;
      this.pos = 0;
      this.full = false;
      this.acc = new Array(n);
    }

    XDropLast.prototype['@@transducer/init'] = _xfBase.init;

    XDropLast.prototype['@@transducer/result'] = function (result) {
      this.acc = null;
      return this.xf['@@transducer/result'](result);
    };

    XDropLast.prototype['@@transducer/step'] = function (result, input) {
      if (this.full) {
        result = this.xf['@@transducer/step'](result, this.acc[this.pos]);
      }

      this.store(input);
      return result;
    };

    XDropLast.prototype.store = function (input) {
      this.acc[this.pos] = input;
      this.pos += 1;

      if (this.pos === this.acc.length) {
        this.pos = 0;
        this.full = true;
      }
    };

    return XDropLast;
  }();

  var _xdropLast$1 =
  /*#__PURE__*/
  _curry2$1(function _xdropLast(n, xf) {
    return new XDropLast(n, xf);
  });

  var _xdropLast_1 = _xdropLast$1;

  var _curry2 =

  _curry2_1;

  var _dispatchable =

  _dispatchable_1;

  var _dropLast =

  _dropLast$1;

  var _xdropLast =

  _xdropLast_1;
  /**
   * Returns a list containing all but the last `n` elements of the given `list`.
   *
   * Acts as a transducer if a transformer is given in list position.
   *
   * @func
   * @memberOf R
   * @since v0.16.0
   * @category List
   * @sig Number -> [a] -> [a]
   * @sig Number -> String -> String
   * @param {Number} n The number of elements of `list` to skip.
   * @param {Array} list The list of elements to consider.
   * @return {Array} A copy of the list with only the first `list.length - n` elements
   * @see R.takeLast, R.drop, R.dropWhile, R.dropLastWhile
   * @example
   *
   *      R.dropLast(1, ['foo', 'bar', 'baz']); //=> ['foo', 'bar']
   *      R.dropLast(2, ['foo', 'bar', 'baz']); //=> ['foo']
   *      R.dropLast(3, ['foo', 'bar', 'baz']); //=> []
   *      R.dropLast(4, ['foo', 'bar', 'baz']); //=> []
   *      R.dropLast(3, 'ramda');               //=> 'ra'
   */


  var dropLast =
  /*#__PURE__*/
  _curry2(
  /*#__PURE__*/
  _dispatchable([], _xdropLast, _dropLast));

  var dropLast_1 = dropLast;

  var dropLast$1 = dropLast_1;

  /**
   * @typedef {import('../entities.js').Entity} Entity
   */
  /**
   * Create a farmOS entity that will validate against the schema for the
   * specified bundle (ie, the `type` prop).
   * @typedef {Function} createEntity
   * @param {Object.<String, any>|Entity} props
   * @property {String} props.type The only required prop. It must correspond to a
   * valid entity bundle (eg, 'activity') whose schema has been previously set.
   * @returns {Entity}
   */
  /**
   * @param {import('./index.js').BundleSchemata} schemata
   * @returns {createEntity}
   */
  const createEntity = (schemata, defaultOptions) => (props) => {
    const { id = v4() } = props;
    const { entity, bundle, type } = parseTypeFromFields(props);
    if (!validate(id)) { throw new Error(`Invalid ${entity} id: ${id}`); }
    const schema = schemata[entity] && schemata[entity][bundle];
    if (!schema) { throw new Error(`Cannot find a schema for the ${entity} type: ${type}.`); }
    const {
      attributes = {}, relationships = {}, meta = {}, ...rest
    } = clone$1(props);
    // Spread attr's and rel's like this so other entities can be passed as props,
    // but nesting props is still not required.
    const copyProps = { ...attributes, ...relationships, ...rest };
    const {
      created = new Date().toISOString(),
      changed = created,
      remote: {
        lastSync = null,
        url = null,
        meta: remoteMeta = null,
      } = {},
    } = meta;
    const fieldChanges = {};
    const initFields = (fieldType) => {
      const fields = {};
      listProperties(schema, fieldType).forEach((name) => {
        if (name in copyProps) {
          const changedProp = meta.fieldChanges && meta.fieldChanges[name];
          fieldChanges[name] = changedProp || changed;
          fields[name] = copyProps[name];
        } else {
          fieldChanges[name] = changed;
          fields[name] = getDefault(schema, [fieldType, name], defaultOptions);
        }
      });
      return fields;
    };
    return {
      id,
      type,
      attributes: initFields('attributes'),
      relationships: initFields('relationships'),
      meta: {
        created,
        changed,
        remote: { lastSync, url, meta: remoteMeta },
        fieldChanges,
        conflicts: [],
      },
    };
  };

  var _arity =

  _arity_1;

  var _curry1 =

  _curry1_1;

  var map =

  map_1;

  var max =

  max_1;

  var reduce =

  reduce_1;
  /**
   * Returns a function, `fn`, which encapsulates `if/else, if/else, ...` logic.
   * `R.cond` takes a list of [predicate, transformer] pairs. All of the arguments
   * to `fn` are applied to each of the predicates in turn until one returns a
   * "truthy" value, at which point `fn` returns the result of applying its
   * arguments to the corresponding transformer. If none of the predicates
   * matches, `fn` returns undefined.
   *
   * @func
   * @memberOf R
   * @since v0.6.0
   * @category Logic
   * @sig [[(*... -> Boolean),(*... -> *)]] -> (*... -> *)
   * @param {Array} pairs A list of [predicate, transformer]
   * @return {Function}
   * @see R.ifElse, R.unless, R.when
   * @example
   *
   *      const fn = R.cond([
   *        [R.equals(0),   R.always('water freezes at 0°C')],
   *        [R.equals(100), R.always('water boils at 100°C')],
   *        [R.T,           temp => 'nothing special happens at ' + temp + '°C']
   *      ]);
   *      fn(0); //=> 'water freezes at 0°C'
   *      fn(50); //=> 'nothing special happens at 50°C'
   *      fn(100); //=> 'water boils at 100°C'
   */


  var cond =
  /*#__PURE__*/
  _curry1(function cond(pairs) {
    var arity = reduce(max, 0, map(function (pair) {
      return pair[0].length;
    }, pairs));
    return _arity(arity, function () {
      var idx = 0;

      while (idx < pairs.length) {
        if (pairs[idx][0].apply(this, arguments)) {
          return pairs[idx][1].apply(this, arguments);
        }

        idx += 1;
      }
    });
  });

  var cond_1 = cond;

  var cond$1 = cond_1;

  var _curry3 =

  _curry3_1;

  var equals =

  equals_1;
  /**
   * Takes a function and two values in its domain and returns `true` if the
   * values map to the same value in the codomain; `false` otherwise.
   *
   * @func
   * @memberOf R
   * @since v0.18.0
   * @category Relation
   * @sig (a -> b) -> a -> a -> Boolean
   * @param {Function} f
   * @param {*} x
   * @param {*} y
   * @return {Boolean}
   * @example
   *
   *      R.eqBy(Math.abs, 5, -5); //=> true
   */


  var eqBy =
  /*#__PURE__*/
  _curry3(function eqBy(f, x, y) {
    return equals(f(x), f(y));
  });

  var eqBy_1 = eqBy;

  var eqBy$1 = eqBy_1;

  // Helpers for determining if a set of fields are equivalent. Attributes are
  // fairly straightforward, but relationships need to be compared strictly by
  // their id(s), b/c JSON:API gives a lot of leeway for how these references
  // can be ordered and structured.
  const setOfIds = compose$1(
    array => new Set(array),
    map$5(prop$2('id')),
  );
  const relsTransform = cond$1([
    [isNil$2, identity$1],
    [Array.isArray, setOfIds],
    [has$1('id'), prop$2('id')],
  ]);
  const eqFields = fieldType =>
    (fieldType === 'relationships' ? eqBy$1(relsTransform) : equals$5);

  /**
   * @typedef {import('../entities.js').Entity} Entity
   */
  /**
   * Merge a local copy of a farmOS entity with an incoming remote copy. They must
   * share the same id (UUID v4) and type (aka, bundle).
   * @typedef {Function} mergeEntity
   * @param {Entity} [local] If the local is nullish, merging will dispatch to the
   * create method instead, creating a new local copy of the remote entity.
   * @param {Entity} [remote] If the remote is nullish, a clone of the local will be returned.
   * @returns {Entity}
   */
  /**
   * @param {import('./index.js').BundleSchemata} schemata
   * @returns {mergeEntity}
   */
  const mergeEntity = (schemata) => (local, remote) => {
    if (!remote) return clone$1(local);
    const now = new Date().toISOString();
    if (!local) {
      // A nullish local value represents the first time a remotely generated
      // entity was fetched, so all changes are considered synced with the remote.
      const resetLastSync = evolve$1({ meta: { remote: { lastSync: () => now } } });
      return createEntity(schemata)(resetLastSync(remote));
    }
    const { id } = local;
    const { entity, bundle, type } = parseTypeFromFields(local);
    if (!validate(id)) { throw new Error(`Invalid ${entity} id: ${id}`); }
    const schema = schemata[entity] && schemata[entity][bundle];
    if (!schema) {
      throw new Error(`Cannot find a schema for the ${entity} type: ${type}.`);
    }
    const localName = local.attributes && `"${local.attributes.name || ''}" `;
    if (id !== remote.id) {
      throw new Error(`Cannot merge remote ${entity} with UUID ${remote.id} `
        + `and local ${entity} ${localName}with UUID ${id}.`);
    }
    if (local.type !== remote.type) {
      throw new Error(`Cannot merge remote ${entity} of type ${remote.type} `
        + `and local ${entity} ${localName}of type ${local.type}.`);
    }
    if (local.meta.conflicts.length > 0) {
      throw new Error(`Cannot merge local ${entity} ${localName}`
        + 'while it still has unresolved conflicts.');
    }

    // Establish a consistent value for the current time.
    // const now = new Date().toISOString();

    // Deep clone the local & destructure its metadata for internal reference.
    const localCopy = clone$1(local);
    const {
      meta: {
        fieldChanges: localChanges,
        changed: localChanged = now,
        remote: { lastSync: localLastSync = null } = {},
      },
    } = localCopy;

    // Deep clone the remote & destructure its metadata for internal reference.
    const remoteCopy = clone$1(remote);
    const {
      meta: {
        fieldChanges: remoteChanges,
        changed: remoteChanged = now,
        remote: { lastSync: remoteLastSync = null } = {},
      },
    } = remoteCopy;

    // These variables are for storing the values that will ultimately be returned
    // as metadata. They are all considered mutable within this function scope and
    // will be reassigned or appeneded to during the iterations of mergeFields, or
    // afterwards in the case of lastSync.
    let changed = localChanged; let lastSync = localLastSync;
    const fieldChanges = {}; const conflicts = [];

    const mergeFields = (fieldType) => {
      const checkEquality = eqFields(fieldType);
      const { [fieldType]: localFields } = localCopy;
      const { [fieldType]: remoteFields } = remoteCopy;
      // Spread localFields so lf.data and lf.changed aren't mutated when fields is.
      const fields = { ...localFields };
      // This loop comprises the main algorithm for merging changes to concurrent
      // versions of the same entity that may exist on separate systems. It uses a
      // "Last Write Wins" (LWW) strategy, which applies to each field individually.
      listProperties(schema, fieldType).forEach((name) => {
        const lf = { // localField shorthand
          data: localFields[name],
          changed: localChanges[name] || localChanged,
        };
        const rf = { // remoteField shorthand
          data: remoteFields[name],
          changed: remoteChanges[name] || remoteChanged,
        };
        const localFieldHasBeenSent = !!localLastSync && localLastSync > lf.changed;
        // Use the local changed value as our default.
        fieldChanges[name] = lf.changed;
        // If the remote field changed more recently than the local field, and the
        // local was synced more recently than it changed, apply the remote changes.
        if (rf.changed > lf.changed && localFieldHasBeenSent) {
          fields[name] = rf.data;
          fieldChanges[name] = rf.changed;
          // Also update the global changed value if the remote field changed more recently.
          if (rf.changed > localChanged) ({ changed } = rf);
        }
        // If the remote field changed more recently than the local field, and the
        // local entity has NOT been synced since then, there may be a conflict.
        if (rf.changed > lf.changed && !localFieldHasBeenSent) {
          // Run one last check to make sure the data isn't actually the same. If
          // they are, there's no conflict, but apply the remote changed timestamps.
          if (checkEquality(lf.data, rf.data)) {
            fieldChanges[name] = rf.changed;
            if (rf.changed > localChanged) ({ changed } = rf);
          } else {
            // Otherwise keep the local values, but add the remote changes to the
            // list of conflicts.
            conflicts.push({
              fieldType,
              field: name,
              changed: rf.changed,
              data: rf.data,
            });
          }
        }
        // In all other cases, the local values will be retained.
      });
      return fields;
    };

    const attributes = mergeFields('attributes');
    const relationships = mergeFields('relationships');

    // These tests will set the lastSync value to the current timestamp if any one
    // of the following criteria can be met: 1) a remote entity is being merged
    // with a local entity whose changes have already been sent to that remote,
    // 2) the merge occurs after the very first time a locally generated entity
    // was sent to the remote system, 3) all changes from the remote have been
    // fetched since the most recent local change. Otherwise, the local lastSync
    // value will be retained.
    const localChangesHaveBeenSent = !!localLastSync && localLastSync >= localChanged;
    const remoteIsInitialSendResponse = !localLastSync && !!remoteLastSync;
    const remoteChangesHaveBeenFetched = !!remoteLastSync && remoteLastSync >= localChanged;
    const syncHasCompleted = localChangesHaveBeenSent
      || remoteIsInitialSendResponse
      || remoteChangesHaveBeenFetched;
    if (syncHasCompleted) lastSync = now;

    return {
      id,
      type,
      attributes,
      relationships,
      meta: {
        ...localCopy.meta,
        changed,
        fieldChanges,
        conflicts,
        remote: {
          ...remoteCopy.meta.remote,
          lastSync,
        },
      },
    };
  };

  /**
   * @typedef {import('../entities.js').Entity} Entity
   */
  /**
   * Update a farmOS entity.
   * @typedef {Function} updateEntity
   * @param {Entity} entity
   * @param {Object.<String, any>} props
   * @returns {Entity}
   */
  /**
   * @param {import('./index.js').BundleSchemata} schemata
   * @returns {updateEntity}
   */
  const updateEntity = (schemata) => (entity, props) => {
    const { id } = entity;
    const { entity: entName, bundle, type } = parseTypeFromFields(entity);
    if (!validate(id)) { throw new Error(`Invalid ${entName} id: ${id}`); }
    const schema = schemata[entName] && schemata[entName][bundle];
    if (!schema) { throw new Error(`Cannot find a schema for the ${entName} type: ${type}.`); }

    const now = new Date().toISOString();
    const entityCopy = clone$1(entity);
    const propsCopy = clone$1(props);
    const { meta = {} } = entityCopy;
    let { changed = now } = meta;
    const {
      conflicts = [], created = now, fieldChanges = {}, remote = {},
    } = meta;
    const { lastSync = null, url = null, meta: remoteMeta = null } = remote;
    const updateFields = (fieldType) => {
      const fields = { ...entityCopy[fieldType] };
      listProperties(schema, fieldType).forEach((name) => {
        if (name in propsCopy) {
          fields[name] = propsCopy[name];
          fieldChanges[name] = now;
          changed = now;
        }
      });
      return fields;
    };

    const attributes = updateFields('attributes');
    const relationships = updateFields('relationships');

    return {
      id,
      type,
      attributes,
      relationships,
      meta: {
        changed,
        conflicts,
        created,
        fieldChanges,
        remote: {
          lastSync,
          meta: remoteMeta,
          url,
        },
      },
    };
  };

  /**
   * JSON Schema for defining the entities supported by a farmOS instance.
   * @see {@link https://json-schema.org/understanding-json-schema/index.html}
   * @typedef {import('../json-schema/reference').JsonSchema} JsonSchema
   */
  /**
   * JSON Schema Dereferenced: A JSON Schema, but w/o any $ref keywords. As such,
   * it may contain circular references that cannot be serialized.
   * @typedef {import('../json-schema/reference').JsonSchemaDereferenced} JsonSchemaDereferenced
   */
  /**
   * An object containing the schemata for the bundles of a farmOS entity, with
   * the bundle name as key and its corresponding schema as its value.
   * @typedef {Object.<string, JsonSchema>} BundleSchemata
   */
  /**
   * An object containing the schemata for the bundles of a farmOS entity, with
   * the bundle name as key and its corresponding schema as its value.
   * @typedef {Object.<string, BundleSchemata>} EntitySchemata
   */

  /** The methods for writing to local copies of farmOS data structures, such as
   * assets, logs, etc.
   * @typedef {Object} ModelEntityMethods
   * @property {import('./create.js').createEntity} create
   * @property {import('./update.js').updateEntity} update
   * @property {import('./merge.js').mergeEntity} merge
   */
  /** A collection of functions for working with farmOS data structures, their
   * associated metadata and schemata.
   * @typedef {Object} FarmModel
   * @property {Object} schema
   * @property {Function} schema.get
   * @property {Function} schema.set
   * @property {Function} schema.on
   * @property {Object} meta
   * @property {Function} meta.isUnsynced
   * @property {ModelEntityMethods} asset
   * @property {ModelEntityMethods} log
   * @property {ModelEntityMethods} plan
   * @property {ModelEntityMethods} quantity
   * @property {ModelEntityMethods} term
   * @property {ModelEntityMethods} user
   */

  /**
   * @typedef {import('../entities.js').EntityConfig} EntityConfig
   */
  /**
   * Create a farm model for generating and manipulating farmOS data structures.
   * @typedef {Function} model
   * @param {Object} options
   * @property {EntitySchemata} [options.schemata]
   * @property {Object<String, EntityConfig>} [options.entities=defaultEntities]
   * @returns {FarmModel}
   */
  function model(options = {}) {
    const { entities = defaultEntities } = options;
    const schemata = map$5(() => ({}), entities);

    const observers = {
      schema: {
        set: createObserver(),
      },
    };

    /**
     * Retrieve all schemata that have been previously set, or the schemata of a
     * particular entity, or one bundle's schema, if specified.
     * @param {...String} args
     * @returns {EntitySchemata|BundleSchemata|JsonSchemaDereferenced}
     */
    function getSchemata(...args) {
      let entity = args[0];
      let bundle = args[1];
      if (args.length === 2 && typeof args[1] === 'string') {
        const parsed = parseEntityType(args[1]);
        if (parsed.type) ({ bundle } = parsed);
      }
      if (args.length === 1 && typeof args[0] === 'string') {
        const parsed = parseEntityType(args[0]);
        if (parsed.type) ({ entity, bundle } = parsed);
      }
      if (schemata[entity] && schemata[entity][bundle]) {
        return clone$1(schemata[entity][bundle]);
      }
      if (schemata[entity]) {
        return clone$1(schemata[entity]);
      }
      return clone$1(schemata);
    }

    /**
     * Load all schemata, the schemata of a particular entity, or one bundle's
     * schema, if specified.
     * @param {...String|EntitySchemata|BundleSchemata|JsonSchema} args
     * @void
     */
    function setSchemata(...args) {
      if (args.length === 0) {
        throw new Error('At least one valid argument is required for setting '
          + 'farm schemata but none was provided.');
      }
      if (args.length === 1 && isObject(args[0])) {
        const [entitySchemata] = args;
        Object.entries(entitySchemata).forEach(([entity, bundleSchemata]) => {
          if (entity in schemata) {
            setSchemata(entity, bundleSchemata);
          }
        });
        return clone$1(schemata);
      }
      if (args.length === 2 && isObject(args[1])) {
        const type0 = parseEntityType(args[0]);
        if (type0.entity in schemata && type0.bundle) {
          const { entity, bundle } = type0;
          const [, schema] = args;
          setSchemata(entity, bundle, schema);
          return clone$1(schemata)[entity][bundle];
        }
        const [entity, bundleSchemata] = args;
        Object.entries(bundleSchemata).forEach(([type1, schema]) => {
          const { bundle = type1 } = parseEntityType(type1);
          setSchemata(entity, bundle, schema);
        });
        return clone$1(schemata)[entity];
      }
      if (args.length === 3
        && args[0] in schemata
        && typeof args[1] === 'string'
        && isObject(args[2])) {
        const [entity, type, schema] = args;
        const { bundle = type } = parseEntityType(type);
        schemata[entity][bundle] = dereference(schema);
        return clone$1(schemata)[entity][bundle];
      }
      const description = 'One or more invalid arguments for setting farm schemata';
      throw new Error(`${description}: ${args.join(', ')}.`);
    }

    if (options.schemata) setSchemata(options.schemata);

    const addListeners = namespace => (name, callback) => {
      if (name in observers[namespace]) {
        return observers[namespace][name].subscribe(callback);
      }
      throw new Error(`Invalid method name for ${namespace} listener: ${name}`);
    };

    return {
      schema: {
        get: getSchemata,
        /** @param {...String|EntitySchemata|BundleSchemata|JsonSchema} args */
        set(...args) {
          setSchemata(...args);
          const getterArgs = dropLast$1(1, args);
          observers.schema.set.next(getSchemata(...getterArgs));
        },
        on: addListeners('schema'),
      },
      meta: {
        isUnsynced(entity) {
          const { changed, remote: { lastSync = null } = {} } = entity.meta;
          return lastSync === null || changed > lastSync;
        },
      },
      ...entityMethods(({ defaultOptions }) => ({
        create: createEntity(schemata, defaultOptions),
        merge: mergeEntity(schemata),
        update: updateEntity(schemata),
      }), entities),
    };
  }

  /** The methods for writing to local copies of farmOS data structures, such as
   * assets, logs, etc, and for transmitting those entities to a farmOS server.
   * @typedef {Object} FarmEntityMethods
   * @property {import('./model/create.js').createEntity} create
   * @property {import('./model/update.js').updateEntity} update
   * @property {import('./model/merge.js').mergeEntity} merge
   * @property {import('./client/fetch.js').fetchEntity} [fetch]
   * @property {import('./client/send.js').sendEntity} [send]
   * @property {import('./client/delete.js').deleteEntity} [delete]
   */

  /** A collection of functions for working with farmOS data structures, their
   * associated metadata and schemata, and for interacting with farmOS servers.
   * @typedef {Object} FarmObject
   * @property {Object} schema
   * @property {Function} schema.get
   * @property {Function} schema.set
   * @property {Function} schema.on
   * @property {Function} [schema.fetch]
   * @property {Object} meta
   * @property {Function} meta.isUnsynced
   * @property {Object} remote
   * @property {import('axios').AxiosInstance} remote.request
   * @property {Function} [remote.info]
   * @property {Function} [remote.authorize]
   * @property {Function} [remote.getToken]
   * @property {FarmEntityMethods} asset
   * @property {FarmEntityMethods} log
   * @property {FarmEntityMethods} plan
   * @property {FarmEntityMethods} quantity
   * @property {FarmEntityMethods} term
   * @property {FarmEntityMethods} user
   */

  /**
   * To enable support for each entity type, its config object must be provided.
   * @typedef {import('./entities.js').EntityConfig} EntityConfig
   */

  /** The main farmOS factory function for creating a new farm object.
   * @typedef {Function} farmOS
   * @param {Object} farmConfig
   * @property {import('./model/index.js').EntitySchemata} [config.schemata]
   * @property {Object} [config.remote]
   * @property {import('./client/index.js').client} [config.remote.adapter=d9JsonApiAdapter]
   * @property {Object.<String, EntityConfig>} [config.entities=defaultEntities]
   * @returns {FarmObject}
   */
  function farmOS(farmConfig) {
    const { schemata, remote, entities = defaultEntities } = farmConfig;
    const shortNames = Object.values(entities).map(e => e.nomenclature.shortName);

    const farm = /** @type {FarmObject} */ (model({ schemata, entities }));

    const addRemote = (remoteConfig = {}) => {
      const { adapter: adapter$1 = adapter, ...options } = remoteConfig;
      const connection = adapter$1(farm, options);
      farm.schema.fetch = connection.schema.fetch;
      shortNames.forEach((shortName) => {
        farm[shortName].fetch = connection[shortName].fetch;
        farm[shortName].send = connection[shortName].send;
        farm[shortName].delete = connection[shortName].delete;
      });
      farm.remote = { ...omit$1(shortNames, connection), add: addRemote };
    };
    addRemote({ ...remote, entities });

    return farm;
  }

  exports.client = client;
  exports["default"] = farmOS;
  exports.entities = defaultEntities;
  exports.model = model;
  exports.parseFilter = parseFilter;
  exports.splitFilterByType = splitFilterByType;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
